import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Action = {
  __typename?: 'Action';
  _count: ActionCount;
  analysisSchema: AnalysisSchema;
  analysisSchemaId: Scalars['Int'];
  creator: User;
  filePrefix: Scalars['String'];
  fileSuffix: Scalars['String'];
  handlerCode: Scalars['String'];
  id: Scalars['Int'];
  invocations?: Maybe<Array<ActionInvocation>>;
  name: Scalars['String'];
  s3Bucket: S3Bucket;
  s3BucketId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ActionCount = {
  __typename?: 'ActionCount';
  invocations: Scalars['Int'];
};

export type ActionCreateManyAnalysisSchemaInput = {
  filePrefix?: InputMaybe<Scalars['String']>;
  fileSuffix?: InputMaybe<Scalars['String']>;
  handlerCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  s3BucketId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ActionCreateManyAnalysisSchemaInputEnvelope = {
  data: Array<ActionCreateManyAnalysisSchemaInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ActionCreateManyCreatorInput = {
  analysisSchemaId: Scalars['Int'];
  filePrefix?: InputMaybe<Scalars['String']>;
  fileSuffix?: InputMaybe<Scalars['String']>;
  handlerCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  s3BucketId: Scalars['Int'];
};

export type ActionCreateManyCreatorInputEnvelope = {
  data: Array<ActionCreateManyCreatorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ActionCreateManyS3BucketInput = {
  analysisSchemaId: Scalars['Int'];
  filePrefix?: InputMaybe<Scalars['String']>;
  fileSuffix?: InputMaybe<Scalars['String']>;
  handlerCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  userId: Scalars['Int'];
};

export type ActionCreateManyS3BucketInputEnvelope = {
  data: Array<ActionCreateManyS3BucketInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ActionCreateNestedManyWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<Array<ActionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionCreateOrConnectWithoutAnalysisSchemaInput>>;
  create?: InputMaybe<Array<ActionCreateWithoutAnalysisSchemaInput>>;
  createMany?: InputMaybe<ActionCreateManyAnalysisSchemaInputEnvelope>;
};

export type ActionCreateNestedManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<ActionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<ActionCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<ActionCreateManyCreatorInputEnvelope>;
};

export type ActionCreateNestedManyWithoutS3BucketInput = {
  connect?: InputMaybe<Array<ActionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionCreateOrConnectWithoutS3BucketInput>>;
  create?: InputMaybe<Array<ActionCreateWithoutS3BucketInput>>;
  createMany?: InputMaybe<ActionCreateManyS3BucketInputEnvelope>;
};

export type ActionCreateOrConnectWithoutAnalysisSchemaInput = {
  create: ActionCreateWithoutAnalysisSchemaInput;
  where: ActionWhereUniqueInput;
};

export type ActionCreateOrConnectWithoutCreatorInput = {
  create: ActionCreateWithoutCreatorInput;
  where: ActionWhereUniqueInput;
};

export type ActionCreateOrConnectWithoutS3BucketInput = {
  create: ActionCreateWithoutS3BucketInput;
  where: ActionWhereUniqueInput;
};

export type ActionCreateWithoutAnalysisSchemaInput = {
  creator: UserCreateNestedOneWithoutActionsInput;
  filePrefix?: InputMaybe<Scalars['String']>;
  fileSuffix?: InputMaybe<Scalars['String']>;
  handlerCode?: InputMaybe<Scalars['String']>;
  invocations?: InputMaybe<ActionInvocationCreateNestedManyWithoutActionInput>;
  name: Scalars['String'];
  s3Bucket: S3BucketCreateNestedOneWithoutActionsInput;
};

export type ActionCreateWithoutCreatorInput = {
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutActionsInput;
  filePrefix?: InputMaybe<Scalars['String']>;
  fileSuffix?: InputMaybe<Scalars['String']>;
  handlerCode?: InputMaybe<Scalars['String']>;
  invocations?: InputMaybe<ActionInvocationCreateNestedManyWithoutActionInput>;
  name: Scalars['String'];
  s3Bucket: S3BucketCreateNestedOneWithoutActionsInput;
};

export type ActionCreateWithoutS3BucketInput = {
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutActionsInput;
  creator: UserCreateNestedOneWithoutActionsInput;
  filePrefix?: InputMaybe<Scalars['String']>;
  fileSuffix?: InputMaybe<Scalars['String']>;
  handlerCode?: InputMaybe<Scalars['String']>;
  invocations?: InputMaybe<ActionInvocationCreateNestedManyWithoutActionInput>;
  name: Scalars['String'];
};

export type ActionInvocation = {
  __typename?: 'ActionInvocation';
  action: Action;
  actionId: Scalars['Int'];
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  inputData: Scalars['JSON'];
  logs: Scalars['String'];
  status: ActionInvocationStatus;
};

export type ActionInvocationCreateManyActionInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  logs?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ActionInvocationStatus>;
};

export type ActionInvocationCreateManyActionInputEnvelope = {
  data: Array<ActionInvocationCreateManyActionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ActionInvocationCreateNestedManyWithoutActionInput = {
  connect?: InputMaybe<Array<ActionInvocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionInvocationCreateOrConnectWithoutActionInput>>;
  create?: InputMaybe<Array<ActionInvocationCreateWithoutActionInput>>;
  createMany?: InputMaybe<ActionInvocationCreateManyActionInputEnvelope>;
};

export type ActionInvocationCreateOrConnectWithoutActionInput = {
  create: ActionInvocationCreateWithoutActionInput;
  where: ActionInvocationWhereUniqueInput;
};

export type ActionInvocationCreateWithoutActionInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  logs?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ActionInvocationStatus>;
};

export type ActionInvocationScalarWhereInput = {
  AND?: InputMaybe<Array<ActionInvocationScalarWhereInput>>;
  NOT?: InputMaybe<Array<ActionInvocationScalarWhereInput>>;
  OR?: InputMaybe<Array<ActionInvocationScalarWhereInput>>;
  actionId?: InputMaybe<IntFilter>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  inputData?: InputMaybe<JsonFilter>;
  logs?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumActionInvocationStatusFilter>;
};

export enum ActionInvocationStatus {
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

export type ActionInvocationUpdateManyMutationInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  inputData?: InputMaybe<Scalars['JSON']>;
  logs?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionInvocationStatusFieldUpdateOperationsInput>;
};

export type ActionInvocationUpdateManyWithWhereWithoutActionInput = {
  data: ActionInvocationUpdateManyMutationInput;
  where: ActionInvocationScalarWhereInput;
};

export type ActionInvocationUpdateManyWithoutActionInput = {
  connect?: InputMaybe<Array<ActionInvocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionInvocationCreateOrConnectWithoutActionInput>>;
  create?: InputMaybe<Array<ActionInvocationCreateWithoutActionInput>>;
  createMany?: InputMaybe<ActionInvocationCreateManyActionInputEnvelope>;
  delete?: InputMaybe<Array<ActionInvocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActionInvocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActionInvocationWhereUniqueInput>>;
  set?: InputMaybe<Array<ActionInvocationWhereUniqueInput>>;
  update?: InputMaybe<Array<ActionInvocationUpdateWithWhereUniqueWithoutActionInput>>;
  updateMany?: InputMaybe<Array<ActionInvocationUpdateManyWithWhereWithoutActionInput>>;
  upsert?: InputMaybe<Array<ActionInvocationUpsertWithWhereUniqueWithoutActionInput>>;
};

export type ActionInvocationUpdateWithWhereUniqueWithoutActionInput = {
  data: ActionInvocationUpdateWithoutActionInput;
  where: ActionInvocationWhereUniqueInput;
};

export type ActionInvocationUpdateWithoutActionInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  inputData?: InputMaybe<Scalars['JSON']>;
  logs?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumActionInvocationStatusFieldUpdateOperationsInput>;
};

export type ActionInvocationUpsertWithWhereUniqueWithoutActionInput = {
  create: ActionInvocationCreateWithoutActionInput;
  update: ActionInvocationUpdateWithoutActionInput;
  where: ActionInvocationWhereUniqueInput;
};

export type ActionInvocationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ActionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ActionScalarWhereInput = {
  AND?: InputMaybe<Array<ActionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ActionScalarWhereInput>>;
  OR?: InputMaybe<Array<ActionScalarWhereInput>>;
  analysisSchemaId?: InputMaybe<IntFilter>;
  filePrefix?: InputMaybe<StringFilter>;
  fileSuffix?: InputMaybe<StringFilter>;
  handlerCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  s3BucketId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type ActionUpdateManyMutationInput = {
  filePrefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileSuffix?: InputMaybe<StringFieldUpdateOperationsInput>;
  handlerCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionUpdateManyWithWhereWithoutAnalysisSchemaInput = {
  data: ActionUpdateManyMutationInput;
  where: ActionScalarWhereInput;
};

export type ActionUpdateManyWithWhereWithoutCreatorInput = {
  data: ActionUpdateManyMutationInput;
  where: ActionScalarWhereInput;
};

export type ActionUpdateManyWithWhereWithoutS3BucketInput = {
  data: ActionUpdateManyMutationInput;
  where: ActionScalarWhereInput;
};

export type ActionUpdateManyWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<Array<ActionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionCreateOrConnectWithoutAnalysisSchemaInput>>;
  create?: InputMaybe<Array<ActionCreateWithoutAnalysisSchemaInput>>;
  createMany?: InputMaybe<ActionCreateManyAnalysisSchemaInputEnvelope>;
  delete?: InputMaybe<Array<ActionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActionWhereUniqueInput>>;
  set?: InputMaybe<Array<ActionWhereUniqueInput>>;
  update?: InputMaybe<Array<ActionUpdateWithWhereUniqueWithoutAnalysisSchemaInput>>;
  updateMany?: InputMaybe<Array<ActionUpdateManyWithWhereWithoutAnalysisSchemaInput>>;
  upsert?: InputMaybe<Array<ActionUpsertWithWhereUniqueWithoutAnalysisSchemaInput>>;
};

export type ActionUpdateManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<ActionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<ActionCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<ActionCreateManyCreatorInputEnvelope>;
  delete?: InputMaybe<Array<ActionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActionWhereUniqueInput>>;
  set?: InputMaybe<Array<ActionWhereUniqueInput>>;
  update?: InputMaybe<Array<ActionUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: InputMaybe<Array<ActionUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: InputMaybe<Array<ActionUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type ActionUpdateManyWithoutS3BucketInput = {
  connect?: InputMaybe<Array<ActionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ActionCreateOrConnectWithoutS3BucketInput>>;
  create?: InputMaybe<Array<ActionCreateWithoutS3BucketInput>>;
  createMany?: InputMaybe<ActionCreateManyS3BucketInputEnvelope>;
  delete?: InputMaybe<Array<ActionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ActionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ActionWhereUniqueInput>>;
  set?: InputMaybe<Array<ActionWhereUniqueInput>>;
  update?: InputMaybe<Array<ActionUpdateWithWhereUniqueWithoutS3BucketInput>>;
  updateMany?: InputMaybe<Array<ActionUpdateManyWithWhereWithoutS3BucketInput>>;
  upsert?: InputMaybe<Array<ActionUpsertWithWhereUniqueWithoutS3BucketInput>>;
};

export type ActionUpdateWithWhereUniqueWithoutAnalysisSchemaInput = {
  data: ActionUpdateWithoutAnalysisSchemaInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpdateWithWhereUniqueWithoutCreatorInput = {
  data: ActionUpdateWithoutCreatorInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpdateWithWhereUniqueWithoutS3BucketInput = {
  data: ActionUpdateWithoutS3BucketInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpdateWithoutAnalysisSchemaInput = {
  creator?: InputMaybe<UserUpdateOneRequiredWithoutActionsInput>;
  filePrefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileSuffix?: InputMaybe<StringFieldUpdateOperationsInput>;
  handlerCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  invocations?: InputMaybe<ActionInvocationUpdateManyWithoutActionInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  s3Bucket?: InputMaybe<S3BucketUpdateOneRequiredWithoutActionsInput>;
};

export type ActionUpdateWithoutCreatorInput = {
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutActionsInput>;
  filePrefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileSuffix?: InputMaybe<StringFieldUpdateOperationsInput>;
  handlerCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  invocations?: InputMaybe<ActionInvocationUpdateManyWithoutActionInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  s3Bucket?: InputMaybe<S3BucketUpdateOneRequiredWithoutActionsInput>;
};

export type ActionUpdateWithoutS3BucketInput = {
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutActionsInput>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutActionsInput>;
  filePrefix?: InputMaybe<StringFieldUpdateOperationsInput>;
  fileSuffix?: InputMaybe<StringFieldUpdateOperationsInput>;
  handlerCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  invocations?: InputMaybe<ActionInvocationUpdateManyWithoutActionInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ActionUpsertWithWhereUniqueWithoutAnalysisSchemaInput = {
  create: ActionCreateWithoutAnalysisSchemaInput;
  update: ActionUpdateWithoutAnalysisSchemaInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpsertWithWhereUniqueWithoutCreatorInput = {
  create: ActionCreateWithoutCreatorInput;
  update: ActionUpdateWithoutCreatorInput;
  where: ActionWhereUniqueInput;
};

export type ActionUpsertWithWhereUniqueWithoutS3BucketInput = {
  create: ActionCreateWithoutS3BucketInput;
  update: ActionUpdateWithoutS3BucketInput;
  where: ActionWhereUniqueInput;
};

export type ActionUserActionUniqueCompoundUniqueInput = {
  name: Scalars['String'];
  userId: Scalars['Int'];
};

export type ActionWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  userActionUnique?: InputMaybe<ActionUserActionUniqueCompoundUniqueInput>;
};

export type AddLabMemberResponse = {
  __typename?: 'AddLabMemberResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Analysis = {
  __typename?: 'Analysis';
  AnalysisValue?: Maybe<Array<AnalysisValue>>;
  _count: AnalysisCount;
  analysisSchema: AnalysisSchema;
  analysisSchemaId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  creator: User;
  creatorId: Scalars['Int'];
  endedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  inputs?: Maybe<Array<AnalysisInput>>;
  logs: Scalars['String'];
  name: Scalars['String'];
  outputs?: Maybe<Array<AnalysisOutput>>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: AnalysisStatus;
  wantsNotification: Scalars['Boolean'];
};

export type AnalysisAnalysisCreatorNameUniqueCompoundUniqueInput = {
  creatorId: Scalars['Int'];
  name: Scalars['String'];
};

export type AnalysisCount = {
  __typename?: 'AnalysisCount';
  AnalysisValue: Scalars['Int'];
  inputs: Scalars['Int'];
  outputs: Scalars['Int'];
};

export type AnalysisCreateManyAnalysisSchemaInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creatorId: Scalars['Int'];
  endedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  logs?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  startedAt?: InputMaybe<Scalars['DateTime']>;
  status: AnalysisStatus;
  wantsNotification?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisCreateManyAnalysisSchemaInputEnvelope = {
  data: Array<AnalysisCreateManyAnalysisSchemaInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisCreateManyCreatorInput = {
  analysisSchemaId: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  endedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  logs?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  startedAt?: InputMaybe<Scalars['DateTime']>;
  status: AnalysisStatus;
  wantsNotification?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisCreateManyCreatorInputEnvelope = {
  data: Array<AnalysisCreateManyCreatorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisCreateNestedManyWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisCreateOrConnectWithoutAnalysisSchemaInput>>;
  create?: InputMaybe<Array<AnalysisCreateWithoutAnalysisSchemaInput>>;
  createMany?: InputMaybe<AnalysisCreateManyAnalysisSchemaInputEnvelope>;
};

export type AnalysisCreateNestedManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<AnalysisCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<AnalysisCreateManyCreatorInputEnvelope>;
};

export type AnalysisCreateNestedOneWithoutAnalysisValueInput = {
  connect?: InputMaybe<AnalysisWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisCreateOrConnectWithoutAnalysisValueInput>;
  create?: InputMaybe<AnalysisCreateWithoutAnalysisValueInput>;
};

export type AnalysisCreateNestedOneWithoutInputsInput = {
  connect?: InputMaybe<AnalysisWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisCreateOrConnectWithoutInputsInput>;
  create?: InputMaybe<AnalysisCreateWithoutInputsInput>;
};

export type AnalysisCreateNestedOneWithoutOutputsInput = {
  connect?: InputMaybe<AnalysisWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisCreateOrConnectWithoutOutputsInput>;
  create?: InputMaybe<AnalysisCreateWithoutOutputsInput>;
};

export type AnalysisCreateOrConnectWithoutAnalysisSchemaInput = {
  create: AnalysisCreateWithoutAnalysisSchemaInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisCreateOrConnectWithoutAnalysisValueInput = {
  create: AnalysisCreateWithoutAnalysisValueInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisCreateOrConnectWithoutCreatorInput = {
  create: AnalysisCreateWithoutCreatorInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisCreateOrConnectWithoutInputsInput = {
  create: AnalysisCreateWithoutInputsInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisCreateOrConnectWithoutOutputsInput = {
  create: AnalysisCreateWithoutOutputsInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisCreateWithoutAnalysisSchemaInput = {
  AnalysisValue?: InputMaybe<AnalysisValueCreateNestedManyWithoutAnalysisInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserCreateNestedOneWithoutAnalysesInput;
  endedAt?: InputMaybe<Scalars['DateTime']>;
  inputs?: InputMaybe<AnalysisInputCreateNestedManyWithoutAnalysisInput>;
  logs?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  outputs?: InputMaybe<AnalysisOutputCreateNestedManyWithoutAnalysisInput>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  status: AnalysisStatus;
  wantsNotification?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisCreateWithoutAnalysisValueInput = {
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutAnalysisInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserCreateNestedOneWithoutAnalysesInput;
  endedAt?: InputMaybe<Scalars['DateTime']>;
  inputs?: InputMaybe<AnalysisInputCreateNestedManyWithoutAnalysisInput>;
  logs?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  outputs?: InputMaybe<AnalysisOutputCreateNestedManyWithoutAnalysisInput>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  status: AnalysisStatus;
  wantsNotification?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisCreateWithoutCreatorInput = {
  AnalysisValue?: InputMaybe<AnalysisValueCreateNestedManyWithoutAnalysisInput>;
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutAnalysisInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  endedAt?: InputMaybe<Scalars['DateTime']>;
  inputs?: InputMaybe<AnalysisInputCreateNestedManyWithoutAnalysisInput>;
  logs?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  outputs?: InputMaybe<AnalysisOutputCreateNestedManyWithoutAnalysisInput>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  status: AnalysisStatus;
  wantsNotification?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisCreateWithoutInputsInput = {
  AnalysisValue?: InputMaybe<AnalysisValueCreateNestedManyWithoutAnalysisInput>;
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutAnalysisInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserCreateNestedOneWithoutAnalysesInput;
  endedAt?: InputMaybe<Scalars['DateTime']>;
  logs?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  outputs?: InputMaybe<AnalysisOutputCreateNestedManyWithoutAnalysisInput>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  status: AnalysisStatus;
  wantsNotification?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisCreateWithoutOutputsInput = {
  AnalysisValue?: InputMaybe<AnalysisValueCreateNestedManyWithoutAnalysisInput>;
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutAnalysisInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserCreateNestedOneWithoutAnalysesInput;
  endedAt?: InputMaybe<Scalars['DateTime']>;
  inputs?: InputMaybe<AnalysisInputCreateNestedManyWithoutAnalysisInput>;
  logs?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  startedAt?: InputMaybe<Scalars['DateTime']>;
  status: AnalysisStatus;
  wantsNotification?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisDescription = {
  __typename?: 'AnalysisDescription';
  analysisSchema: AnalysisSchema;
  analysisSchemaId: Scalars['Int'];
  id: Scalars['Int'];
  long: Scalars['String'];
  short: Scalars['String'];
};

export type AnalysisDescriptionCreateNestedOneWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<AnalysisDescriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisDescriptionCreateOrConnectWithoutAnalysisSchemaInput>;
  create?: InputMaybe<AnalysisDescriptionCreateWithoutAnalysisSchemaInput>;
};

export type AnalysisDescriptionCreateOrConnectWithoutAnalysisSchemaInput = {
  create: AnalysisDescriptionCreateWithoutAnalysisSchemaInput;
  where: AnalysisDescriptionWhereUniqueInput;
};

export type AnalysisDescriptionCreateWithoutAnalysisSchemaInput = {
  long: Scalars['String'];
  short: Scalars['String'];
};

export type AnalysisDescriptionOrderByWithRelationInput = {
  analysisSchema?: InputMaybe<AnalysisSchemaOrderByWithRelationInput>;
  analysisSchemaId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  long?: InputMaybe<SortOrder>;
  short?: InputMaybe<SortOrder>;
};

export type AnalysisDescriptionUpdateOneWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<AnalysisDescriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisDescriptionCreateOrConnectWithoutAnalysisSchemaInput>;
  create?: InputMaybe<AnalysisDescriptionCreateWithoutAnalysisSchemaInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<AnalysisDescriptionUpdateWithoutAnalysisSchemaInput>;
  upsert?: InputMaybe<AnalysisDescriptionUpsertWithoutAnalysisSchemaInput>;
};

export type AnalysisDescriptionUpdateWithoutAnalysisSchemaInput = {
  long?: InputMaybe<StringFieldUpdateOperationsInput>;
  short?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AnalysisDescriptionUpsertWithoutAnalysisSchemaInput = {
  create: AnalysisDescriptionCreateWithoutAnalysisSchemaInput;
  update: AnalysisDescriptionUpdateWithoutAnalysisSchemaInput;
};

export type AnalysisDescriptionWhereUniqueInput = {
  analysisSchemaId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisInput = {
  __typename?: 'AnalysisInput';
  analysis: Analysis;
  analysisId: Scalars['Int'];
  analysisSchemaInput: AnalysisSchemaInput;
  analysisSchemaInputId: Scalars['Int'];
  analysisValue: AnalysisValue;
  analysisValueId: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  id: Scalars['Int'];
};

export type AnalysisInputCreateManyAnalysisInput = {
  analysisSchemaInputId: Scalars['Int'];
  analysisValueId: Scalars['Int'];
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisInputCreateManyAnalysisInputEnvelope = {
  data: Array<AnalysisInputCreateManyAnalysisInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisInputCreateManyAnalysisSchemaInputInput = {
  analysisId: Scalars['Int'];
  analysisValueId: Scalars['Int'];
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisInputCreateManyAnalysisSchemaInputInputEnvelope = {
  data: Array<AnalysisInputCreateManyAnalysisSchemaInputInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisInputCreateManyAnalysisValueInput = {
  analysisId: Scalars['Int'];
  analysisSchemaInputId: Scalars['Int'];
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisInputCreateManyAnalysisValueInputEnvelope = {
  data: Array<AnalysisInputCreateManyAnalysisValueInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisInputCreateNestedManyWithoutAnalysisInput = {
  connect?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisInputCreateOrConnectWithoutAnalysisInput>>;
  create?: InputMaybe<Array<AnalysisInputCreateWithoutAnalysisInput>>;
  createMany?: InputMaybe<AnalysisInputCreateManyAnalysisInputEnvelope>;
};

export type AnalysisInputCreateNestedManyWithoutAnalysisSchemaInputInput = {
  connect?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisInputCreateOrConnectWithoutAnalysisSchemaInputInput>>;
  create?: InputMaybe<Array<AnalysisInputCreateWithoutAnalysisSchemaInputInput>>;
  createMany?: InputMaybe<AnalysisInputCreateManyAnalysisSchemaInputInputEnvelope>;
};

export type AnalysisInputCreateNestedManyWithoutAnalysisValueInput = {
  connect?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisInputCreateOrConnectWithoutAnalysisValueInput>>;
  create?: InputMaybe<Array<AnalysisInputCreateWithoutAnalysisValueInput>>;
  createMany?: InputMaybe<AnalysisInputCreateManyAnalysisValueInputEnvelope>;
};

export type AnalysisInputCreateOrConnectWithoutAnalysisInput = {
  create: AnalysisInputCreateWithoutAnalysisInput;
  where: AnalysisInputWhereUniqueInput;
};

export type AnalysisInputCreateOrConnectWithoutAnalysisSchemaInputInput = {
  create: AnalysisInputCreateWithoutAnalysisSchemaInputInput;
  where: AnalysisInputWhereUniqueInput;
};

export type AnalysisInputCreateOrConnectWithoutAnalysisValueInput = {
  create: AnalysisInputCreateWithoutAnalysisValueInput;
  where: AnalysisInputWhereUniqueInput;
};

export type AnalysisInputCreateWithoutAnalysisInput = {
  analysisSchemaInput: AnalysisSchemaInputCreateNestedOneWithoutAnalysisInputInput;
  analysisValue: AnalysisValueCreateNestedOneWithoutAnalysisInputsInput;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
};

export type AnalysisInputCreateWithoutAnalysisSchemaInputInput = {
  analysis: AnalysisCreateNestedOneWithoutInputsInput;
  analysisValue: AnalysisValueCreateNestedOneWithoutAnalysisInputsInput;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
};

export type AnalysisInputCreateWithoutAnalysisValueInput = {
  analysis: AnalysisCreateNestedOneWithoutInputsInput;
  analysisSchemaInput: AnalysisSchemaInputCreateNestedOneWithoutAnalysisInputInput;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
};

export type AnalysisInputScalarWhereInput = {
  AND?: InputMaybe<Array<AnalysisInputScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnalysisInputScalarWhereInput>>;
  OR?: InputMaybe<Array<AnalysisInputScalarWhereInput>>;
  analysisId?: InputMaybe<IntFilter>;
  analysisSchemaInputId?: InputMaybe<IntFilter>;
  analysisValueId?: InputMaybe<IntFilter>;
  dateCreated?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AnalysisInputUpdateManyMutationInput = {
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnalysisInputUpdateManyWithWhereWithoutAnalysisInput = {
  data: AnalysisInputUpdateManyMutationInput;
  where: AnalysisInputScalarWhereInput;
};

export type AnalysisInputUpdateManyWithWhereWithoutAnalysisSchemaInputInput = {
  data: AnalysisInputUpdateManyMutationInput;
  where: AnalysisInputScalarWhereInput;
};

export type AnalysisInputUpdateManyWithWhereWithoutAnalysisValueInput = {
  data: AnalysisInputUpdateManyMutationInput;
  where: AnalysisInputScalarWhereInput;
};

export type AnalysisInputUpdateManyWithoutAnalysisInput = {
  connect?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisInputCreateOrConnectWithoutAnalysisInput>>;
  create?: InputMaybe<Array<AnalysisInputCreateWithoutAnalysisInput>>;
  createMany?: InputMaybe<AnalysisInputCreateManyAnalysisInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisInputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisInputUpdateWithWhereUniqueWithoutAnalysisInput>>;
  updateMany?: InputMaybe<Array<AnalysisInputUpdateManyWithWhereWithoutAnalysisInput>>;
  upsert?: InputMaybe<Array<AnalysisInputUpsertWithWhereUniqueWithoutAnalysisInput>>;
};

export type AnalysisInputUpdateManyWithoutAnalysisSchemaInputInput = {
  connect?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisInputCreateOrConnectWithoutAnalysisSchemaInputInput>>;
  create?: InputMaybe<Array<AnalysisInputCreateWithoutAnalysisSchemaInputInput>>;
  createMany?: InputMaybe<AnalysisInputCreateManyAnalysisSchemaInputInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisInputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisInputUpdateWithWhereUniqueWithoutAnalysisSchemaInputInput>>;
  updateMany?: InputMaybe<Array<AnalysisInputUpdateManyWithWhereWithoutAnalysisSchemaInputInput>>;
  upsert?: InputMaybe<Array<AnalysisInputUpsertWithWhereUniqueWithoutAnalysisSchemaInputInput>>;
};

export type AnalysisInputUpdateManyWithoutAnalysisValueInput = {
  connect?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisInputCreateOrConnectWithoutAnalysisValueInput>>;
  create?: InputMaybe<Array<AnalysisInputCreateWithoutAnalysisValueInput>>;
  createMany?: InputMaybe<AnalysisInputCreateManyAnalysisValueInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisInputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisInputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisInputUpdateWithWhereUniqueWithoutAnalysisValueInput>>;
  updateMany?: InputMaybe<Array<AnalysisInputUpdateManyWithWhereWithoutAnalysisValueInput>>;
  upsert?: InputMaybe<Array<AnalysisInputUpsertWithWhereUniqueWithoutAnalysisValueInput>>;
};

export type AnalysisInputUpdateWithWhereUniqueWithoutAnalysisInput = {
  data: AnalysisInputUpdateWithoutAnalysisInput;
  where: AnalysisInputWhereUniqueInput;
};

export type AnalysisInputUpdateWithWhereUniqueWithoutAnalysisSchemaInputInput = {
  data: AnalysisInputUpdateWithoutAnalysisSchemaInputInput;
  where: AnalysisInputWhereUniqueInput;
};

export type AnalysisInputUpdateWithWhereUniqueWithoutAnalysisValueInput = {
  data: AnalysisInputUpdateWithoutAnalysisValueInput;
  where: AnalysisInputWhereUniqueInput;
};

export type AnalysisInputUpdateWithoutAnalysisInput = {
  analysisSchemaInput?: InputMaybe<AnalysisSchemaInputUpdateOneRequiredWithoutAnalysisInputInput>;
  analysisValue?: InputMaybe<AnalysisValueUpdateOneRequiredWithoutAnalysisInputsInput>;
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnalysisInputUpdateWithoutAnalysisSchemaInputInput = {
  analysis?: InputMaybe<AnalysisUpdateOneRequiredWithoutInputsInput>;
  analysisValue?: InputMaybe<AnalysisValueUpdateOneRequiredWithoutAnalysisInputsInput>;
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnalysisInputUpdateWithoutAnalysisValueInput = {
  analysis?: InputMaybe<AnalysisUpdateOneRequiredWithoutInputsInput>;
  analysisSchemaInput?: InputMaybe<AnalysisSchemaInputUpdateOneRequiredWithoutAnalysisInputInput>;
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnalysisInputUpsertWithWhereUniqueWithoutAnalysisInput = {
  create: AnalysisInputCreateWithoutAnalysisInput;
  update: AnalysisInputUpdateWithoutAnalysisInput;
  where: AnalysisInputWhereUniqueInput;
};

export type AnalysisInputUpsertWithWhereUniqueWithoutAnalysisSchemaInputInput = {
  create: AnalysisInputCreateWithoutAnalysisSchemaInputInput;
  update: AnalysisInputUpdateWithoutAnalysisSchemaInputInput;
  where: AnalysisInputWhereUniqueInput;
};

export type AnalysisInputUpsertWithWhereUniqueWithoutAnalysisValueInput = {
  create: AnalysisInputCreateWithoutAnalysisValueInput;
  update: AnalysisInputUpdateWithoutAnalysisValueInput;
  where: AnalysisInputWhereUniqueInput;
};

export type AnalysisInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AnalysisOutput = {
  __typename?: 'AnalysisOutput';
  analysis: Analysis;
  analysisId: Scalars['Int'];
  analysisSchemaOutput: AnalysisSchemaOutput;
  analysisSchemaOutputId: Scalars['Int'];
  analysisValue?: Maybe<AnalysisValue>;
  analysisValueId?: Maybe<Scalars['Int']>;
  dateCreated: Scalars['DateTime'];
  id: Scalars['Int'];
};

export type AnalysisOutputCreateManyAnalysisInput = {
  analysisSchemaOutputId: Scalars['Int'];
  analysisValueId?: InputMaybe<Scalars['Int']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisOutputCreateManyAnalysisInputEnvelope = {
  data: Array<AnalysisOutputCreateManyAnalysisInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisOutputCreateManyAnalysisSchemaOutputInput = {
  analysisId: Scalars['Int'];
  analysisValueId?: InputMaybe<Scalars['Int']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisOutputCreateManyAnalysisSchemaOutputInputEnvelope = {
  data: Array<AnalysisOutputCreateManyAnalysisSchemaOutputInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisOutputCreateManyAnalysisValueInput = {
  analysisId: Scalars['Int'];
  analysisSchemaOutputId: Scalars['Int'];
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisOutputCreateManyAnalysisValueInputEnvelope = {
  data: Array<AnalysisOutputCreateManyAnalysisValueInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisOutputCreateNestedManyWithoutAnalysisInput = {
  connect?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisOutputCreateOrConnectWithoutAnalysisInput>>;
  create?: InputMaybe<Array<AnalysisOutputCreateWithoutAnalysisInput>>;
  createMany?: InputMaybe<AnalysisOutputCreateManyAnalysisInputEnvelope>;
};

export type AnalysisOutputCreateNestedManyWithoutAnalysisSchemaOutputInput = {
  connect?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisOutputCreateOrConnectWithoutAnalysisSchemaOutputInput>>;
  create?: InputMaybe<Array<AnalysisOutputCreateWithoutAnalysisSchemaOutputInput>>;
  createMany?: InputMaybe<AnalysisOutputCreateManyAnalysisSchemaOutputInputEnvelope>;
};

export type AnalysisOutputCreateNestedManyWithoutAnalysisValueInput = {
  connect?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisOutputCreateOrConnectWithoutAnalysisValueInput>>;
  create?: InputMaybe<Array<AnalysisOutputCreateWithoutAnalysisValueInput>>;
  createMany?: InputMaybe<AnalysisOutputCreateManyAnalysisValueInputEnvelope>;
};

export type AnalysisOutputCreateOrConnectWithoutAnalysisInput = {
  create: AnalysisOutputCreateWithoutAnalysisInput;
  where: AnalysisOutputWhereUniqueInput;
};

export type AnalysisOutputCreateOrConnectWithoutAnalysisSchemaOutputInput = {
  create: AnalysisOutputCreateWithoutAnalysisSchemaOutputInput;
  where: AnalysisOutputWhereUniqueInput;
};

export type AnalysisOutputCreateOrConnectWithoutAnalysisValueInput = {
  create: AnalysisOutputCreateWithoutAnalysisValueInput;
  where: AnalysisOutputWhereUniqueInput;
};

export type AnalysisOutputCreateWithoutAnalysisInput = {
  analysisSchemaOutput: AnalysisSchemaOutputCreateNestedOneWithoutAnalysisOutputsInput;
  analysisValue?: InputMaybe<AnalysisValueCreateNestedOneWithoutAnalysisOutputsInput>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
};

export type AnalysisOutputCreateWithoutAnalysisSchemaOutputInput = {
  analysis: AnalysisCreateNestedOneWithoutOutputsInput;
  analysisValue?: InputMaybe<AnalysisValueCreateNestedOneWithoutAnalysisOutputsInput>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
};

export type AnalysisOutputCreateWithoutAnalysisValueInput = {
  analysis: AnalysisCreateNestedOneWithoutOutputsInput;
  analysisSchemaOutput: AnalysisSchemaOutputCreateNestedOneWithoutAnalysisOutputsInput;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
};

export type AnalysisOutputScalarWhereInput = {
  AND?: InputMaybe<Array<AnalysisOutputScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnalysisOutputScalarWhereInput>>;
  OR?: InputMaybe<Array<AnalysisOutputScalarWhereInput>>;
  analysisId?: InputMaybe<IntFilter>;
  analysisSchemaOutputId?: InputMaybe<IntFilter>;
  analysisValueId?: InputMaybe<IntNullableFilter>;
  dateCreated?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AnalysisOutputUpdateManyMutationInput = {
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnalysisOutputUpdateManyWithWhereWithoutAnalysisInput = {
  data: AnalysisOutputUpdateManyMutationInput;
  where: AnalysisOutputScalarWhereInput;
};

export type AnalysisOutputUpdateManyWithWhereWithoutAnalysisSchemaOutputInput = {
  data: AnalysisOutputUpdateManyMutationInput;
  where: AnalysisOutputScalarWhereInput;
};

export type AnalysisOutputUpdateManyWithWhereWithoutAnalysisValueInput = {
  data: AnalysisOutputUpdateManyMutationInput;
  where: AnalysisOutputScalarWhereInput;
};

export type AnalysisOutputUpdateManyWithoutAnalysisInput = {
  connect?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisOutputCreateOrConnectWithoutAnalysisInput>>;
  create?: InputMaybe<Array<AnalysisOutputCreateWithoutAnalysisInput>>;
  createMany?: InputMaybe<AnalysisOutputCreateManyAnalysisInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisOutputUpdateWithWhereUniqueWithoutAnalysisInput>>;
  updateMany?: InputMaybe<Array<AnalysisOutputUpdateManyWithWhereWithoutAnalysisInput>>;
  upsert?: InputMaybe<Array<AnalysisOutputUpsertWithWhereUniqueWithoutAnalysisInput>>;
};

export type AnalysisOutputUpdateManyWithoutAnalysisSchemaOutputInput = {
  connect?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisOutputCreateOrConnectWithoutAnalysisSchemaOutputInput>>;
  create?: InputMaybe<Array<AnalysisOutputCreateWithoutAnalysisSchemaOutputInput>>;
  createMany?: InputMaybe<AnalysisOutputCreateManyAnalysisSchemaOutputInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisOutputUpdateWithWhereUniqueWithoutAnalysisSchemaOutputInput>>;
  updateMany?: InputMaybe<Array<AnalysisOutputUpdateManyWithWhereWithoutAnalysisSchemaOutputInput>>;
  upsert?: InputMaybe<Array<AnalysisOutputUpsertWithWhereUniqueWithoutAnalysisSchemaOutputInput>>;
};

export type AnalysisOutputUpdateManyWithoutAnalysisValueInput = {
  connect?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisOutputCreateOrConnectWithoutAnalysisValueInput>>;
  create?: InputMaybe<Array<AnalysisOutputCreateWithoutAnalysisValueInput>>;
  createMany?: InputMaybe<AnalysisOutputCreateManyAnalysisValueInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisOutputUpdateWithWhereUniqueWithoutAnalysisValueInput>>;
  updateMany?: InputMaybe<Array<AnalysisOutputUpdateManyWithWhereWithoutAnalysisValueInput>>;
  upsert?: InputMaybe<Array<AnalysisOutputUpsertWithWhereUniqueWithoutAnalysisValueInput>>;
};

export type AnalysisOutputUpdateWithWhereUniqueWithoutAnalysisInput = {
  data: AnalysisOutputUpdateWithoutAnalysisInput;
  where: AnalysisOutputWhereUniqueInput;
};

export type AnalysisOutputUpdateWithWhereUniqueWithoutAnalysisSchemaOutputInput = {
  data: AnalysisOutputUpdateWithoutAnalysisSchemaOutputInput;
  where: AnalysisOutputWhereUniqueInput;
};

export type AnalysisOutputUpdateWithWhereUniqueWithoutAnalysisValueInput = {
  data: AnalysisOutputUpdateWithoutAnalysisValueInput;
  where: AnalysisOutputWhereUniqueInput;
};

export type AnalysisOutputUpdateWithoutAnalysisInput = {
  analysisSchemaOutput?: InputMaybe<AnalysisSchemaOutputUpdateOneRequiredWithoutAnalysisOutputsInput>;
  analysisValue?: InputMaybe<AnalysisValueUpdateOneWithoutAnalysisOutputsInput>;
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnalysisOutputUpdateWithoutAnalysisSchemaOutputInput = {
  analysis?: InputMaybe<AnalysisUpdateOneRequiredWithoutOutputsInput>;
  analysisValue?: InputMaybe<AnalysisValueUpdateOneWithoutAnalysisOutputsInput>;
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnalysisOutputUpdateWithoutAnalysisValueInput = {
  analysis?: InputMaybe<AnalysisUpdateOneRequiredWithoutOutputsInput>;
  analysisSchemaOutput?: InputMaybe<AnalysisSchemaOutputUpdateOneRequiredWithoutAnalysisOutputsInput>;
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AnalysisOutputUpsertWithWhereUniqueWithoutAnalysisInput = {
  create: AnalysisOutputCreateWithoutAnalysisInput;
  update: AnalysisOutputUpdateWithoutAnalysisInput;
  where: AnalysisOutputWhereUniqueInput;
};

export type AnalysisOutputUpsertWithWhereUniqueWithoutAnalysisSchemaOutputInput = {
  create: AnalysisOutputCreateWithoutAnalysisSchemaOutputInput;
  update: AnalysisOutputUpdateWithoutAnalysisSchemaOutputInput;
  where: AnalysisOutputWhereUniqueInput;
};

export type AnalysisOutputUpsertWithWhereUniqueWithoutAnalysisValueInput = {
  create: AnalysisOutputCreateWithoutAnalysisValueInput;
  update: AnalysisOutputUpdateWithoutAnalysisValueInput;
  where: AnalysisOutputWhereUniqueInput;
};

export type AnalysisOutputWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisScalarWhereInput = {
  AND?: InputMaybe<Array<AnalysisScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnalysisScalarWhereInput>>;
  OR?: InputMaybe<Array<AnalysisScalarWhereInput>>;
  analysisSchemaId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creatorId?: InputMaybe<IntFilter>;
  endedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  logs?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  startedAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumAnalysisStatusFilter>;
  wantsNotification?: InputMaybe<BoolFilter>;
};

export type AnalysisSchema = {
  __typename?: 'AnalysisSchema';
  _count: AnalysisSchemaCount;
  actions?: Maybe<Array<Action>>;
  analysis?: Maybe<Array<Analysis>>;
  analysisDescription?: Maybe<AnalysisDescription>;
  analysisSchemaInputs?: Maybe<Array<AnalysisSchemaInput>>;
  analysisSchemaOutputs?: Maybe<Array<AnalysisSchemaOutput>>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  nextflowWorkflowId: Scalars['Int'];
  workflow: NextflowWorkflow;
};

export type AnalysisSchemaCount = {
  __typename?: 'AnalysisSchemaCount';
  actions: Scalars['Int'];
  analysis: Scalars['Int'];
  analysisSchemaInputs: Scalars['Int'];
  analysisSchemaOutputs: Scalars['Int'];
};

export type AnalysisSchemaCreateInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutAnalysisSchemaInput>;
  analysis?: InputMaybe<AnalysisCreateNestedManyWithoutAnalysisSchemaInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionCreateNestedOneWithoutAnalysisSchemaInput>;
  analysisSchemaInputs?: InputMaybe<AnalysisSchemaInputCreateNestedManyWithoutAnalysisSchemaInput>;
  analysisSchemaOutputs?: InputMaybe<AnalysisSchemaOutputCreateNestedManyWithoutAnalysisSchemaInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  workflow: NextflowWorkflowCreateNestedOneWithoutAnalysisSchemaInput;
};

export type AnalysisSchemaCreateNestedOneWithoutActionsInput = {
  connect?: InputMaybe<AnalysisSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaCreateOrConnectWithoutActionsInput>;
  create?: InputMaybe<AnalysisSchemaCreateWithoutActionsInput>;
};

export type AnalysisSchemaCreateNestedOneWithoutAnalysisInput = {
  connect?: InputMaybe<AnalysisSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaCreateOrConnectWithoutAnalysisInput>;
  create?: InputMaybe<AnalysisSchemaCreateWithoutAnalysisInput>;
};

export type AnalysisSchemaCreateNestedOneWithoutAnalysisSchemaInputsInput = {
  connect?: InputMaybe<AnalysisSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaCreateOrConnectWithoutAnalysisSchemaInputsInput>;
  create?: InputMaybe<AnalysisSchemaCreateWithoutAnalysisSchemaInputsInput>;
};

export type AnalysisSchemaCreateNestedOneWithoutAnalysisSchemaOutputsInput = {
  connect?: InputMaybe<AnalysisSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaCreateOrConnectWithoutAnalysisSchemaOutputsInput>;
  create?: InputMaybe<AnalysisSchemaCreateWithoutAnalysisSchemaOutputsInput>;
};

export type AnalysisSchemaCreateOrConnectWithoutActionsInput = {
  create: AnalysisSchemaCreateWithoutActionsInput;
  where: AnalysisSchemaWhereUniqueInput;
};

export type AnalysisSchemaCreateOrConnectWithoutAnalysisInput = {
  create: AnalysisSchemaCreateWithoutAnalysisInput;
  where: AnalysisSchemaWhereUniqueInput;
};

export type AnalysisSchemaCreateOrConnectWithoutAnalysisSchemaInputsInput = {
  create: AnalysisSchemaCreateWithoutAnalysisSchemaInputsInput;
  where: AnalysisSchemaWhereUniqueInput;
};

export type AnalysisSchemaCreateOrConnectWithoutAnalysisSchemaOutputsInput = {
  create: AnalysisSchemaCreateWithoutAnalysisSchemaOutputsInput;
  where: AnalysisSchemaWhereUniqueInput;
};

export type AnalysisSchemaCreateWithoutActionsInput = {
  analysis?: InputMaybe<AnalysisCreateNestedManyWithoutAnalysisSchemaInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionCreateNestedOneWithoutAnalysisSchemaInput>;
  analysisSchemaInputs?: InputMaybe<AnalysisSchemaInputCreateNestedManyWithoutAnalysisSchemaInput>;
  analysisSchemaOutputs?: InputMaybe<AnalysisSchemaOutputCreateNestedManyWithoutAnalysisSchemaInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  workflow: NextflowWorkflowCreateNestedOneWithoutAnalysisSchemaInput;
};

export type AnalysisSchemaCreateWithoutAnalysisInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutAnalysisSchemaInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionCreateNestedOneWithoutAnalysisSchemaInput>;
  analysisSchemaInputs?: InputMaybe<AnalysisSchemaInputCreateNestedManyWithoutAnalysisSchemaInput>;
  analysisSchemaOutputs?: InputMaybe<AnalysisSchemaOutputCreateNestedManyWithoutAnalysisSchemaInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  workflow: NextflowWorkflowCreateNestedOneWithoutAnalysisSchemaInput;
};

export type AnalysisSchemaCreateWithoutAnalysisSchemaInputsInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutAnalysisSchemaInput>;
  analysis?: InputMaybe<AnalysisCreateNestedManyWithoutAnalysisSchemaInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionCreateNestedOneWithoutAnalysisSchemaInput>;
  analysisSchemaOutputs?: InputMaybe<AnalysisSchemaOutputCreateNestedManyWithoutAnalysisSchemaInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  workflow: NextflowWorkflowCreateNestedOneWithoutAnalysisSchemaInput;
};

export type AnalysisSchemaCreateWithoutAnalysisSchemaOutputsInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutAnalysisSchemaInput>;
  analysis?: InputMaybe<AnalysisCreateNestedManyWithoutAnalysisSchemaInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionCreateNestedOneWithoutAnalysisSchemaInput>;
  analysisSchemaInputs?: InputMaybe<AnalysisSchemaInputCreateNestedManyWithoutAnalysisSchemaInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  workflow: NextflowWorkflowCreateNestedOneWithoutAnalysisSchemaInput;
};

export type AnalysisSchemaInput = {
  __typename?: 'AnalysisSchemaInput';
  AnalysisInput?: Maybe<Array<AnalysisInput>>;
  _count: AnalysisSchemaInputCount;
  analysisSchema: AnalysisSchema;
  analysisSchemaId: Scalars['Int'];
  analysisValueId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  valueSchema: ValueSchema;
  valueSchemaId: Scalars['Int'];
};

export type AnalysisSchemaInputAnalysisSchemaIdNameUniqueCompoundUniqueInput = {
  analysisSchemaId: Scalars['Int'];
  name: Scalars['String'];
};

export type AnalysisSchemaInputCount = {
  __typename?: 'AnalysisSchemaInputCount';
  AnalysisInput: Scalars['Int'];
};

export type AnalysisSchemaInputCreateManyAnalysisSchemaInput = {
  analysisValueId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  valueSchemaId: Scalars['Int'];
};

export type AnalysisSchemaInputCreateManyAnalysisSchemaInputEnvelope = {
  data: Array<AnalysisSchemaInputCreateManyAnalysisSchemaInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisSchemaInputCreateManyValueSchemaInput = {
  analysisSchemaId: Scalars['Int'];
  analysisValueId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type AnalysisSchemaInputCreateManyValueSchemaInputEnvelope = {
  data: Array<AnalysisSchemaInputCreateManyValueSchemaInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisSchemaInputCreateNestedManyWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisSchemaInputCreateOrConnectWithoutAnalysisSchemaInput>>;
  create?: InputMaybe<Array<AnalysisSchemaInputCreateWithoutAnalysisSchemaInput>>;
  createMany?: InputMaybe<AnalysisSchemaInputCreateManyAnalysisSchemaInputEnvelope>;
};

export type AnalysisSchemaInputCreateNestedManyWithoutValueSchemaInput = {
  connect?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisSchemaInputCreateOrConnectWithoutValueSchemaInput>>;
  create?: InputMaybe<Array<AnalysisSchemaInputCreateWithoutValueSchemaInput>>;
  createMany?: InputMaybe<AnalysisSchemaInputCreateManyValueSchemaInputEnvelope>;
};

export type AnalysisSchemaInputCreateNestedOneWithoutAnalysisInputInput = {
  connect?: InputMaybe<AnalysisSchemaInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaInputCreateOrConnectWithoutAnalysisInputInput>;
  create?: InputMaybe<AnalysisSchemaInputCreateWithoutAnalysisInputInput>;
};

export type AnalysisSchemaInputCreateOrConnectWithoutAnalysisInputInput = {
  create: AnalysisSchemaInputCreateWithoutAnalysisInputInput;
  where: AnalysisSchemaInputWhereUniqueInput;
};

export type AnalysisSchemaInputCreateOrConnectWithoutAnalysisSchemaInput = {
  create: AnalysisSchemaInputCreateWithoutAnalysisSchemaInput;
  where: AnalysisSchemaInputWhereUniqueInput;
};

export type AnalysisSchemaInputCreateOrConnectWithoutValueSchemaInput = {
  create: AnalysisSchemaInputCreateWithoutValueSchemaInput;
  where: AnalysisSchemaInputWhereUniqueInput;
};

export type AnalysisSchemaInputCreateWithoutAnalysisInputInput = {
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutAnalysisSchemaInputsInput;
  analysisValueId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  valueSchema: ValueSchemaCreateNestedOneWithoutAnalysisValueInputInput;
};

export type AnalysisSchemaInputCreateWithoutAnalysisSchemaInput = {
  AnalysisInput?: InputMaybe<AnalysisInputCreateNestedManyWithoutAnalysisSchemaInputInput>;
  analysisValueId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  valueSchema: ValueSchemaCreateNestedOneWithoutAnalysisValueInputInput;
};

export type AnalysisSchemaInputCreateWithoutValueSchemaInput = {
  AnalysisInput?: InputMaybe<AnalysisInputCreateNestedManyWithoutAnalysisSchemaInputInput>;
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutAnalysisSchemaInputsInput;
  analysisValueId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type AnalysisSchemaInputOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AnalysisSchemaInputScalarWhereInput = {
  AND?: InputMaybe<Array<AnalysisSchemaInputScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnalysisSchemaInputScalarWhereInput>>;
  OR?: InputMaybe<Array<AnalysisSchemaInputScalarWhereInput>>;
  analysisSchemaId?: InputMaybe<IntFilter>;
  analysisValueId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  valueSchemaId?: InputMaybe<IntFilter>;
};

export type AnalysisSchemaInputUpdateManyMutationInput = {
  analysisValueId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AnalysisSchemaInputUpdateManyWithWhereWithoutAnalysisSchemaInput = {
  data: AnalysisSchemaInputUpdateManyMutationInput;
  where: AnalysisSchemaInputScalarWhereInput;
};

export type AnalysisSchemaInputUpdateManyWithWhereWithoutValueSchemaInput = {
  data: AnalysisSchemaInputUpdateManyMutationInput;
  where: AnalysisSchemaInputScalarWhereInput;
};

export type AnalysisSchemaInputUpdateManyWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisSchemaInputCreateOrConnectWithoutAnalysisSchemaInput>>;
  create?: InputMaybe<Array<AnalysisSchemaInputCreateWithoutAnalysisSchemaInput>>;
  createMany?: InputMaybe<AnalysisSchemaInputCreateManyAnalysisSchemaInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisSchemaInputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisSchemaInputUpdateWithWhereUniqueWithoutAnalysisSchemaInput>>;
  updateMany?: InputMaybe<Array<AnalysisSchemaInputUpdateManyWithWhereWithoutAnalysisSchemaInput>>;
  upsert?: InputMaybe<Array<AnalysisSchemaInputUpsertWithWhereUniqueWithoutAnalysisSchemaInput>>;
};

export type AnalysisSchemaInputUpdateManyWithoutValueSchemaInput = {
  connect?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisSchemaInputCreateOrConnectWithoutValueSchemaInput>>;
  create?: InputMaybe<Array<AnalysisSchemaInputCreateWithoutValueSchemaInput>>;
  createMany?: InputMaybe<AnalysisSchemaInputCreateManyValueSchemaInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisSchemaInputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisSchemaInputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisSchemaInputUpdateWithWhereUniqueWithoutValueSchemaInput>>;
  updateMany?: InputMaybe<Array<AnalysisSchemaInputUpdateManyWithWhereWithoutValueSchemaInput>>;
  upsert?: InputMaybe<Array<AnalysisSchemaInputUpsertWithWhereUniqueWithoutValueSchemaInput>>;
};

export type AnalysisSchemaInputUpdateOneRequiredWithoutAnalysisInputInput = {
  connect?: InputMaybe<AnalysisSchemaInputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaInputCreateOrConnectWithoutAnalysisInputInput>;
  create?: InputMaybe<AnalysisSchemaInputCreateWithoutAnalysisInputInput>;
  update?: InputMaybe<AnalysisSchemaInputUpdateWithoutAnalysisInputInput>;
  upsert?: InputMaybe<AnalysisSchemaInputUpsertWithoutAnalysisInputInput>;
};

export type AnalysisSchemaInputUpdateWithWhereUniqueWithoutAnalysisSchemaInput = {
  data: AnalysisSchemaInputUpdateWithoutAnalysisSchemaInput;
  where: AnalysisSchemaInputWhereUniqueInput;
};

export type AnalysisSchemaInputUpdateWithWhereUniqueWithoutValueSchemaInput = {
  data: AnalysisSchemaInputUpdateWithoutValueSchemaInput;
  where: AnalysisSchemaInputWhereUniqueInput;
};

export type AnalysisSchemaInputUpdateWithoutAnalysisInputInput = {
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutAnalysisSchemaInputsInput>;
  analysisValueId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  valueSchema?: InputMaybe<ValueSchemaUpdateOneRequiredWithoutAnalysisValueInputInput>;
};

export type AnalysisSchemaInputUpdateWithoutAnalysisSchemaInput = {
  AnalysisInput?: InputMaybe<AnalysisInputUpdateManyWithoutAnalysisSchemaInputInput>;
  analysisValueId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  valueSchema?: InputMaybe<ValueSchemaUpdateOneRequiredWithoutAnalysisValueInputInput>;
};

export type AnalysisSchemaInputUpdateWithoutValueSchemaInput = {
  AnalysisInput?: InputMaybe<AnalysisInputUpdateManyWithoutAnalysisSchemaInputInput>;
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutAnalysisSchemaInputsInput>;
  analysisValueId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AnalysisSchemaInputUpsertWithWhereUniqueWithoutAnalysisSchemaInput = {
  create: AnalysisSchemaInputCreateWithoutAnalysisSchemaInput;
  update: AnalysisSchemaInputUpdateWithoutAnalysisSchemaInput;
  where: AnalysisSchemaInputWhereUniqueInput;
};

export type AnalysisSchemaInputUpsertWithWhereUniqueWithoutValueSchemaInput = {
  create: AnalysisSchemaInputCreateWithoutValueSchemaInput;
  update: AnalysisSchemaInputUpdateWithoutValueSchemaInput;
  where: AnalysisSchemaInputWhereUniqueInput;
};

export type AnalysisSchemaInputUpsertWithoutAnalysisInputInput = {
  create: AnalysisSchemaInputCreateWithoutAnalysisInputInput;
  update: AnalysisSchemaInputUpdateWithoutAnalysisInputInput;
};

export type AnalysisSchemaInputWhereUniqueInput = {
  analysisSchemaIdNameUnique?: InputMaybe<AnalysisSchemaInputAnalysisSchemaIdNameUniqueCompoundUniqueInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisSchemaOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AnalysisSchemaOrderByWithRelationInput = {
  actions?: InputMaybe<ActionOrderByRelationAggregateInput>;
  analysis?: InputMaybe<AnalysisOrderByRelationAggregateInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionOrderByWithRelationInput>;
  analysisSchemaInputs?: InputMaybe<AnalysisSchemaInputOrderByRelationAggregateInput>;
  analysisSchemaOutputs?: InputMaybe<AnalysisSchemaOutputOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nextflowWorkflowId?: InputMaybe<SortOrder>;
  workflow?: InputMaybe<NextflowWorkflowOrderByWithRelationInput>;
};

export type AnalysisSchemaOutput = {
  __typename?: 'AnalysisSchemaOutput';
  _count: AnalysisSchemaOutputCount;
  analysisOutputs?: Maybe<Array<AnalysisOutput>>;
  analysisSchema: AnalysisSchema;
  analysisSchemaId: Scalars['Int'];
  analysisValueId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  valueSchema: ValueSchema;
  valueSchemaId: Scalars['Int'];
};

export type AnalysisSchemaOutputAnalysisSchemaIdNameUniqueCompoundUniqueInput = {
  analysisSchemaId: Scalars['Int'];
  name: Scalars['String'];
};

export type AnalysisSchemaOutputCount = {
  __typename?: 'AnalysisSchemaOutputCount';
  analysisOutputs: Scalars['Int'];
};

export type AnalysisSchemaOutputCreateManyAnalysisSchemaInput = {
  analysisValueId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  valueSchemaId: Scalars['Int'];
};

export type AnalysisSchemaOutputCreateManyAnalysisSchemaInputEnvelope = {
  data: Array<AnalysisSchemaOutputCreateManyAnalysisSchemaInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisSchemaOutputCreateManyValueSchemaInput = {
  analysisSchemaId: Scalars['Int'];
  analysisValueId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type AnalysisSchemaOutputCreateManyValueSchemaInputEnvelope = {
  data: Array<AnalysisSchemaOutputCreateManyValueSchemaInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisSchemaOutputCreateNestedManyWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisSchemaOutputCreateOrConnectWithoutAnalysisSchemaInput>>;
  create?: InputMaybe<Array<AnalysisSchemaOutputCreateWithoutAnalysisSchemaInput>>;
  createMany?: InputMaybe<AnalysisSchemaOutputCreateManyAnalysisSchemaInputEnvelope>;
};

export type AnalysisSchemaOutputCreateNestedManyWithoutValueSchemaInput = {
  connect?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisSchemaOutputCreateOrConnectWithoutValueSchemaInput>>;
  create?: InputMaybe<Array<AnalysisSchemaOutputCreateWithoutValueSchemaInput>>;
  createMany?: InputMaybe<AnalysisSchemaOutputCreateManyValueSchemaInputEnvelope>;
};

export type AnalysisSchemaOutputCreateNestedOneWithoutAnalysisOutputsInput = {
  connect?: InputMaybe<AnalysisSchemaOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaOutputCreateOrConnectWithoutAnalysisOutputsInput>;
  create?: InputMaybe<AnalysisSchemaOutputCreateWithoutAnalysisOutputsInput>;
};

export type AnalysisSchemaOutputCreateOrConnectWithoutAnalysisOutputsInput = {
  create: AnalysisSchemaOutputCreateWithoutAnalysisOutputsInput;
  where: AnalysisSchemaOutputWhereUniqueInput;
};

export type AnalysisSchemaOutputCreateOrConnectWithoutAnalysisSchemaInput = {
  create: AnalysisSchemaOutputCreateWithoutAnalysisSchemaInput;
  where: AnalysisSchemaOutputWhereUniqueInput;
};

export type AnalysisSchemaOutputCreateOrConnectWithoutValueSchemaInput = {
  create: AnalysisSchemaOutputCreateWithoutValueSchemaInput;
  where: AnalysisSchemaOutputWhereUniqueInput;
};

export type AnalysisSchemaOutputCreateWithoutAnalysisOutputsInput = {
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutAnalysisSchemaOutputsInput;
  analysisValueId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  valueSchema: ValueSchemaCreateNestedOneWithoutAnalysisSchemaOutputInput;
};

export type AnalysisSchemaOutputCreateWithoutAnalysisSchemaInput = {
  analysisOutputs?: InputMaybe<AnalysisOutputCreateNestedManyWithoutAnalysisSchemaOutputInput>;
  analysisValueId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  valueSchema: ValueSchemaCreateNestedOneWithoutAnalysisSchemaOutputInput;
};

export type AnalysisSchemaOutputCreateWithoutValueSchemaInput = {
  analysisOutputs?: InputMaybe<AnalysisOutputCreateNestedManyWithoutAnalysisSchemaOutputInput>;
  analysisSchema: AnalysisSchemaCreateNestedOneWithoutAnalysisSchemaOutputsInput;
  analysisValueId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type AnalysisSchemaOutputOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AnalysisSchemaOutputScalarWhereInput = {
  AND?: InputMaybe<Array<AnalysisSchemaOutputScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnalysisSchemaOutputScalarWhereInput>>;
  OR?: InputMaybe<Array<AnalysisSchemaOutputScalarWhereInput>>;
  analysisSchemaId?: InputMaybe<IntFilter>;
  analysisValueId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  valueSchemaId?: InputMaybe<IntFilter>;
};

export type AnalysisSchemaOutputUpdateManyMutationInput = {
  analysisValueId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AnalysisSchemaOutputUpdateManyWithWhereWithoutAnalysisSchemaInput = {
  data: AnalysisSchemaOutputUpdateManyMutationInput;
  where: AnalysisSchemaOutputScalarWhereInput;
};

export type AnalysisSchemaOutputUpdateManyWithWhereWithoutValueSchemaInput = {
  data: AnalysisSchemaOutputUpdateManyMutationInput;
  where: AnalysisSchemaOutputScalarWhereInput;
};

export type AnalysisSchemaOutputUpdateManyWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisSchemaOutputCreateOrConnectWithoutAnalysisSchemaInput>>;
  create?: InputMaybe<Array<AnalysisSchemaOutputCreateWithoutAnalysisSchemaInput>>;
  createMany?: InputMaybe<AnalysisSchemaOutputCreateManyAnalysisSchemaInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisSchemaOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisSchemaOutputUpdateWithWhereUniqueWithoutAnalysisSchemaInput>>;
  updateMany?: InputMaybe<Array<AnalysisSchemaOutputUpdateManyWithWhereWithoutAnalysisSchemaInput>>;
  upsert?: InputMaybe<Array<AnalysisSchemaOutputUpsertWithWhereUniqueWithoutAnalysisSchemaInput>>;
};

export type AnalysisSchemaOutputUpdateManyWithoutValueSchemaInput = {
  connect?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisSchemaOutputCreateOrConnectWithoutValueSchemaInput>>;
  create?: InputMaybe<Array<AnalysisSchemaOutputCreateWithoutValueSchemaInput>>;
  createMany?: InputMaybe<AnalysisSchemaOutputCreateManyValueSchemaInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisSchemaOutputScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisSchemaOutputWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisSchemaOutputUpdateWithWhereUniqueWithoutValueSchemaInput>>;
  updateMany?: InputMaybe<Array<AnalysisSchemaOutputUpdateManyWithWhereWithoutValueSchemaInput>>;
  upsert?: InputMaybe<Array<AnalysisSchemaOutputUpsertWithWhereUniqueWithoutValueSchemaInput>>;
};

export type AnalysisSchemaOutputUpdateOneRequiredWithoutAnalysisOutputsInput = {
  connect?: InputMaybe<AnalysisSchemaOutputWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaOutputCreateOrConnectWithoutAnalysisOutputsInput>;
  create?: InputMaybe<AnalysisSchemaOutputCreateWithoutAnalysisOutputsInput>;
  update?: InputMaybe<AnalysisSchemaOutputUpdateWithoutAnalysisOutputsInput>;
  upsert?: InputMaybe<AnalysisSchemaOutputUpsertWithoutAnalysisOutputsInput>;
};

export type AnalysisSchemaOutputUpdateWithWhereUniqueWithoutAnalysisSchemaInput = {
  data: AnalysisSchemaOutputUpdateWithoutAnalysisSchemaInput;
  where: AnalysisSchemaOutputWhereUniqueInput;
};

export type AnalysisSchemaOutputUpdateWithWhereUniqueWithoutValueSchemaInput = {
  data: AnalysisSchemaOutputUpdateWithoutValueSchemaInput;
  where: AnalysisSchemaOutputWhereUniqueInput;
};

export type AnalysisSchemaOutputUpdateWithoutAnalysisOutputsInput = {
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutAnalysisSchemaOutputsInput>;
  analysisValueId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  valueSchema?: InputMaybe<ValueSchemaUpdateOneRequiredWithoutAnalysisSchemaOutputInput>;
};

export type AnalysisSchemaOutputUpdateWithoutAnalysisSchemaInput = {
  analysisOutputs?: InputMaybe<AnalysisOutputUpdateManyWithoutAnalysisSchemaOutputInput>;
  analysisValueId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  valueSchema?: InputMaybe<ValueSchemaUpdateOneRequiredWithoutAnalysisSchemaOutputInput>;
};

export type AnalysisSchemaOutputUpdateWithoutValueSchemaInput = {
  analysisOutputs?: InputMaybe<AnalysisOutputUpdateManyWithoutAnalysisSchemaOutputInput>;
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutAnalysisSchemaOutputsInput>;
  analysisValueId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AnalysisSchemaOutputUpsertWithWhereUniqueWithoutAnalysisSchemaInput = {
  create: AnalysisSchemaOutputCreateWithoutAnalysisSchemaInput;
  update: AnalysisSchemaOutputUpdateWithoutAnalysisSchemaInput;
  where: AnalysisSchemaOutputWhereUniqueInput;
};

export type AnalysisSchemaOutputUpsertWithWhereUniqueWithoutValueSchemaInput = {
  create: AnalysisSchemaOutputCreateWithoutValueSchemaInput;
  update: AnalysisSchemaOutputUpdateWithoutValueSchemaInput;
  where: AnalysisSchemaOutputWhereUniqueInput;
};

export type AnalysisSchemaOutputUpsertWithoutAnalysisOutputsInput = {
  create: AnalysisSchemaOutputCreateWithoutAnalysisOutputsInput;
  update: AnalysisSchemaOutputUpdateWithoutAnalysisOutputsInput;
};

export type AnalysisSchemaOutputWhereUniqueInput = {
  analysisSchemaIdNameUnique?: InputMaybe<AnalysisSchemaOutputAnalysisSchemaIdNameUniqueCompoundUniqueInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisSchemaUpdateOneRequiredWithoutActionsInput = {
  connect?: InputMaybe<AnalysisSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaCreateOrConnectWithoutActionsInput>;
  create?: InputMaybe<AnalysisSchemaCreateWithoutActionsInput>;
  update?: InputMaybe<AnalysisSchemaUpdateWithoutActionsInput>;
  upsert?: InputMaybe<AnalysisSchemaUpsertWithoutActionsInput>;
};

export type AnalysisSchemaUpdateOneRequiredWithoutAnalysisInput = {
  connect?: InputMaybe<AnalysisSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaCreateOrConnectWithoutAnalysisInput>;
  create?: InputMaybe<AnalysisSchemaCreateWithoutAnalysisInput>;
  update?: InputMaybe<AnalysisSchemaUpdateWithoutAnalysisInput>;
  upsert?: InputMaybe<AnalysisSchemaUpsertWithoutAnalysisInput>;
};

export type AnalysisSchemaUpdateOneRequiredWithoutAnalysisSchemaInputsInput = {
  connect?: InputMaybe<AnalysisSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaCreateOrConnectWithoutAnalysisSchemaInputsInput>;
  create?: InputMaybe<AnalysisSchemaCreateWithoutAnalysisSchemaInputsInput>;
  update?: InputMaybe<AnalysisSchemaUpdateWithoutAnalysisSchemaInputsInput>;
  upsert?: InputMaybe<AnalysisSchemaUpsertWithoutAnalysisSchemaInputsInput>;
};

export type AnalysisSchemaUpdateOneRequiredWithoutAnalysisSchemaOutputsInput = {
  connect?: InputMaybe<AnalysisSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisSchemaCreateOrConnectWithoutAnalysisSchemaOutputsInput>;
  create?: InputMaybe<AnalysisSchemaCreateWithoutAnalysisSchemaOutputsInput>;
  update?: InputMaybe<AnalysisSchemaUpdateWithoutAnalysisSchemaOutputsInput>;
  upsert?: InputMaybe<AnalysisSchemaUpsertWithoutAnalysisSchemaOutputsInput>;
};

export type AnalysisSchemaUpdateWithoutActionsInput = {
  analysis?: InputMaybe<AnalysisUpdateManyWithoutAnalysisSchemaInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionUpdateOneWithoutAnalysisSchemaInput>;
  analysisSchemaInputs?: InputMaybe<AnalysisSchemaInputUpdateManyWithoutAnalysisSchemaInput>;
  analysisSchemaOutputs?: InputMaybe<AnalysisSchemaOutputUpdateManyWithoutAnalysisSchemaInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  workflow?: InputMaybe<NextflowWorkflowUpdateOneRequiredWithoutAnalysisSchemaInput>;
};

export type AnalysisSchemaUpdateWithoutAnalysisInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutAnalysisSchemaInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionUpdateOneWithoutAnalysisSchemaInput>;
  analysisSchemaInputs?: InputMaybe<AnalysisSchemaInputUpdateManyWithoutAnalysisSchemaInput>;
  analysisSchemaOutputs?: InputMaybe<AnalysisSchemaOutputUpdateManyWithoutAnalysisSchemaInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  workflow?: InputMaybe<NextflowWorkflowUpdateOneRequiredWithoutAnalysisSchemaInput>;
};

export type AnalysisSchemaUpdateWithoutAnalysisSchemaInputsInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutAnalysisSchemaInput>;
  analysis?: InputMaybe<AnalysisUpdateManyWithoutAnalysisSchemaInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionUpdateOneWithoutAnalysisSchemaInput>;
  analysisSchemaOutputs?: InputMaybe<AnalysisSchemaOutputUpdateManyWithoutAnalysisSchemaInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  workflow?: InputMaybe<NextflowWorkflowUpdateOneRequiredWithoutAnalysisSchemaInput>;
};

export type AnalysisSchemaUpdateWithoutAnalysisSchemaOutputsInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutAnalysisSchemaInput>;
  analysis?: InputMaybe<AnalysisUpdateManyWithoutAnalysisSchemaInput>;
  analysisDescription?: InputMaybe<AnalysisDescriptionUpdateOneWithoutAnalysisSchemaInput>;
  analysisSchemaInputs?: InputMaybe<AnalysisSchemaInputUpdateManyWithoutAnalysisSchemaInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  workflow?: InputMaybe<NextflowWorkflowUpdateOneRequiredWithoutAnalysisSchemaInput>;
};

export type AnalysisSchemaUpsertWithoutActionsInput = {
  create: AnalysisSchemaCreateWithoutActionsInput;
  update: AnalysisSchemaUpdateWithoutActionsInput;
};

export type AnalysisSchemaUpsertWithoutAnalysisInput = {
  create: AnalysisSchemaCreateWithoutAnalysisInput;
  update: AnalysisSchemaUpdateWithoutAnalysisInput;
};

export type AnalysisSchemaUpsertWithoutAnalysisSchemaInputsInput = {
  create: AnalysisSchemaCreateWithoutAnalysisSchemaInputsInput;
  update: AnalysisSchemaUpdateWithoutAnalysisSchemaInputsInput;
};

export type AnalysisSchemaUpsertWithoutAnalysisSchemaOutputsInput = {
  create: AnalysisSchemaCreateWithoutAnalysisSchemaOutputsInput;
  update: AnalysisSchemaUpdateWithoutAnalysisSchemaOutputsInput;
};

export type AnalysisSchemaWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum AnalysisStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type AnalysisUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  logs?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAnalysisStatusFieldUpdateOperationsInput>;
  wantsNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AnalysisUpdateManyWithWhereWithoutAnalysisSchemaInput = {
  data: AnalysisUpdateManyMutationInput;
  where: AnalysisScalarWhereInput;
};

export type AnalysisUpdateManyWithWhereWithoutCreatorInput = {
  data: AnalysisUpdateManyMutationInput;
  where: AnalysisScalarWhereInput;
};

export type AnalysisUpdateManyWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisCreateOrConnectWithoutAnalysisSchemaInput>>;
  create?: InputMaybe<Array<AnalysisCreateWithoutAnalysisSchemaInput>>;
  createMany?: InputMaybe<AnalysisCreateManyAnalysisSchemaInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisUpdateWithWhereUniqueWithoutAnalysisSchemaInput>>;
  updateMany?: InputMaybe<Array<AnalysisUpdateManyWithWhereWithoutAnalysisSchemaInput>>;
  upsert?: InputMaybe<Array<AnalysisUpsertWithWhereUniqueWithoutAnalysisSchemaInput>>;
};

export type AnalysisUpdateManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<AnalysisCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<AnalysisCreateManyCreatorInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: InputMaybe<Array<AnalysisUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: InputMaybe<Array<AnalysisUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type AnalysisUpdateOneRequiredWithoutAnalysisValueInput = {
  connect?: InputMaybe<AnalysisWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisCreateOrConnectWithoutAnalysisValueInput>;
  create?: InputMaybe<AnalysisCreateWithoutAnalysisValueInput>;
  update?: InputMaybe<AnalysisUpdateWithoutAnalysisValueInput>;
  upsert?: InputMaybe<AnalysisUpsertWithoutAnalysisValueInput>;
};

export type AnalysisUpdateOneRequiredWithoutInputsInput = {
  connect?: InputMaybe<AnalysisWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisCreateOrConnectWithoutInputsInput>;
  create?: InputMaybe<AnalysisCreateWithoutInputsInput>;
  update?: InputMaybe<AnalysisUpdateWithoutInputsInput>;
  upsert?: InputMaybe<AnalysisUpsertWithoutInputsInput>;
};

export type AnalysisUpdateOneRequiredWithoutOutputsInput = {
  connect?: InputMaybe<AnalysisWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisCreateOrConnectWithoutOutputsInput>;
  create?: InputMaybe<AnalysisCreateWithoutOutputsInput>;
  update?: InputMaybe<AnalysisUpdateWithoutOutputsInput>;
  upsert?: InputMaybe<AnalysisUpsertWithoutOutputsInput>;
};

export type AnalysisUpdateWithWhereUniqueWithoutAnalysisSchemaInput = {
  data: AnalysisUpdateWithoutAnalysisSchemaInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisUpdateWithWhereUniqueWithoutCreatorInput = {
  data: AnalysisUpdateWithoutCreatorInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisUpdateWithoutAnalysisSchemaInput = {
  AnalysisValue?: InputMaybe<AnalysisValueUpdateManyWithoutAnalysisInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutAnalysesInput>;
  endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  inputs?: InputMaybe<AnalysisInputUpdateManyWithoutAnalysisInput>;
  logs?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  outputs?: InputMaybe<AnalysisOutputUpdateManyWithoutAnalysisInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAnalysisStatusFieldUpdateOperationsInput>;
  wantsNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AnalysisUpdateWithoutAnalysisValueInput = {
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutAnalysisInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutAnalysesInput>;
  endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  inputs?: InputMaybe<AnalysisInputUpdateManyWithoutAnalysisInput>;
  logs?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  outputs?: InputMaybe<AnalysisOutputUpdateManyWithoutAnalysisInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAnalysisStatusFieldUpdateOperationsInput>;
  wantsNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AnalysisUpdateWithoutCreatorInput = {
  AnalysisValue?: InputMaybe<AnalysisValueUpdateManyWithoutAnalysisInput>;
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutAnalysisInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  inputs?: InputMaybe<AnalysisInputUpdateManyWithoutAnalysisInput>;
  logs?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  outputs?: InputMaybe<AnalysisOutputUpdateManyWithoutAnalysisInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAnalysisStatusFieldUpdateOperationsInput>;
  wantsNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AnalysisUpdateWithoutInputsInput = {
  AnalysisValue?: InputMaybe<AnalysisValueUpdateManyWithoutAnalysisInput>;
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutAnalysisInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutAnalysesInput>;
  endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  logs?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  outputs?: InputMaybe<AnalysisOutputUpdateManyWithoutAnalysisInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAnalysisStatusFieldUpdateOperationsInput>;
  wantsNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AnalysisUpdateWithoutOutputsInput = {
  AnalysisValue?: InputMaybe<AnalysisValueUpdateManyWithoutAnalysisInput>;
  analysisSchema?: InputMaybe<AnalysisSchemaUpdateOneRequiredWithoutAnalysisInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creator?: InputMaybe<UserUpdateOneRequiredWithoutAnalysesInput>;
  endedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  inputs?: InputMaybe<AnalysisInputUpdateManyWithoutAnalysisInput>;
  logs?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  startedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAnalysisStatusFieldUpdateOperationsInput>;
  wantsNotification?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AnalysisUpsertWithWhereUniqueWithoutAnalysisSchemaInput = {
  create: AnalysisCreateWithoutAnalysisSchemaInput;
  update: AnalysisUpdateWithoutAnalysisSchemaInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisUpsertWithWhereUniqueWithoutCreatorInput = {
  create: AnalysisCreateWithoutCreatorInput;
  update: AnalysisUpdateWithoutCreatorInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisUpsertWithoutAnalysisValueInput = {
  create: AnalysisCreateWithoutAnalysisValueInput;
  update: AnalysisUpdateWithoutAnalysisValueInput;
};

export type AnalysisUpsertWithoutInputsInput = {
  create: AnalysisCreateWithoutInputsInput;
  update: AnalysisUpdateWithoutInputsInput;
};

export type AnalysisUpsertWithoutOutputsInput = {
  create: AnalysisCreateWithoutOutputsInput;
  update: AnalysisUpdateWithoutOutputsInput;
};

export type AnalysisValue = {
  __typename?: 'AnalysisValue';
  _count: AnalysisValueCount;
  analysis: Analysis;
  analysisId: Scalars['Int'];
  analysisInputs?: Maybe<Array<AnalysisInput>>;
  analysisOutputs?: Maybe<Array<AnalysisOutput>>;
  id: Scalars['Int'];
  value: Scalars['JSON'];
};

export type AnalysisValueCount = {
  __typename?: 'AnalysisValueCount';
  analysisInputs: Scalars['Int'];
  analysisOutputs: Scalars['Int'];
};

export type AnalysisValueCreateManyAnalysisInput = {
  id?: InputMaybe<Scalars['Int']>;
  value: Scalars['JSON'];
};

export type AnalysisValueCreateManyAnalysisInputEnvelope = {
  data: Array<AnalysisValueCreateManyAnalysisInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisValueCreateNestedManyWithoutAnalysisInput = {
  connect?: InputMaybe<Array<AnalysisValueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisValueCreateOrConnectWithoutAnalysisInput>>;
  create?: InputMaybe<Array<AnalysisValueCreateWithoutAnalysisInput>>;
  createMany?: InputMaybe<AnalysisValueCreateManyAnalysisInputEnvelope>;
};

export type AnalysisValueCreateNestedOneWithoutAnalysisInputsInput = {
  connect?: InputMaybe<AnalysisValueWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisValueCreateOrConnectWithoutAnalysisInputsInput>;
  create?: InputMaybe<AnalysisValueCreateWithoutAnalysisInputsInput>;
};

export type AnalysisValueCreateNestedOneWithoutAnalysisOutputsInput = {
  connect?: InputMaybe<AnalysisValueWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisValueCreateOrConnectWithoutAnalysisOutputsInput>;
  create?: InputMaybe<AnalysisValueCreateWithoutAnalysisOutputsInput>;
};

export type AnalysisValueCreateOrConnectWithoutAnalysisInput = {
  create: AnalysisValueCreateWithoutAnalysisInput;
  where: AnalysisValueWhereUniqueInput;
};

export type AnalysisValueCreateOrConnectWithoutAnalysisInputsInput = {
  create: AnalysisValueCreateWithoutAnalysisInputsInput;
  where: AnalysisValueWhereUniqueInput;
};

export type AnalysisValueCreateOrConnectWithoutAnalysisOutputsInput = {
  create: AnalysisValueCreateWithoutAnalysisOutputsInput;
  where: AnalysisValueWhereUniqueInput;
};

export type AnalysisValueCreateWithoutAnalysisInput = {
  analysisInputs?: InputMaybe<AnalysisInputCreateNestedManyWithoutAnalysisValueInput>;
  analysisOutputs?: InputMaybe<AnalysisOutputCreateNestedManyWithoutAnalysisValueInput>;
  value: Scalars['JSON'];
};

export type AnalysisValueCreateWithoutAnalysisInputsInput = {
  analysis: AnalysisCreateNestedOneWithoutAnalysisValueInput;
  analysisOutputs?: InputMaybe<AnalysisOutputCreateNestedManyWithoutAnalysisValueInput>;
  value: Scalars['JSON'];
};

export type AnalysisValueCreateWithoutAnalysisOutputsInput = {
  analysis: AnalysisCreateNestedOneWithoutAnalysisValueInput;
  analysisInputs?: InputMaybe<AnalysisInputCreateNestedManyWithoutAnalysisValueInput>;
  value: Scalars['JSON'];
};

export type AnalysisValueScalarWhereInput = {
  AND?: InputMaybe<Array<AnalysisValueScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnalysisValueScalarWhereInput>>;
  OR?: InputMaybe<Array<AnalysisValueScalarWhereInput>>;
  analysisId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  value?: InputMaybe<JsonFilter>;
};

export type AnalysisValueUpdateManyMutationInput = {
  value?: InputMaybe<Scalars['JSON']>;
};

export type AnalysisValueUpdateManyWithWhereWithoutAnalysisInput = {
  data: AnalysisValueUpdateManyMutationInput;
  where: AnalysisValueScalarWhereInput;
};

export type AnalysisValueUpdateManyWithoutAnalysisInput = {
  connect?: InputMaybe<Array<AnalysisValueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnalysisValueCreateOrConnectWithoutAnalysisInput>>;
  create?: InputMaybe<Array<AnalysisValueCreateWithoutAnalysisInput>>;
  createMany?: InputMaybe<AnalysisValueCreateManyAnalysisInputEnvelope>;
  delete?: InputMaybe<Array<AnalysisValueWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnalysisValueScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnalysisValueWhereUniqueInput>>;
  set?: InputMaybe<Array<AnalysisValueWhereUniqueInput>>;
  update?: InputMaybe<Array<AnalysisValueUpdateWithWhereUniqueWithoutAnalysisInput>>;
  updateMany?: InputMaybe<Array<AnalysisValueUpdateManyWithWhereWithoutAnalysisInput>>;
  upsert?: InputMaybe<Array<AnalysisValueUpsertWithWhereUniqueWithoutAnalysisInput>>;
};

export type AnalysisValueUpdateOneRequiredWithoutAnalysisInputsInput = {
  connect?: InputMaybe<AnalysisValueWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisValueCreateOrConnectWithoutAnalysisInputsInput>;
  create?: InputMaybe<AnalysisValueCreateWithoutAnalysisInputsInput>;
  update?: InputMaybe<AnalysisValueUpdateWithoutAnalysisInputsInput>;
  upsert?: InputMaybe<AnalysisValueUpsertWithoutAnalysisInputsInput>;
};

export type AnalysisValueUpdateOneWithoutAnalysisOutputsInput = {
  connect?: InputMaybe<AnalysisValueWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnalysisValueCreateOrConnectWithoutAnalysisOutputsInput>;
  create?: InputMaybe<AnalysisValueCreateWithoutAnalysisOutputsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<AnalysisValueUpdateWithoutAnalysisOutputsInput>;
  upsert?: InputMaybe<AnalysisValueUpsertWithoutAnalysisOutputsInput>;
};

export type AnalysisValueUpdateWithWhereUniqueWithoutAnalysisInput = {
  data: AnalysisValueUpdateWithoutAnalysisInput;
  where: AnalysisValueWhereUniqueInput;
};

export type AnalysisValueUpdateWithoutAnalysisInput = {
  analysisInputs?: InputMaybe<AnalysisInputUpdateManyWithoutAnalysisValueInput>;
  analysisOutputs?: InputMaybe<AnalysisOutputUpdateManyWithoutAnalysisValueInput>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type AnalysisValueUpdateWithoutAnalysisInputsInput = {
  analysis?: InputMaybe<AnalysisUpdateOneRequiredWithoutAnalysisValueInput>;
  analysisOutputs?: InputMaybe<AnalysisOutputUpdateManyWithoutAnalysisValueInput>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type AnalysisValueUpdateWithoutAnalysisOutputsInput = {
  analysis?: InputMaybe<AnalysisUpdateOneRequiredWithoutAnalysisValueInput>;
  analysisInputs?: InputMaybe<AnalysisInputUpdateManyWithoutAnalysisValueInput>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type AnalysisValueUpsertWithWhereUniqueWithoutAnalysisInput = {
  create: AnalysisValueCreateWithoutAnalysisInput;
  update: AnalysisValueUpdateWithoutAnalysisInput;
  where: AnalysisValueWhereUniqueInput;
};

export type AnalysisValueUpsertWithoutAnalysisInputsInput = {
  create: AnalysisValueCreateWithoutAnalysisInputsInput;
  update: AnalysisValueUpdateWithoutAnalysisInputsInput;
};

export type AnalysisValueUpsertWithoutAnalysisOutputsInput = {
  create: AnalysisValueCreateWithoutAnalysisOutputsInput;
  update: AnalysisValueUpdateWithoutAnalysisOutputsInput;
};

export type AnalysisValueWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type AnalysisWhereUniqueInput = {
  analysisCreatorNameUnique?: InputMaybe<AnalysisAnalysisCreatorNameUniqueCompoundUniqueInput>;
  id?: InputMaybe<Scalars['Int']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type Chat = {
  __typename?: 'Chat';
  _count: ChatCount;
  id: Scalars['Int'];
  lab: Lab;
  labId: Scalars['Int'];
  messages?: Maybe<Array<ChatMessage>>;
  user: User;
  userId: Scalars['Int'];
};

export type ChatCount = {
  __typename?: 'ChatCount';
  messages: Scalars['Int'];
};

export type ChatCreateManyLabInput = {
  id?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type ChatCreateManyLabInputEnvelope = {
  data: Array<ChatCreateManyLabInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ChatCreateManyUserInput = {
  id?: InputMaybe<Scalars['Int']>;
  labId: Scalars['Int'];
};

export type ChatCreateManyUserInputEnvelope = {
  data: Array<ChatCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ChatCreateNestedManyWithoutLabInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutLabInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutLabInput>>;
  createMany?: InputMaybe<ChatCreateManyLabInputEnvelope>;
};

export type ChatCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutUserInput>>;
  createMany?: InputMaybe<ChatCreateManyUserInputEnvelope>;
};

export type ChatCreateOrConnectWithoutLabInput = {
  create: ChatCreateWithoutLabInput;
  where: ChatWhereUniqueInput;
};

export type ChatCreateOrConnectWithoutUserInput = {
  create: ChatCreateWithoutUserInput;
  where: ChatWhereUniqueInput;
};

export type ChatCreateWithoutLabInput = {
  messages?: InputMaybe<ChatMessageCreateNestedManyWithoutChatInput>;
  user: UserCreateNestedOneWithoutChatsInput;
};

export type ChatCreateWithoutUserInput = {
  lab: LabCreateNestedOneWithoutChatsInput;
  messages?: InputMaybe<ChatMessageCreateNestedManyWithoutChatInput>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  chat: Chat;
  chatId: Scalars['Int'];
  content: Scalars['String'];
  id: Scalars['Int'];
  isBot: Scalars['Boolean'];
  time: Scalars['DateTime'];
  unhelpful: Scalars['Boolean'];
};

export type ChatMessageCreateManyChatInput = {
  content: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  isBot?: InputMaybe<Scalars['Boolean']>;
  time?: InputMaybe<Scalars['DateTime']>;
  unhelpful?: InputMaybe<Scalars['Boolean']>;
};

export type ChatMessageCreateManyChatInputEnvelope = {
  data: Array<ChatMessageCreateManyChatInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ChatMessageCreateNestedManyWithoutChatInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutChatInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutChatInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyChatInputEnvelope>;
};

export type ChatMessageCreateOrConnectWithoutChatInput = {
  create: ChatMessageCreateWithoutChatInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageCreateWithoutChatInput = {
  content: Scalars['String'];
  isBot?: InputMaybe<Scalars['Boolean']>;
  time?: InputMaybe<Scalars['DateTime']>;
  unhelpful?: InputMaybe<Scalars['Boolean']>;
};

export type ChatMessageScalarWhereInput = {
  AND?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  OR?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  chatId?: InputMaybe<IntFilter>;
  content?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isBot?: InputMaybe<BoolFilter>;
  time?: InputMaybe<DateTimeFilter>;
  unhelpful?: InputMaybe<BoolFilter>;
};

export type ChatMessageUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  isBot?: InputMaybe<BoolFieldUpdateOperationsInput>;
  time?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unhelpful?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ChatMessageUpdateManyWithWhereWithoutChatInput = {
  data: ChatMessageUpdateManyMutationInput;
  where: ChatMessageScalarWhereInput;
};

export type ChatMessageUpdateManyWithoutChatInput = {
  connect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatMessageCreateOrConnectWithoutChatInput>>;
  create?: InputMaybe<Array<ChatMessageCreateWithoutChatInput>>;
  createMany?: InputMaybe<ChatMessageCreateManyChatInputEnvelope>;
  delete?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatMessageUpdateWithWhereUniqueWithoutChatInput>>;
  updateMany?: InputMaybe<Array<ChatMessageUpdateManyWithWhereWithoutChatInput>>;
  upsert?: InputMaybe<Array<ChatMessageUpsertWithWhereUniqueWithoutChatInput>>;
};

export type ChatMessageUpdateWithWhereUniqueWithoutChatInput = {
  data: ChatMessageUpdateWithoutChatInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageUpdateWithoutChatInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>;
  isBot?: InputMaybe<BoolFieldUpdateOperationsInput>;
  time?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  unhelpful?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ChatMessageUpsertWithWhereUniqueWithoutChatInput = {
  create: ChatMessageCreateWithoutChatInput;
  update: ChatMessageUpdateWithoutChatInput;
  where: ChatMessageWhereUniqueInput;
};

export type ChatMessageWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ChatScalarWhereInput = {
  AND?: InputMaybe<Array<ChatScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChatScalarWhereInput>>;
  OR?: InputMaybe<Array<ChatScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  labId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type ChatUncheckedUpdateManyWithoutChatsInput = {
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  labId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ChatUpdateManyWithWhereWithoutLabInput = {
  data: ChatUncheckedUpdateManyWithoutChatsInput;
  where: ChatScalarWhereInput;
};

export type ChatUpdateManyWithWhereWithoutUserInput = {
  data: ChatUncheckedUpdateManyWithoutChatsInput;
  where: ChatScalarWhereInput;
};

export type ChatUpdateManyWithoutLabInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutLabInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutLabInput>>;
  createMany?: InputMaybe<ChatCreateManyLabInputEnvelope>;
  delete?: InputMaybe<Array<ChatWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatUpdateWithWhereUniqueWithoutLabInput>>;
  updateMany?: InputMaybe<Array<ChatUpdateManyWithWhereWithoutLabInput>>;
  upsert?: InputMaybe<Array<ChatUpsertWithWhereUniqueWithoutLabInput>>;
};

export type ChatUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ChatCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ChatCreateWithoutUserInput>>;
  createMany?: InputMaybe<ChatCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ChatWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChatScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChatWhereUniqueInput>>;
  set?: InputMaybe<Array<ChatWhereUniqueInput>>;
  update?: InputMaybe<Array<ChatUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ChatUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ChatUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ChatUpdateWithWhereUniqueWithoutLabInput = {
  data: ChatUpdateWithoutLabInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpdateWithWhereUniqueWithoutUserInput = {
  data: ChatUpdateWithoutUserInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpdateWithoutLabInput = {
  messages?: InputMaybe<ChatMessageUpdateManyWithoutChatInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutChatsInput>;
};

export type ChatUpdateWithoutUserInput = {
  lab?: InputMaybe<LabUpdateOneRequiredWithoutChatsInput>;
  messages?: InputMaybe<ChatMessageUpdateManyWithoutChatInput>;
};

export type ChatUpsertWithWhereUniqueWithoutLabInput = {
  create: ChatCreateWithoutLabInput;
  update: ChatUpdateWithoutLabInput;
  where: ChatWhereUniqueInput;
};

export type ChatUpsertWithWhereUniqueWithoutUserInput = {
  create: ChatCreateWithoutUserInput;
  update: ChatUpdateWithoutUserInput;
  where: ChatWhereUniqueInput;
};

export type ChatWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type CloudFormationStack = {
  __typename?: 'CloudFormationStack';
  _count: CloudFormationStackCount;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  labs?: Maybe<Array<Lab>>;
  name: Scalars['String'];
  resources?: Maybe<Array<CloudFormationStackResource>>;
  users?: Maybe<Array<User>>;
};

export type CloudFormationStackCount = {
  __typename?: 'CloudFormationStackCount';
  labs: Scalars['Int'];
  resources: Scalars['Int'];
  users: Scalars['Int'];
};

export type CloudFormationStackCreateNestedOneWithoutLabsInput = {
  connect?: InputMaybe<CloudFormationStackWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CloudFormationStackCreateOrConnectWithoutLabsInput>;
  create?: InputMaybe<CloudFormationStackCreateWithoutLabsInput>;
};

export type CloudFormationStackCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<CloudFormationStackWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CloudFormationStackCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<CloudFormationStackCreateWithoutUsersInput>;
};

export type CloudFormationStackCreateOrConnectWithoutLabsInput = {
  create: CloudFormationStackCreateWithoutLabsInput;
  where: CloudFormationStackWhereUniqueInput;
};

export type CloudFormationStackCreateOrConnectWithoutUsersInput = {
  create: CloudFormationStackCreateWithoutUsersInput;
  where: CloudFormationStackWhereUniqueInput;
};

export type CloudFormationStackCreateWithoutLabsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  resources?: InputMaybe<CloudFormationStackResourceCreateNestedManyWithoutCloudFormationStackInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutCloudFormationStackInput>;
};

export type CloudFormationStackCreateWithoutUsersInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  labs?: InputMaybe<LabCreateNestedManyWithoutCloudFormationStackInput>;
  name: Scalars['String'];
  resources?: InputMaybe<CloudFormationStackResourceCreateNestedManyWithoutCloudFormationStackInput>;
};

export type CloudFormationStackResource = {
  __typename?: 'CloudFormationStackResource';
  cloudFormationStack: CloudFormationStack;
  cloudFormationStackId: Scalars['Int'];
  id: Scalars['Int'];
  logicalResourceId: Scalars['String'];
  physicalResourceId: Scalars['String'];
  resourceType: Scalars['String'];
};

export type CloudFormationStackResourceCreateManyCloudFormationStackInput = {
  id?: InputMaybe<Scalars['Int']>;
  logicalResourceId: Scalars['String'];
  physicalResourceId: Scalars['String'];
  resourceType: Scalars['String'];
};

export type CloudFormationStackResourceCreateManyCloudFormationStackInputEnvelope = {
  data: Array<CloudFormationStackResourceCreateManyCloudFormationStackInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CloudFormationStackResourceCreateNestedManyWithoutCloudFormationStackInput = {
  connect?: InputMaybe<Array<CloudFormationStackResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CloudFormationStackResourceCreateOrConnectWithoutCloudFormationStackInput>>;
  create?: InputMaybe<Array<CloudFormationStackResourceCreateWithoutCloudFormationStackInput>>;
  createMany?: InputMaybe<CloudFormationStackResourceCreateManyCloudFormationStackInputEnvelope>;
};

export type CloudFormationStackResourceCreateOrConnectWithoutCloudFormationStackInput = {
  create: CloudFormationStackResourceCreateWithoutCloudFormationStackInput;
  where: CloudFormationStackResourceWhereUniqueInput;
};

export type CloudFormationStackResourceCreateWithoutCloudFormationStackInput = {
  logicalResourceId: Scalars['String'];
  physicalResourceId: Scalars['String'];
  resourceType: Scalars['String'];
};

export type CloudFormationStackResourceScalarWhereInput = {
  AND?: InputMaybe<Array<CloudFormationStackResourceScalarWhereInput>>;
  NOT?: InputMaybe<Array<CloudFormationStackResourceScalarWhereInput>>;
  OR?: InputMaybe<Array<CloudFormationStackResourceScalarWhereInput>>;
  cloudFormationStackId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  logicalResourceId?: InputMaybe<StringFilter>;
  physicalResourceId?: InputMaybe<StringFilter>;
  resourceType?: InputMaybe<StringFilter>;
};

export type CloudFormationStackResourceUpdateManyMutationInput = {
  logicalResourceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalResourceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CloudFormationStackResourceUpdateManyWithWhereWithoutCloudFormationStackInput = {
  data: CloudFormationStackResourceUpdateManyMutationInput;
  where: CloudFormationStackResourceScalarWhereInput;
};

export type CloudFormationStackResourceUpdateManyWithoutCloudFormationStackInput = {
  connect?: InputMaybe<Array<CloudFormationStackResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CloudFormationStackResourceCreateOrConnectWithoutCloudFormationStackInput>>;
  create?: InputMaybe<Array<CloudFormationStackResourceCreateWithoutCloudFormationStackInput>>;
  createMany?: InputMaybe<CloudFormationStackResourceCreateManyCloudFormationStackInputEnvelope>;
  delete?: InputMaybe<Array<CloudFormationStackResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CloudFormationStackResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CloudFormationStackResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<CloudFormationStackResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<CloudFormationStackResourceUpdateWithWhereUniqueWithoutCloudFormationStackInput>>;
  updateMany?: InputMaybe<Array<CloudFormationStackResourceUpdateManyWithWhereWithoutCloudFormationStackInput>>;
  upsert?: InputMaybe<Array<CloudFormationStackResourceUpsertWithWhereUniqueWithoutCloudFormationStackInput>>;
};

export type CloudFormationStackResourceUpdateWithWhereUniqueWithoutCloudFormationStackInput = {
  data: CloudFormationStackResourceUpdateWithoutCloudFormationStackInput;
  where: CloudFormationStackResourceWhereUniqueInput;
};

export type CloudFormationStackResourceUpdateWithoutCloudFormationStackInput = {
  logicalResourceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  physicalResourceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CloudFormationStackResourceUpsertWithWhereUniqueWithoutCloudFormationStackInput = {
  create: CloudFormationStackResourceCreateWithoutCloudFormationStackInput;
  update: CloudFormationStackResourceUpdateWithoutCloudFormationStackInput;
  where: CloudFormationStackResourceWhereUniqueInput;
};

export type CloudFormationStackResourceWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  physicalResourceId?: InputMaybe<Scalars['String']>;
};

export type CloudFormationStackUpdateOneWithoutLabsInput = {
  connect?: InputMaybe<CloudFormationStackWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CloudFormationStackCreateOrConnectWithoutLabsInput>;
  create?: InputMaybe<CloudFormationStackCreateWithoutLabsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CloudFormationStackUpdateWithoutLabsInput>;
  upsert?: InputMaybe<CloudFormationStackUpsertWithoutLabsInput>;
};

export type CloudFormationStackUpdateOneWithoutUsersInput = {
  connect?: InputMaybe<CloudFormationStackWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CloudFormationStackCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<CloudFormationStackCreateWithoutUsersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CloudFormationStackUpdateWithoutUsersInput>;
  upsert?: InputMaybe<CloudFormationStackUpsertWithoutUsersInput>;
};

export type CloudFormationStackUpdateWithoutLabsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resources?: InputMaybe<CloudFormationStackResourceUpdateManyWithoutCloudFormationStackInput>;
  users?: InputMaybe<UserUpdateManyWithoutCloudFormationStackInput>;
};

export type CloudFormationStackUpdateWithoutUsersInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  labs?: InputMaybe<LabUpdateManyWithoutCloudFormationStackInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resources?: InputMaybe<CloudFormationStackResourceUpdateManyWithoutCloudFormationStackInput>;
};

export type CloudFormationStackUpsertWithoutLabsInput = {
  create: CloudFormationStackCreateWithoutLabsInput;
  update: CloudFormationStackUpdateWithoutLabsInput;
};

export type CloudFormationStackUpsertWithoutUsersInput = {
  create: CloudFormationStackCreateWithoutUsersInput;
  update: CloudFormationStackUpdateWithoutUsersInput;
};

export type CloudFormationStackWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateActionResponse = {
  __typename?: 'CreateActionResponse';
  action?: Maybe<Action>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateAnalysesFromTableInput = {
  analysisSchemaId: Scalars['Float'];
  table: Scalars['String'];
};

export type CreateAnalysesFromTableResponse = {
  __typename?: 'CreateAnalysesFromTableResponse';
  analyses?: Maybe<Array<Analysis>>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateAnalysisInput = {
  analysisSchemaId: Scalars['Float'];
  name: Scalars['String'];
  values: Array<CreateAnalysisInputValue>;
};

export type CreateAnalysisInputValue = {
  analysisSchemaInputId: Scalars['Float'];
  value: Scalars['String'];
};

export type CreateAnalysisResponse = {
  __typename?: 'CreateAnalysisResponse';
  analysis?: Maybe<Analysis>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateCliTokenResponse = {
  __typename?: 'CreateCliTokenResponse';
  token: Scalars['String'];
};

export type CreateLabResponse = {
  __typename?: 'CreateLabResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  jobId?: Maybe<Scalars['ID']>;
  lab?: Maybe<Lab>;
};

export type DataSource = {
  __typename?: 'DataSource';
  _count: DataSourceCount;
  dataSourceSubscription?: Maybe<Array<DataSourceSubscription>>;
  id: Scalars['Int'];
  isSubscribed: Scalars['Boolean'];
  name: Scalars['String'];
  s3Bucket: S3Bucket;
  s3BucketId: Scalars['Int'];
};

export type DataSourceCount = {
  __typename?: 'DataSourceCount';
  dataSourceSubscription: Scalars['Int'];
};

export type DataSourceCreateManyS3BucketInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type DataSourceCreateManyS3BucketInputEnvelope = {
  data: Array<DataSourceCreateManyS3BucketInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DataSourceCreateNestedManyWithoutS3BucketInput = {
  connect?: InputMaybe<Array<DataSourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceCreateOrConnectWithoutS3BucketInput>>;
  create?: InputMaybe<Array<DataSourceCreateWithoutS3BucketInput>>;
  createMany?: InputMaybe<DataSourceCreateManyS3BucketInputEnvelope>;
};

export type DataSourceCreateNestedOneWithoutDataSourceSubscriptionInput = {
  connect?: InputMaybe<DataSourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataSourceCreateOrConnectWithoutDataSourceSubscriptionInput>;
  create?: InputMaybe<DataSourceCreateWithoutDataSourceSubscriptionInput>;
};

export type DataSourceCreateOrConnectWithoutDataSourceSubscriptionInput = {
  create: DataSourceCreateWithoutDataSourceSubscriptionInput;
  where: DataSourceWhereUniqueInput;
};

export type DataSourceCreateOrConnectWithoutS3BucketInput = {
  create: DataSourceCreateWithoutS3BucketInput;
  where: DataSourceWhereUniqueInput;
};

export type DataSourceCreateWithoutDataSourceSubscriptionInput = {
  name: Scalars['String'];
  s3Bucket: S3BucketCreateNestedOneWithoutDataSourcesInput;
};

export type DataSourceCreateWithoutS3BucketInput = {
  dataSourceSubscription?: InputMaybe<DataSourceSubscriptionCreateNestedManyWithoutDataSourceInput>;
  name: Scalars['String'];
};

export type DataSourceNotification = {
  __typename?: 'DataSourceNotification';
  dataCreatedAt: Scalars['DateTime'];
  dataSourceSubscription: DataSourceSubscription;
  dataSourceSubscriptionId: Scalars['Int'];
  id: Scalars['Int'];
};

export type DataSourceNotificationCreateManyDataSourceSubscriptionInput = {
  dataCreatedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type DataSourceNotificationCreateManyDataSourceSubscriptionInputEnvelope = {
  data: Array<DataSourceNotificationCreateManyDataSourceSubscriptionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DataSourceNotificationCreateNestedManyWithoutDataSourceSubscriptionInput = {
  connect?: InputMaybe<Array<DataSourceNotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceNotificationCreateOrConnectWithoutDataSourceSubscriptionInput>>;
  create?: InputMaybe<Array<DataSourceNotificationCreateWithoutDataSourceSubscriptionInput>>;
  createMany?: InputMaybe<DataSourceNotificationCreateManyDataSourceSubscriptionInputEnvelope>;
};

export type DataSourceNotificationCreateOrConnectWithoutDataSourceSubscriptionInput = {
  create: DataSourceNotificationCreateWithoutDataSourceSubscriptionInput;
  where: DataSourceNotificationWhereUniqueInput;
};

export type DataSourceNotificationCreateWithoutDataSourceSubscriptionInput = {
  dataCreatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DataSourceNotificationScalarWhereInput = {
  AND?: InputMaybe<Array<DataSourceNotificationScalarWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceNotificationScalarWhereInput>>;
  OR?: InputMaybe<Array<DataSourceNotificationScalarWhereInput>>;
  dataCreatedAt?: InputMaybe<DateTimeFilter>;
  dataSourceSubscriptionId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type DataSourceNotificationUpdateManyMutationInput = {
  dataCreatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataSourceNotificationUpdateManyWithWhereWithoutDataSourceSubscriptionInput = {
  data: DataSourceNotificationUpdateManyMutationInput;
  where: DataSourceNotificationScalarWhereInput;
};

export type DataSourceNotificationUpdateManyWithoutDataSourceSubscriptionInput = {
  connect?: InputMaybe<Array<DataSourceNotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceNotificationCreateOrConnectWithoutDataSourceSubscriptionInput>>;
  create?: InputMaybe<Array<DataSourceNotificationCreateWithoutDataSourceSubscriptionInput>>;
  createMany?: InputMaybe<DataSourceNotificationCreateManyDataSourceSubscriptionInputEnvelope>;
  delete?: InputMaybe<Array<DataSourceNotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataSourceNotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataSourceNotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<DataSourceNotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<DataSourceNotificationUpdateWithWhereUniqueWithoutDataSourceSubscriptionInput>>;
  updateMany?: InputMaybe<Array<DataSourceNotificationUpdateManyWithWhereWithoutDataSourceSubscriptionInput>>;
  upsert?: InputMaybe<Array<DataSourceNotificationUpsertWithWhereUniqueWithoutDataSourceSubscriptionInput>>;
};

export type DataSourceNotificationUpdateWithWhereUniqueWithoutDataSourceSubscriptionInput = {
  data: DataSourceNotificationUpdateWithoutDataSourceSubscriptionInput;
  where: DataSourceNotificationWhereUniqueInput;
};

export type DataSourceNotificationUpdateWithoutDataSourceSubscriptionInput = {
  dataCreatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DataSourceNotificationUpsertWithWhereUniqueWithoutDataSourceSubscriptionInput = {
  create: DataSourceNotificationCreateWithoutDataSourceSubscriptionInput;
  update: DataSourceNotificationUpdateWithoutDataSourceSubscriptionInput;
  where: DataSourceNotificationWhereUniqueInput;
};

export type DataSourceNotificationWhereUniqueInput = {
  dataSourceSubscriptionId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type DataSourceScalarWhereInput = {
  AND?: InputMaybe<Array<DataSourceScalarWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceScalarWhereInput>>;
  OR?: InputMaybe<Array<DataSourceScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  s3BucketId?: InputMaybe<IntFilter>;
};

export type DataSourceSubscription = {
  __typename?: 'DataSourceSubscription';
  _count: DataSourceSubscriptionCount;
  dataSource: DataSource;
  dataSourceId: Scalars['Int'];
  dataSourceNotification?: Maybe<Array<DataSourceNotification>>;
  id: Scalars['Int'];
  user: User;
  userId: Scalars['Int'];
  wantsNotifications: Scalars['Boolean'];
};

export type DataSourceSubscriptionCount = {
  __typename?: 'DataSourceSubscriptionCount';
  dataSourceNotification: Scalars['Int'];
};

export type DataSourceSubscriptionCreateManyDataSourceInput = {
  id?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  wantsNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type DataSourceSubscriptionCreateManyDataSourceInputEnvelope = {
  data: Array<DataSourceSubscriptionCreateManyDataSourceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DataSourceSubscriptionCreateManyUserInput = {
  dataSourceId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  wantsNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type DataSourceSubscriptionCreateManyUserInputEnvelope = {
  data: Array<DataSourceSubscriptionCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DataSourceSubscriptionCreateNestedManyWithoutDataSourceInput = {
  connect?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceSubscriptionCreateOrConnectWithoutDataSourceInput>>;
  create?: InputMaybe<Array<DataSourceSubscriptionCreateWithoutDataSourceInput>>;
  createMany?: InputMaybe<DataSourceSubscriptionCreateManyDataSourceInputEnvelope>;
};

export type DataSourceSubscriptionCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceSubscriptionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DataSourceSubscriptionCreateWithoutUserInput>>;
  createMany?: InputMaybe<DataSourceSubscriptionCreateManyUserInputEnvelope>;
};

export type DataSourceSubscriptionCreateOrConnectWithoutDataSourceInput = {
  create: DataSourceSubscriptionCreateWithoutDataSourceInput;
  where: DataSourceSubscriptionWhereUniqueInput;
};

export type DataSourceSubscriptionCreateOrConnectWithoutUserInput = {
  create: DataSourceSubscriptionCreateWithoutUserInput;
  where: DataSourceSubscriptionWhereUniqueInput;
};

export type DataSourceSubscriptionCreateWithoutDataSourceInput = {
  dataSourceNotification?: InputMaybe<DataSourceNotificationCreateNestedManyWithoutDataSourceSubscriptionInput>;
  user: UserCreateNestedOneWithoutDataSourceSubscriptionsInput;
  wantsNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type DataSourceSubscriptionCreateWithoutUserInput = {
  dataSource: DataSourceCreateNestedOneWithoutDataSourceSubscriptionInput;
  dataSourceNotification?: InputMaybe<DataSourceNotificationCreateNestedManyWithoutDataSourceSubscriptionInput>;
  wantsNotifications?: InputMaybe<Scalars['Boolean']>;
};

export type DataSourceSubscriptionScalarWhereInput = {
  AND?: InputMaybe<Array<DataSourceSubscriptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<DataSourceSubscriptionScalarWhereInput>>;
  OR?: InputMaybe<Array<DataSourceSubscriptionScalarWhereInput>>;
  dataSourceId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
  wantsNotifications?: InputMaybe<BoolFilter>;
};

export type DataSourceSubscriptionUpdateManyMutationInput = {
  wantsNotifications?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DataSourceSubscriptionUpdateManyWithWhereWithoutDataSourceInput = {
  data: DataSourceSubscriptionUpdateManyMutationInput;
  where: DataSourceSubscriptionScalarWhereInput;
};

export type DataSourceSubscriptionUpdateManyWithWhereWithoutUserInput = {
  data: DataSourceSubscriptionUpdateManyMutationInput;
  where: DataSourceSubscriptionScalarWhereInput;
};

export type DataSourceSubscriptionUpdateManyWithoutDataSourceInput = {
  connect?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceSubscriptionCreateOrConnectWithoutDataSourceInput>>;
  create?: InputMaybe<Array<DataSourceSubscriptionCreateWithoutDataSourceInput>>;
  createMany?: InputMaybe<DataSourceSubscriptionCreateManyDataSourceInputEnvelope>;
  delete?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataSourceSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DataSourceSubscriptionUpdateWithWhereUniqueWithoutDataSourceInput>>;
  updateMany?: InputMaybe<Array<DataSourceSubscriptionUpdateManyWithWhereWithoutDataSourceInput>>;
  upsert?: InputMaybe<Array<DataSourceSubscriptionUpsertWithWhereUniqueWithoutDataSourceInput>>;
};

export type DataSourceSubscriptionUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceSubscriptionCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DataSourceSubscriptionCreateWithoutUserInput>>;
  createMany?: InputMaybe<DataSourceSubscriptionCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataSourceSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DataSourceSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DataSourceSubscriptionUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<DataSourceSubscriptionUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<DataSourceSubscriptionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type DataSourceSubscriptionUpdateWithWhereUniqueWithoutDataSourceInput = {
  data: DataSourceSubscriptionUpdateWithoutDataSourceInput;
  where: DataSourceSubscriptionWhereUniqueInput;
};

export type DataSourceSubscriptionUpdateWithWhereUniqueWithoutUserInput = {
  data: DataSourceSubscriptionUpdateWithoutUserInput;
  where: DataSourceSubscriptionWhereUniqueInput;
};

export type DataSourceSubscriptionUpdateWithoutDataSourceInput = {
  dataSourceNotification?: InputMaybe<DataSourceNotificationUpdateManyWithoutDataSourceSubscriptionInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutDataSourceSubscriptionsInput>;
  wantsNotifications?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DataSourceSubscriptionUpdateWithoutUserInput = {
  dataSource?: InputMaybe<DataSourceUpdateOneRequiredWithoutDataSourceSubscriptionInput>;
  dataSourceNotification?: InputMaybe<DataSourceNotificationUpdateManyWithoutDataSourceSubscriptionInput>;
  wantsNotifications?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DataSourceSubscriptionUpsertWithWhereUniqueWithoutDataSourceInput = {
  create: DataSourceSubscriptionCreateWithoutDataSourceInput;
  update: DataSourceSubscriptionUpdateWithoutDataSourceInput;
  where: DataSourceSubscriptionWhereUniqueInput;
};

export type DataSourceSubscriptionUpsertWithWhereUniqueWithoutUserInput = {
  create: DataSourceSubscriptionCreateWithoutUserInput;
  update: DataSourceSubscriptionUpdateWithoutUserInput;
  where: DataSourceSubscriptionWhereUniqueInput;
};

export type DataSourceSubscriptionUserDatasourceUniqueCompoundUniqueInput = {
  dataSourceId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type DataSourceSubscriptionWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  userDatasourceUnique?: InputMaybe<DataSourceSubscriptionUserDatasourceUniqueCompoundUniqueInput>;
};

export type DataSourceUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DataSourceUpdateManyWithWhereWithoutS3BucketInput = {
  data: DataSourceUpdateManyMutationInput;
  where: DataSourceScalarWhereInput;
};

export type DataSourceUpdateManyWithoutS3BucketInput = {
  connect?: InputMaybe<Array<DataSourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DataSourceCreateOrConnectWithoutS3BucketInput>>;
  create?: InputMaybe<Array<DataSourceCreateWithoutS3BucketInput>>;
  createMany?: InputMaybe<DataSourceCreateManyS3BucketInputEnvelope>;
  delete?: InputMaybe<Array<DataSourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DataSourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DataSourceWhereUniqueInput>>;
  set?: InputMaybe<Array<DataSourceWhereUniqueInput>>;
  update?: InputMaybe<Array<DataSourceUpdateWithWhereUniqueWithoutS3BucketInput>>;
  updateMany?: InputMaybe<Array<DataSourceUpdateManyWithWhereWithoutS3BucketInput>>;
  upsert?: InputMaybe<Array<DataSourceUpsertWithWhereUniqueWithoutS3BucketInput>>;
};

export type DataSourceUpdateOneRequiredWithoutDataSourceSubscriptionInput = {
  connect?: InputMaybe<DataSourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DataSourceCreateOrConnectWithoutDataSourceSubscriptionInput>;
  create?: InputMaybe<DataSourceCreateWithoutDataSourceSubscriptionInput>;
  update?: InputMaybe<DataSourceUpdateWithoutDataSourceSubscriptionInput>;
  upsert?: InputMaybe<DataSourceUpsertWithoutDataSourceSubscriptionInput>;
};

export type DataSourceUpdateWithWhereUniqueWithoutS3BucketInput = {
  data: DataSourceUpdateWithoutS3BucketInput;
  where: DataSourceWhereUniqueInput;
};

export type DataSourceUpdateWithoutDataSourceSubscriptionInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  s3Bucket?: InputMaybe<S3BucketUpdateOneRequiredWithoutDataSourcesInput>;
};

export type DataSourceUpdateWithoutS3BucketInput = {
  dataSourceSubscription?: InputMaybe<DataSourceSubscriptionUpdateManyWithoutDataSourceInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DataSourceUpsertWithWhereUniqueWithoutS3BucketInput = {
  create: DataSourceCreateWithoutS3BucketInput;
  update: DataSourceUpdateWithoutS3BucketInput;
  where: DataSourceWhereUniqueInput;
};

export type DataSourceUpsertWithoutDataSourceSubscriptionInput = {
  create: DataSourceCreateWithoutDataSourceSubscriptionInput;
  update: DataSourceUpdateWithoutDataSourceSubscriptionInput;
};

export type DataSourceWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DateRange = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DeleteUserResponse = {
  __typename?: 'DeleteUserResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type EnumActionInvocationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ActionInvocationStatus>;
};

export type EnumActionInvocationStatusFilter = {
  equals?: InputMaybe<ActionInvocationStatus>;
  in?: InputMaybe<Array<ActionInvocationStatus>>;
  not?: InputMaybe<NestedEnumActionInvocationStatusFilter>;
  notIn?: InputMaybe<Array<ActionInvocationStatus>>;
};

export type EnumAnalysisStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<AnalysisStatus>;
};

export type EnumAnalysisStatusFilter = {
  equals?: InputMaybe<AnalysisStatus>;
  in?: InputMaybe<Array<AnalysisStatus>>;
  not?: InputMaybe<NestedEnumAnalysisStatusFilter>;
  notIn?: InputMaybe<Array<AnalysisStatus>>;
};

export type EnumLabMemberRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<LabMemberRole>;
};

export type EnumLabMemberRoleFilter = {
  equals?: InputMaybe<LabMemberRole>;
  in?: InputMaybe<Array<LabMemberRole>>;
  not?: InputMaybe<NestedEnumLabMemberRoleFilter>;
  notIn?: InputMaybe<Array<LabMemberRole>>;
};

export type EnumLabStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<LabStatus>;
};

export type EnumLabStatusFilter = {
  equals?: InputMaybe<LabStatus>;
  in?: InputMaybe<Array<LabStatus>>;
  not?: InputMaybe<NestedEnumLabStatusFilter>;
  notIn?: InputMaybe<Array<LabStatus>>;
};

export type EnumPrimerDocTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PrimerDocType>;
};

export type EnumRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<Role>;
};

export type EnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumTinkerBoxStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<TinkerBoxStatus>;
};

export type EnumTinkerBoxStatusFilter = {
  equals?: InputMaybe<TinkerBoxStatus>;
  in?: InputMaybe<Array<TinkerBoxStatus>>;
  not?: InputMaybe<NestedEnumTinkerBoxStatusFilter>;
  notIn?: InputMaybe<Array<TinkerBoxStatus>>;
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  _count: FeatureFlagCount;
  id: Scalars['Int'];
  name: Scalars['String'];
  users?: Maybe<Array<UserFeatureFlag>>;
};

export type FeatureFlagCount = {
  __typename?: 'FeatureFlagCount';
  users: Scalars['Int'];
};

export type FeatureFlagCreateNestedOneWithoutUsersInput = {
  connect?: InputMaybe<FeatureFlagWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeatureFlagCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<FeatureFlagCreateWithoutUsersInput>;
};

export type FeatureFlagCreateOrConnectWithoutUsersInput = {
  create: FeatureFlagCreateWithoutUsersInput;
  where: FeatureFlagWhereUniqueInput;
};

export type FeatureFlagCreateWithoutUsersInput = {
  name: Scalars['String'];
};

export type FeatureFlagUpdateOneRequiredWithoutUsersInput = {
  connect?: InputMaybe<FeatureFlagWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FeatureFlagCreateOrConnectWithoutUsersInput>;
  create?: InputMaybe<FeatureFlagCreateWithoutUsersInput>;
  update?: InputMaybe<FeatureFlagUpdateWithoutUsersInput>;
  upsert?: InputMaybe<FeatureFlagUpsertWithoutUsersInput>;
};

export type FeatureFlagUpdateWithoutUsersInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FeatureFlagUpsertWithoutUsersInput = {
  create: FeatureFlagCreateWithoutUsersInput;
  update: FeatureFlagUpdateWithoutUsersInput;
};

export type FeatureFlagWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FileSearchResponse = {
  __typename?: 'FileSearchResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  results?: Maybe<Array<S3Object>>;
};

export type FileTransfer = {
  __typename?: 'FileTransfer';
  id: Scalars['Int'];
  name: Scalars['String'];
  progress: Scalars['Float'];
  user: User;
  userId: Scalars['Int'];
};

export type FileTransferCreateManyUserInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  progress?: InputMaybe<Scalars['Float']>;
};

export type FileTransferCreateManyUserInputEnvelope = {
  data: Array<FileTransferCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FileTransferCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<FileTransferWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileTransferCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<FileTransferCreateWithoutUserInput>>;
  createMany?: InputMaybe<FileTransferCreateManyUserInputEnvelope>;
};

export type FileTransferCreateOrConnectWithoutUserInput = {
  create: FileTransferCreateWithoutUserInput;
  where: FileTransferWhereUniqueInput;
};

export type FileTransferCreateWithoutUserInput = {
  name: Scalars['String'];
  progress?: InputMaybe<Scalars['Float']>;
};

export type FileTransferScalarWhereInput = {
  AND?: InputMaybe<Array<FileTransferScalarWhereInput>>;
  NOT?: InputMaybe<Array<FileTransferScalarWhereInput>>;
  OR?: InputMaybe<Array<FileTransferScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  progress?: InputMaybe<FloatFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type FileTransferUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  progress?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type FileTransferUpdateManyWithWhereWithoutUserInput = {
  data: FileTransferUpdateManyMutationInput;
  where: FileTransferScalarWhereInput;
};

export type FileTransferUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<FileTransferWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileTransferCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<FileTransferCreateWithoutUserInput>>;
  createMany?: InputMaybe<FileTransferCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<FileTransferWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileTransferScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileTransferWhereUniqueInput>>;
  set?: InputMaybe<Array<FileTransferWhereUniqueInput>>;
  update?: InputMaybe<Array<FileTransferUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<FileTransferUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<FileTransferUpsertWithWhereUniqueWithoutUserInput>>;
};

export type FileTransferUpdateWithWhereUniqueWithoutUserInput = {
  data: FileTransferUpdateWithoutUserInput;
  where: FileTransferWhereUniqueInput;
};

export type FileTransferUpdateWithoutUserInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  progress?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type FileTransferUpsertWithWhereUniqueWithoutUserInput = {
  create: FileTransferCreateWithoutUserInput;
  update: FileTransferUpdateWithoutUserInput;
  where: FileTransferWhereUniqueInput;
};

export type FileTransferWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']>;
  divide?: InputMaybe<Scalars['Float']>;
  increment?: InputMaybe<Scalars['Float']>;
  multiply?: InputMaybe<Scalars['Float']>;
  set?: InputMaybe<Scalars['Float']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FolderContents = {
  __typename?: 'FolderContents';
  contents: Array<S3Object>;
  errors?: Maybe<Scalars['String']>;
};

export type FormSchema = {
  __typename?: 'FormSchema';
  formSubmissions: Array<FormSubmission>;
  id: Scalars['Int'];
  name: Scalars['String'];
  schema: Scalars['JSON'];
};

export type FormSubmission = {
  __typename?: 'FormSubmission';
  data: Scalars['JSON'];
  dateCreated: Scalars['DateTime'];
  form: FormSchema;
  formId: Scalars['Int'];
  id: Scalars['Int'];
};

export type GetAiResponseData = {
  __typename?: 'GetAIResponseData';
  chatId: Scalars['Float'];
  message: Scalars['String'];
};

export type HeatMapData = {
  __typename?: 'HeatMapData';
  sessions: Array<TinkerBoxSession>;
  statusChanges: Array<TinkerBoxStatusChange>;
  tinkerBox: TinkerBox;
  tinkerBoxId: Scalars['Float'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type JsonFilter = {
  equals?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
};

export type JsonNullableFilter = {
  equals?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
};

export type KeyPair = {
  __typename?: 'KeyPair';
  _count: KeyPairCount;
  id: Scalars['Int'];
  material: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type KeyPairCount = {
  __typename?: 'KeyPairCount';
  tinkerBoxes: Scalars['Int'];
};

export type KeyPairCreateNestedOneWithoutLabInput = {
  connect?: InputMaybe<KeyPairWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KeyPairCreateOrConnectWithoutLabInput>;
  create?: InputMaybe<KeyPairCreateWithoutLabInput>;
};

export type KeyPairCreateNestedOneWithoutTinkerBoxesInput = {
  connect?: InputMaybe<KeyPairWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KeyPairCreateOrConnectWithoutTinkerBoxesInput>;
  create?: InputMaybe<KeyPairCreateWithoutTinkerBoxesInput>;
};

export type KeyPairCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<KeyPairWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KeyPairCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<KeyPairCreateWithoutUserInput>;
};

export type KeyPairCreateOrConnectWithoutLabInput = {
  create: KeyPairCreateWithoutLabInput;
  where: KeyPairWhereUniqueInput;
};

export type KeyPairCreateOrConnectWithoutTinkerBoxesInput = {
  create: KeyPairCreateWithoutTinkerBoxesInput;
  where: KeyPairWhereUniqueInput;
};

export type KeyPairCreateOrConnectWithoutUserInput = {
  create: KeyPairCreateWithoutUserInput;
  where: KeyPairWhereUniqueInput;
};

export type KeyPairCreateWithoutLabInput = {
  material: Scalars['String'];
  name: Scalars['String'];
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutKeyPairInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutKeyPairInput>;
};

export type KeyPairCreateWithoutTinkerBoxesInput = {
  lab?: InputMaybe<LabCreateNestedOneWithoutKeyPairInput>;
  material: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutKeyPairInput>;
};

export type KeyPairCreateWithoutUserInput = {
  lab?: InputMaybe<LabCreateNestedOneWithoutKeyPairInput>;
  material: Scalars['String'];
  name: Scalars['String'];
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutKeyPairInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type KeyPairUpdateOneRequiredWithoutLabInput = {
  connect?: InputMaybe<KeyPairWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KeyPairCreateOrConnectWithoutLabInput>;
  create?: InputMaybe<KeyPairCreateWithoutLabInput>;
  update?: InputMaybe<KeyPairUpdateWithoutLabInput>;
  upsert?: InputMaybe<KeyPairUpsertWithoutLabInput>;
};

export type KeyPairUpdateOneRequiredWithoutTinkerBoxesInput = {
  connect?: InputMaybe<KeyPairWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KeyPairCreateOrConnectWithoutTinkerBoxesInput>;
  create?: InputMaybe<KeyPairCreateWithoutTinkerBoxesInput>;
  update?: InputMaybe<KeyPairUpdateWithoutTinkerBoxesInput>;
  upsert?: InputMaybe<KeyPairUpsertWithoutTinkerBoxesInput>;
};

export type KeyPairUpdateOneRequiredWithoutUserInput = {
  connect?: InputMaybe<KeyPairWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KeyPairCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<KeyPairCreateWithoutUserInput>;
  update?: InputMaybe<KeyPairUpdateWithoutUserInput>;
  upsert?: InputMaybe<KeyPairUpsertWithoutUserInput>;
};

export type KeyPairUpdateWithoutLabInput = {
  material?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutKeyPairInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutKeyPairInput>;
};

export type KeyPairUpdateWithoutTinkerBoxesInput = {
  lab?: InputMaybe<LabUpdateOneWithoutKeyPairInput>;
  material?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutKeyPairInput>;
};

export type KeyPairUpdateWithoutUserInput = {
  lab?: InputMaybe<LabUpdateOneWithoutKeyPairInput>;
  material?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutKeyPairInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type KeyPairUpsertWithoutLabInput = {
  create: KeyPairCreateWithoutLabInput;
  update: KeyPairUpdateWithoutLabInput;
};

export type KeyPairUpsertWithoutTinkerBoxesInput = {
  create: KeyPairCreateWithoutTinkerBoxesInput;
  update: KeyPairUpdateWithoutTinkerBoxesInput;
};

export type KeyPairUpsertWithoutUserInput = {
  create: KeyPairCreateWithoutUserInput;
  update: KeyPairUpdateWithoutUserInput;
};

export type KeyPairWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Lab = {
  __typename?: 'Lab';
  _count: LabCount;
  chats?: Maybe<Array<Chat>>;
  cloudFormationStack?: Maybe<CloudFormationStack>;
  cloudFormationStackId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  keyPair: KeyPair;
  keyPairId: Scalars['Int'];
  labVolumes?: Maybe<Array<LabVolume>>;
  members?: Maybe<Array<LabMember>>;
  myLabRole: LabMemberRole;
  name: Scalars['String'];
  s3Bucket?: Maybe<S3Bucket>;
  s3BucketId?: Maybe<Scalars['Int']>;
  status: LabStatus;
  tinkerBoxScript?: Maybe<Scalars['String']>;
  tinkerBoxes?: Maybe<Array<TinkerBox>>;
};

export type LabCount = {
  __typename?: 'LabCount';
  chats: Scalars['Int'];
  labVolumes: Scalars['Int'];
  members: Scalars['Int'];
  tinkerBoxes: Scalars['Int'];
};

export type LabCreateManyCloudFormationStackInput = {
  id?: InputMaybe<Scalars['Int']>;
  keyPairId: Scalars['Int'];
  name: Scalars['String'];
  s3BucketId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<LabStatus>;
  tinkerBoxScript?: InputMaybe<Scalars['String']>;
};

export type LabCreateManyCloudFormationStackInputEnvelope = {
  data: Array<LabCreateManyCloudFormationStackInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LabCreateManyS3BucketInput = {
  cloudFormationStackId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  keyPairId: Scalars['Int'];
  name: Scalars['String'];
  status?: InputMaybe<LabStatus>;
  tinkerBoxScript?: InputMaybe<Scalars['String']>;
};

export type LabCreateManyS3BucketInputEnvelope = {
  data: Array<LabCreateManyS3BucketInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LabCreateNestedManyWithoutCloudFormationStackInput = {
  connect?: InputMaybe<Array<LabWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabCreateOrConnectWithoutCloudFormationStackInput>>;
  create?: InputMaybe<Array<LabCreateWithoutCloudFormationStackInput>>;
  createMany?: InputMaybe<LabCreateManyCloudFormationStackInputEnvelope>;
};

export type LabCreateNestedManyWithoutS3BucketInput = {
  connect?: InputMaybe<Array<LabWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabCreateOrConnectWithoutS3BucketInput>>;
  create?: InputMaybe<Array<LabCreateWithoutS3BucketInput>>;
  createMany?: InputMaybe<LabCreateManyS3BucketInputEnvelope>;
};

export type LabCreateNestedOneWithoutChatsInput = {
  connect?: InputMaybe<LabWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LabCreateOrConnectWithoutChatsInput>;
  create?: InputMaybe<LabCreateWithoutChatsInput>;
};

export type LabCreateNestedOneWithoutKeyPairInput = {
  connect?: InputMaybe<LabWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LabCreateOrConnectWithoutKeyPairInput>;
  create?: InputMaybe<LabCreateWithoutKeyPairInput>;
};

export type LabCreateNestedOneWithoutMembersInput = {
  connect?: InputMaybe<LabWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LabCreateOrConnectWithoutMembersInput>;
  create?: InputMaybe<LabCreateWithoutMembersInput>;
};

export type LabCreateNestedOneWithoutTinkerBoxesInput = {
  connect?: InputMaybe<LabWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LabCreateOrConnectWithoutTinkerBoxesInput>;
  create?: InputMaybe<LabCreateWithoutTinkerBoxesInput>;
};

export type LabCreateOrConnectWithoutChatsInput = {
  create: LabCreateWithoutChatsInput;
  where: LabWhereUniqueInput;
};

export type LabCreateOrConnectWithoutCloudFormationStackInput = {
  create: LabCreateWithoutCloudFormationStackInput;
  where: LabWhereUniqueInput;
};

export type LabCreateOrConnectWithoutKeyPairInput = {
  create: LabCreateWithoutKeyPairInput;
  where: LabWhereUniqueInput;
};

export type LabCreateOrConnectWithoutMembersInput = {
  create: LabCreateWithoutMembersInput;
  where: LabWhereUniqueInput;
};

export type LabCreateOrConnectWithoutS3BucketInput = {
  create: LabCreateWithoutS3BucketInput;
  where: LabWhereUniqueInput;
};

export type LabCreateOrConnectWithoutTinkerBoxesInput = {
  create: LabCreateWithoutTinkerBoxesInput;
  where: LabWhereUniqueInput;
};

export type LabCreateWithoutChatsInput = {
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutLabsInput>;
  keyPair: KeyPairCreateNestedOneWithoutLabInput;
  labVolumes?: InputMaybe<LabVolumeCreateNestedManyWithoutLabInput>;
  members?: InputMaybe<LabMemberCreateNestedManyWithoutLabInput>;
  name: Scalars['String'];
  s3Bucket?: InputMaybe<S3BucketCreateNestedOneWithoutLabInput>;
  status?: InputMaybe<LabStatus>;
  tinkerBoxScript?: InputMaybe<Scalars['String']>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutLabInput>;
};

export type LabCreateWithoutCloudFormationStackInput = {
  chats?: InputMaybe<ChatCreateNestedManyWithoutLabInput>;
  keyPair: KeyPairCreateNestedOneWithoutLabInput;
  labVolumes?: InputMaybe<LabVolumeCreateNestedManyWithoutLabInput>;
  members?: InputMaybe<LabMemberCreateNestedManyWithoutLabInput>;
  name: Scalars['String'];
  s3Bucket?: InputMaybe<S3BucketCreateNestedOneWithoutLabInput>;
  status?: InputMaybe<LabStatus>;
  tinkerBoxScript?: InputMaybe<Scalars['String']>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutLabInput>;
};

export type LabCreateWithoutKeyPairInput = {
  chats?: InputMaybe<ChatCreateNestedManyWithoutLabInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutLabsInput>;
  labVolumes?: InputMaybe<LabVolumeCreateNestedManyWithoutLabInput>;
  members?: InputMaybe<LabMemberCreateNestedManyWithoutLabInput>;
  name: Scalars['String'];
  s3Bucket?: InputMaybe<S3BucketCreateNestedOneWithoutLabInput>;
  status?: InputMaybe<LabStatus>;
  tinkerBoxScript?: InputMaybe<Scalars['String']>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutLabInput>;
};

export type LabCreateWithoutMembersInput = {
  chats?: InputMaybe<ChatCreateNestedManyWithoutLabInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutLabsInput>;
  keyPair: KeyPairCreateNestedOneWithoutLabInput;
  labVolumes?: InputMaybe<LabVolumeCreateNestedManyWithoutLabInput>;
  name: Scalars['String'];
  s3Bucket?: InputMaybe<S3BucketCreateNestedOneWithoutLabInput>;
  status?: InputMaybe<LabStatus>;
  tinkerBoxScript?: InputMaybe<Scalars['String']>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutLabInput>;
};

export type LabCreateWithoutS3BucketInput = {
  chats?: InputMaybe<ChatCreateNestedManyWithoutLabInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutLabsInput>;
  keyPair: KeyPairCreateNestedOneWithoutLabInput;
  labVolumes?: InputMaybe<LabVolumeCreateNestedManyWithoutLabInput>;
  members?: InputMaybe<LabMemberCreateNestedManyWithoutLabInput>;
  name: Scalars['String'];
  status?: InputMaybe<LabStatus>;
  tinkerBoxScript?: InputMaybe<Scalars['String']>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutLabInput>;
};

export type LabCreateWithoutTinkerBoxesInput = {
  chats?: InputMaybe<ChatCreateNestedManyWithoutLabInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutLabsInput>;
  keyPair: KeyPairCreateNestedOneWithoutLabInput;
  labVolumes?: InputMaybe<LabVolumeCreateNestedManyWithoutLabInput>;
  members?: InputMaybe<LabMemberCreateNestedManyWithoutLabInput>;
  name: Scalars['String'];
  s3Bucket?: InputMaybe<S3BucketCreateNestedOneWithoutLabInput>;
  status?: InputMaybe<LabStatus>;
  tinkerBoxScript?: InputMaybe<Scalars['String']>;
};

export type LabMember = {
  __typename?: 'LabMember';
  id: Scalars['Int'];
  lab?: Maybe<Lab>;
  labId: Scalars['Int'];
  role: LabMemberRole;
  user: User;
  userId: Scalars['Int'];
};

export type LabMemberCreateManyLabInput = {
  id?: InputMaybe<Scalars['Int']>;
  role: LabMemberRole;
  userId: Scalars['Int'];
};

export type LabMemberCreateManyLabInputEnvelope = {
  data: Array<LabMemberCreateManyLabInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LabMemberCreateManyUserInput = {
  id?: InputMaybe<Scalars['Int']>;
  labId: Scalars['Int'];
  role: LabMemberRole;
};

export type LabMemberCreateManyUserInputEnvelope = {
  data: Array<LabMemberCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LabMemberCreateNestedManyWithoutLabInput = {
  connect?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabMemberCreateOrConnectWithoutLabInput>>;
  create?: InputMaybe<Array<LabMemberCreateWithoutLabInput>>;
  createMany?: InputMaybe<LabMemberCreateManyLabInputEnvelope>;
};

export type LabMemberCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabMemberCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LabMemberCreateWithoutUserInput>>;
  createMany?: InputMaybe<LabMemberCreateManyUserInputEnvelope>;
};

export type LabMemberCreateOrConnectWithoutLabInput = {
  create: LabMemberCreateWithoutLabInput;
  where: LabMemberWhereUniqueInput;
};

export type LabMemberCreateOrConnectWithoutUserInput = {
  create: LabMemberCreateWithoutUserInput;
  where: LabMemberWhereUniqueInput;
};

export type LabMemberCreateWithoutLabInput = {
  role: LabMemberRole;
  user: UserCreateNestedOneWithoutLabMembersInput;
};

export type LabMemberCreateWithoutUserInput = {
  lab?: InputMaybe<LabCreateNestedOneWithoutMembersInput>;
  role: LabMemberRole;
};

export enum LabMemberRole {
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export type LabMemberScalarWhereInput = {
  AND?: InputMaybe<Array<LabMemberScalarWhereInput>>;
  NOT?: InputMaybe<Array<LabMemberScalarWhereInput>>;
  OR?: InputMaybe<Array<LabMemberScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  labId?: InputMaybe<IntFilter>;
  role?: InputMaybe<EnumLabMemberRoleFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type LabMemberUpdateManyMutationInput = {
  role?: InputMaybe<EnumLabMemberRoleFieldUpdateOperationsInput>;
};

export type LabMemberUpdateManyWithWhereWithoutLabInput = {
  data: LabMemberUpdateManyMutationInput;
  where: LabMemberScalarWhereInput;
};

export type LabMemberUpdateManyWithWhereWithoutUserInput = {
  data: LabMemberUpdateManyMutationInput;
  where: LabMemberScalarWhereInput;
};

export type LabMemberUpdateManyWithoutLabInput = {
  connect?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabMemberCreateOrConnectWithoutLabInput>>;
  create?: InputMaybe<Array<LabMemberCreateWithoutLabInput>>;
  createMany?: InputMaybe<LabMemberCreateManyLabInputEnvelope>;
  delete?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LabMemberScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  set?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  update?: InputMaybe<Array<LabMemberUpdateWithWhereUniqueWithoutLabInput>>;
  updateMany?: InputMaybe<Array<LabMemberUpdateManyWithWhereWithoutLabInput>>;
  upsert?: InputMaybe<Array<LabMemberUpsertWithWhereUniqueWithoutLabInput>>;
};

export type LabMemberUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabMemberCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<LabMemberCreateWithoutUserInput>>;
  createMany?: InputMaybe<LabMemberCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LabMemberScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  set?: InputMaybe<Array<LabMemberWhereUniqueInput>>;
  update?: InputMaybe<Array<LabMemberUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<LabMemberUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<LabMemberUpsertWithWhereUniqueWithoutUserInput>>;
};

export type LabMemberUpdateWithWhereUniqueWithoutLabInput = {
  data: LabMemberUpdateWithoutLabInput;
  where: LabMemberWhereUniqueInput;
};

export type LabMemberUpdateWithWhereUniqueWithoutUserInput = {
  data: LabMemberUpdateWithoutUserInput;
  where: LabMemberWhereUniqueInput;
};

export type LabMemberUpdateWithoutLabInput = {
  role?: InputMaybe<EnumLabMemberRoleFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutLabMembersInput>;
};

export type LabMemberUpdateWithoutUserInput = {
  lab?: InputMaybe<LabUpdateOneWithoutMembersInput>;
  role?: InputMaybe<EnumLabMemberRoleFieldUpdateOperationsInput>;
};

export type LabMemberUpsertWithWhereUniqueWithoutLabInput = {
  create: LabMemberCreateWithoutLabInput;
  update: LabMemberUpdateWithoutLabInput;
  where: LabMemberWhereUniqueInput;
};

export type LabMemberUpsertWithWhereUniqueWithoutUserInput = {
  create: LabMemberCreateWithoutUserInput;
  update: LabMemberUpdateWithoutUserInput;
  where: LabMemberWhereUniqueInput;
};

export type LabMemberUserLabUniqueCompoundUniqueInput = {
  labId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type LabMemberWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  userLabUnique?: InputMaybe<LabMemberUserLabUniqueCompoundUniqueInput>;
};

export type LabScalarWhereInput = {
  AND?: InputMaybe<Array<LabScalarWhereInput>>;
  NOT?: InputMaybe<Array<LabScalarWhereInput>>;
  OR?: InputMaybe<Array<LabScalarWhereInput>>;
  cloudFormationStackId?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<IntFilter>;
  keyPairId?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  s3BucketId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<EnumLabStatusFilter>;
  tinkerBoxScript?: InputMaybe<StringNullableFilter>;
};

export enum LabStatus {
  Creating = 'CREATING',
  Failed = 'FAILED',
  Ready = 'READY'
}

export type LabUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumLabStatusFieldUpdateOperationsInput>;
  tinkerBoxScript?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LabUpdateManyWithWhereWithoutCloudFormationStackInput = {
  data: LabUpdateManyMutationInput;
  where: LabScalarWhereInput;
};

export type LabUpdateManyWithWhereWithoutS3BucketInput = {
  data: LabUpdateManyMutationInput;
  where: LabScalarWhereInput;
};

export type LabUpdateManyWithoutCloudFormationStackInput = {
  connect?: InputMaybe<Array<LabWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabCreateOrConnectWithoutCloudFormationStackInput>>;
  create?: InputMaybe<Array<LabCreateWithoutCloudFormationStackInput>>;
  createMany?: InputMaybe<LabCreateManyCloudFormationStackInputEnvelope>;
  delete?: InputMaybe<Array<LabWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LabScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LabWhereUniqueInput>>;
  set?: InputMaybe<Array<LabWhereUniqueInput>>;
  update?: InputMaybe<Array<LabUpdateWithWhereUniqueWithoutCloudFormationStackInput>>;
  updateMany?: InputMaybe<Array<LabUpdateManyWithWhereWithoutCloudFormationStackInput>>;
  upsert?: InputMaybe<Array<LabUpsertWithWhereUniqueWithoutCloudFormationStackInput>>;
};

export type LabUpdateManyWithoutS3BucketInput = {
  connect?: InputMaybe<Array<LabWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabCreateOrConnectWithoutS3BucketInput>>;
  create?: InputMaybe<Array<LabCreateWithoutS3BucketInput>>;
  createMany?: InputMaybe<LabCreateManyS3BucketInputEnvelope>;
  delete?: InputMaybe<Array<LabWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LabScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LabWhereUniqueInput>>;
  set?: InputMaybe<Array<LabWhereUniqueInput>>;
  update?: InputMaybe<Array<LabUpdateWithWhereUniqueWithoutS3BucketInput>>;
  updateMany?: InputMaybe<Array<LabUpdateManyWithWhereWithoutS3BucketInput>>;
  upsert?: InputMaybe<Array<LabUpsertWithWhereUniqueWithoutS3BucketInput>>;
};

export type LabUpdateOneRequiredWithoutChatsInput = {
  connect?: InputMaybe<LabWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LabCreateOrConnectWithoutChatsInput>;
  create?: InputMaybe<LabCreateWithoutChatsInput>;
  update?: InputMaybe<LabUpdateWithoutChatsInput>;
  upsert?: InputMaybe<LabUpsertWithoutChatsInput>;
};

export type LabUpdateOneWithoutKeyPairInput = {
  connect?: InputMaybe<LabWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LabCreateOrConnectWithoutKeyPairInput>;
  create?: InputMaybe<LabCreateWithoutKeyPairInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LabUpdateWithoutKeyPairInput>;
  upsert?: InputMaybe<LabUpsertWithoutKeyPairInput>;
};

export type LabUpdateOneWithoutMembersInput = {
  connect?: InputMaybe<LabWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LabCreateOrConnectWithoutMembersInput>;
  create?: InputMaybe<LabCreateWithoutMembersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LabUpdateWithoutMembersInput>;
  upsert?: InputMaybe<LabUpsertWithoutMembersInput>;
};

export type LabUpdateOneWithoutTinkerBoxesInput = {
  connect?: InputMaybe<LabWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LabCreateOrConnectWithoutTinkerBoxesInput>;
  create?: InputMaybe<LabCreateWithoutTinkerBoxesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LabUpdateWithoutTinkerBoxesInput>;
  upsert?: InputMaybe<LabUpsertWithoutTinkerBoxesInput>;
};

export type LabUpdateWithWhereUniqueWithoutCloudFormationStackInput = {
  data: LabUpdateWithoutCloudFormationStackInput;
  where: LabWhereUniqueInput;
};

export type LabUpdateWithWhereUniqueWithoutS3BucketInput = {
  data: LabUpdateWithoutS3BucketInput;
  where: LabWhereUniqueInput;
};

export type LabUpdateWithoutChatsInput = {
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutLabsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutLabInput>;
  labVolumes?: InputMaybe<LabVolumeUpdateManyWithoutLabInput>;
  members?: InputMaybe<LabMemberUpdateManyWithoutLabInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  s3Bucket?: InputMaybe<S3BucketUpdateOneWithoutLabInput>;
  status?: InputMaybe<EnumLabStatusFieldUpdateOperationsInput>;
  tinkerBoxScript?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutLabInput>;
};

export type LabUpdateWithoutCloudFormationStackInput = {
  chats?: InputMaybe<ChatUpdateManyWithoutLabInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutLabInput>;
  labVolumes?: InputMaybe<LabVolumeUpdateManyWithoutLabInput>;
  members?: InputMaybe<LabMemberUpdateManyWithoutLabInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  s3Bucket?: InputMaybe<S3BucketUpdateOneWithoutLabInput>;
  status?: InputMaybe<EnumLabStatusFieldUpdateOperationsInput>;
  tinkerBoxScript?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutLabInput>;
};

export type LabUpdateWithoutKeyPairInput = {
  chats?: InputMaybe<ChatUpdateManyWithoutLabInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutLabsInput>;
  labVolumes?: InputMaybe<LabVolumeUpdateManyWithoutLabInput>;
  members?: InputMaybe<LabMemberUpdateManyWithoutLabInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  s3Bucket?: InputMaybe<S3BucketUpdateOneWithoutLabInput>;
  status?: InputMaybe<EnumLabStatusFieldUpdateOperationsInput>;
  tinkerBoxScript?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutLabInput>;
};

export type LabUpdateWithoutMembersInput = {
  chats?: InputMaybe<ChatUpdateManyWithoutLabInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutLabsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutLabInput>;
  labVolumes?: InputMaybe<LabVolumeUpdateManyWithoutLabInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  s3Bucket?: InputMaybe<S3BucketUpdateOneWithoutLabInput>;
  status?: InputMaybe<EnumLabStatusFieldUpdateOperationsInput>;
  tinkerBoxScript?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutLabInput>;
};

export type LabUpdateWithoutS3BucketInput = {
  chats?: InputMaybe<ChatUpdateManyWithoutLabInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutLabsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutLabInput>;
  labVolumes?: InputMaybe<LabVolumeUpdateManyWithoutLabInput>;
  members?: InputMaybe<LabMemberUpdateManyWithoutLabInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumLabStatusFieldUpdateOperationsInput>;
  tinkerBoxScript?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutLabInput>;
};

export type LabUpdateWithoutTinkerBoxesInput = {
  chats?: InputMaybe<ChatUpdateManyWithoutLabInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutLabsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutLabInput>;
  labVolumes?: InputMaybe<LabVolumeUpdateManyWithoutLabInput>;
  members?: InputMaybe<LabMemberUpdateManyWithoutLabInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  s3Bucket?: InputMaybe<S3BucketUpdateOneWithoutLabInput>;
  status?: InputMaybe<EnumLabStatusFieldUpdateOperationsInput>;
  tinkerBoxScript?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LabUpsertWithWhereUniqueWithoutCloudFormationStackInput = {
  create: LabCreateWithoutCloudFormationStackInput;
  update: LabUpdateWithoutCloudFormationStackInput;
  where: LabWhereUniqueInput;
};

export type LabUpsertWithWhereUniqueWithoutS3BucketInput = {
  create: LabCreateWithoutS3BucketInput;
  update: LabUpdateWithoutS3BucketInput;
  where: LabWhereUniqueInput;
};

export type LabUpsertWithoutChatsInput = {
  create: LabCreateWithoutChatsInput;
  update: LabUpdateWithoutChatsInput;
};

export type LabUpsertWithoutKeyPairInput = {
  create: LabCreateWithoutKeyPairInput;
  update: LabUpdateWithoutKeyPairInput;
};

export type LabUpsertWithoutMembersInput = {
  create: LabCreateWithoutMembersInput;
  update: LabUpdateWithoutMembersInput;
};

export type LabUpsertWithoutTinkerBoxesInput = {
  create: LabCreateWithoutTinkerBoxesInput;
  update: LabUpdateWithoutTinkerBoxesInput;
};

export type LabVolume = {
  __typename?: 'LabVolume';
  accessPointId?: Maybe<Scalars['String']>;
  fileSystemId: Scalars['String'];
  id: Scalars['Int'];
  lab: Lab;
  labId: Scalars['Int'];
};

export type LabVolumeCreateManyLabInput = {
  accessPointId?: InputMaybe<Scalars['String']>;
  fileSystemId: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
};

export type LabVolumeCreateManyLabInputEnvelope = {
  data: Array<LabVolumeCreateManyLabInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LabVolumeCreateNestedManyWithoutLabInput = {
  connect?: InputMaybe<Array<LabVolumeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabVolumeCreateOrConnectWithoutLabInput>>;
  create?: InputMaybe<Array<LabVolumeCreateWithoutLabInput>>;
  createMany?: InputMaybe<LabVolumeCreateManyLabInputEnvelope>;
};

export type LabVolumeCreateOrConnectWithoutLabInput = {
  create: LabVolumeCreateWithoutLabInput;
  where: LabVolumeWhereUniqueInput;
};

export type LabVolumeCreateWithoutLabInput = {
  accessPointId?: InputMaybe<Scalars['String']>;
  fileSystemId: Scalars['String'];
};

export type LabVolumeScalarWhereInput = {
  AND?: InputMaybe<Array<LabVolumeScalarWhereInput>>;
  NOT?: InputMaybe<Array<LabVolumeScalarWhereInput>>;
  OR?: InputMaybe<Array<LabVolumeScalarWhereInput>>;
  accessPointId?: InputMaybe<StringNullableFilter>;
  fileSystemId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  labId?: InputMaybe<IntFilter>;
};

export type LabVolumeUpdateManyMutationInput = {
  accessPointId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSystemId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LabVolumeUpdateManyWithWhereWithoutLabInput = {
  data: LabVolumeUpdateManyMutationInput;
  where: LabVolumeScalarWhereInput;
};

export type LabVolumeUpdateManyWithoutLabInput = {
  connect?: InputMaybe<Array<LabVolumeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LabVolumeCreateOrConnectWithoutLabInput>>;
  create?: InputMaybe<Array<LabVolumeCreateWithoutLabInput>>;
  createMany?: InputMaybe<LabVolumeCreateManyLabInputEnvelope>;
  delete?: InputMaybe<Array<LabVolumeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LabVolumeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LabVolumeWhereUniqueInput>>;
  set?: InputMaybe<Array<LabVolumeWhereUniqueInput>>;
  update?: InputMaybe<Array<LabVolumeUpdateWithWhereUniqueWithoutLabInput>>;
  updateMany?: InputMaybe<Array<LabVolumeUpdateManyWithWhereWithoutLabInput>>;
  upsert?: InputMaybe<Array<LabVolumeUpsertWithWhereUniqueWithoutLabInput>>;
};

export type LabVolumeUpdateWithWhereUniqueWithoutLabInput = {
  data: LabVolumeUpdateWithoutLabInput;
  where: LabVolumeWhereUniqueInput;
};

export type LabVolumeUpdateWithoutLabInput = {
  accessPointId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSystemId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LabVolumeUpsertWithWhereUniqueWithoutLabInput = {
  create: LabVolumeCreateWithoutLabInput;
  update: LabVolumeUpdateWithoutLabInput;
  where: LabVolumeWhereUniqueInput;
};

export type LabVolumeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type LabWhereUniqueInput = {
  cloudFormationStackId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  keyPairId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type LaunchTinkerBoxResponse = {
  __typename?: 'LaunchTinkerBoxResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  tinkerBox?: Maybe<TinkerBox>;
};

export type LoginCliResponse = {
  __typename?: 'LoginCliResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  token?: Maybe<Scalars['String']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addLabMember: AddLabMemberResponse;
  createAction: CreateActionResponse;
  createAnalysesFromTable: CreateAnalysesFromTableResponse;
  createAnalysis: CreateAnalysisResponse;
  createAnalysisSchema: AnalysisSchema;
  createCliToken: CreateCliTokenResponse;
  createFolder: Scalars['String'];
  createForm: FormSchema;
  createLab: CreateLabResponse;
  createPrimer: Primer;
  createPrimerGoogleDoc: Primer;
  createUser: Scalars['Boolean'];
  createValueSchema: ValueSchema;
  deleteAnalysis: Scalars['Boolean'];
  deleteFilesResolver: Scalars['Boolean'];
  deleteLab: Scalars['Boolean'];
  deleteLabMember: Scalars['Boolean'];
  deletePrimerGoogleDoc: Primer;
  deleteUser: DeleteUserResponse;
  deleteValueSchema: ValueSchema;
  getAIResponse: GetAiResponseData;
  getUploadUrlForDocIndexUpload: Scalars['String'];
  launchAnalysis: Scalars['String'];
  launchLabTinkerBox: StartAllTinkerBoxesResponse;
  launchTinkerBox: LaunchTinkerBoxResponse;
  loginCli: LoginCliResponse;
  loginCliOneTimePassword: LoginCliResponse;
  loginOneTimePassword: LoginResponse;
  loginUsernamePassword: LoginResponse;
  logout: Scalars['Boolean'];
  markMessageAsUnhelpful: Scalars['Boolean'];
  moveS3Files: Scalars['Boolean'];
  moveUpAFolder: Scalars['Boolean'];
  sendOneTimePassword: Scalars['Boolean'];
  setPasswordForUser: Scalars['Boolean'];
  shutdownTinkerBox: Scalars['Boolean'];
  signupProspect: SuccessOrErrors;
  startAIChat: Chat;
  startAllTinkerBoxes: StartAllTinkerBoxesResponse;
  startTinkerBox: TinkerBox;
  stopTinkerBox: TinkerBox;
  submitForm: Scalars['Boolean'];
  testAction: TestActionResponse;
  updateAction: UpdateActionResponse;
  updateCloudFormationStack: SuccessOrErrors;
  updateDataSourceSubscription: Scalars['Boolean'];
  updateLabMemberRole: Scalars['Boolean'];
  updatePrimer: Primer;
  updatePrimerGoogleDoc: Primer;
  updateTinkerBox: TinkerBox;
  updateValueSchema: ValueSchema;
};


export type MutationAddLabMemberArgs = {
  email: Scalars['String'];
  labId: Scalars['Float'];
};


export type MutationCreateActionArgs = {
  analysisSchemaId: Scalars['Float'];
  filePrefix: Scalars['String'];
  fileSuffix: Scalars['String'];
  handlerCode: Scalars['String'];
  name: Scalars['String'];
  s3BucketId: Scalars['Float'];
};


export type MutationCreateAnalysesFromTableArgs = {
  input: CreateAnalysesFromTableInput;
};


export type MutationCreateAnalysisArgs = {
  input: CreateAnalysisInput;
};


export type MutationCreateAnalysisSchemaArgs = {
  data: AnalysisSchemaCreateInput;
};


export type MutationCreateFolderArgs = {
  currentFolder: Scalars['String'];
  newFolder: Scalars['String'];
  s3BucketId?: InputMaybe<Scalars['Float']>;
};


export type MutationCreateFormArgs = {
  name: Scalars['String'];
  schema: Scalars['String'];
};


export type MutationCreateLabArgs = {
  name: Scalars['String'];
  numTinkerBoxes?: InputMaybe<Scalars['Float']>;
};


export type MutationCreatePrimerArgs = {
  data: PrimerCreateInput;
};


export type MutationCreatePrimerGoogleDocArgs = {
  data: PrimerGoogleDocCreateInput;
};


export type MutationCreateUserArgs = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCreateValueSchemaArgs = {
  data: ValueSchemaCreateInput;
};


export type MutationDeleteAnalysisArgs = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteFilesResolverArgs = {
  paths: Array<S3ObjectInput>;
};


export type MutationDeleteLabArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteLabMemberArgs = {
  labMemberId: Scalars['Float'];
};


export type MutationDeletePrimerGoogleDocArgs = {
  where: PrimerGoogleDocWhereUniqueInput;
};


export type MutationDeleteUserArgs = {
  id: Scalars['Float'];
};


export type MutationDeleteValueSchemaArgs = {
  where: ValueSchemaWhereUniqueInput;
};


export type MutationGetAiResponseArgs = {
  chatId?: InputMaybe<Scalars['Float']>;
  message: Scalars['String'];
};


export type MutationGetUploadUrlForDocIndexUploadArgs = {
  category: Scalars['String'];
  name: Scalars['String'];
};


export type MutationLaunchAnalysisArgs = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationLaunchLabTinkerBoxArgs = {
  labId: Scalars['Float'];
};


export type MutationLoginCliArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginCliOneTimePasswordArgs = {
  otp: Scalars['String'];
};


export type MutationLoginOneTimePasswordArgs = {
  otp: Scalars['String'];
};


export type MutationLoginUsernamePasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationMarkMessageAsUnhelpfulArgs = {
  messageId: Scalars['Float'];
};


export type MutationMoveS3FilesArgs = {
  source: S3ObjectInput;
  target: S3ObjectInput;
};


export type MutationMoveUpAFolderArgs = {
  path: S3ObjectInput;
};


export type MutationSendOneTimePasswordArgs = {
  email: Scalars['String'];
};


export type MutationSetPasswordForUserArgs = {
  password: Scalars['String'];
  userId: Scalars['Float'];
};


export type MutationShutdownTinkerBoxArgs = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationSignupProspectArgs = {
  email: Scalars['String'];
};


export type MutationStartAiChatArgs = {
  labId: Scalars['Float'];
};


export type MutationStartTinkerBoxArgs = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationStopTinkerBoxArgs = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationSubmitFormArgs = {
  data: Scalars['String'];
  name: Scalars['String'];
};


export type MutationTestActionArgs = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateActionArgs = {
  actionName: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
  filePrefix?: InputMaybe<Scalars['String']>;
  fileSuffix?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCloudFormationStackArgs = {
  id: Scalars['Float'];
};


export type MutationUpdateDataSourceSubscriptionArgs = {
  dataSourceId: Scalars['Float'];
  isSubscribed: Scalars['Boolean'];
};


export type MutationUpdateLabMemberRoleArgs = {
  labMemberId: Scalars['Float'];
  role: Scalars['String'];
};


export type MutationUpdatePrimerArgs = {
  data: PrimerUpdateInput;
  where: PrimerWhereUniqueInput;
};


export type MutationUpdatePrimerGoogleDocArgs = {
  data: PrimerGoogleDocUpdateInput;
  where: PrimerGoogleDocWhereUniqueInput;
};


export type MutationUpdateTinkerBoxArgs = {
  data: UpdateTinkerBoxData;
  id: Scalars['Float'];
};


export type MutationUpdateValueSchemaArgs = {
  data: ValueSchemaUpdateInput;
  where: ValueSchemaWhereUniqueInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedEnumActionInvocationStatusFilter = {
  equals?: InputMaybe<ActionInvocationStatus>;
  in?: InputMaybe<Array<ActionInvocationStatus>>;
  not?: InputMaybe<NestedEnumActionInvocationStatusFilter>;
  notIn?: InputMaybe<Array<ActionInvocationStatus>>;
};

export type NestedEnumAnalysisStatusFilter = {
  equals?: InputMaybe<AnalysisStatus>;
  in?: InputMaybe<Array<AnalysisStatus>>;
  not?: InputMaybe<NestedEnumAnalysisStatusFilter>;
  notIn?: InputMaybe<Array<AnalysisStatus>>;
};

export type NestedEnumLabMemberRoleFilter = {
  equals?: InputMaybe<LabMemberRole>;
  in?: InputMaybe<Array<LabMemberRole>>;
  not?: InputMaybe<NestedEnumLabMemberRoleFilter>;
  notIn?: InputMaybe<Array<LabMemberRole>>;
};

export type NestedEnumLabStatusFilter = {
  equals?: InputMaybe<LabStatus>;
  in?: InputMaybe<Array<LabStatus>>;
  not?: InputMaybe<NestedEnumLabStatusFilter>;
  notIn?: InputMaybe<Array<LabStatus>>;
};

export type NestedEnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumTinkerBoxStatusFilter = {
  equals?: InputMaybe<TinkerBoxStatus>;
  in?: InputMaybe<Array<TinkerBoxStatus>>;
  not?: InputMaybe<NestedEnumTinkerBoxStatusFilter>;
  notIn?: InputMaybe<Array<TinkerBoxStatus>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NextflowWorkflow = {
  __typename?: 'NextflowWorkflow';
  _count: NextflowWorkflowCount;
  analysisSchema?: Maybe<Array<AnalysisSchema>>;
  computeEnvId?: Maybe<Scalars['String']>;
  extraParams?: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  pipelineUrl: Scalars['String'];
  revision: Scalars['String'];
  scriptName: Scalars['String'];
};

export type NextflowWorkflowCount = {
  __typename?: 'NextflowWorkflowCount';
  analysisSchema: Scalars['Int'];
};

export type NextflowWorkflowCreateNestedOneWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<NextflowWorkflowWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NextflowWorkflowCreateOrConnectWithoutAnalysisSchemaInput>;
  create?: InputMaybe<NextflowWorkflowCreateWithoutAnalysisSchemaInput>;
};

export type NextflowWorkflowCreateOrConnectWithoutAnalysisSchemaInput = {
  create: NextflowWorkflowCreateWithoutAnalysisSchemaInput;
  where: NextflowWorkflowWhereUniqueInput;
};

export type NextflowWorkflowCreateWithoutAnalysisSchemaInput = {
  computeEnvId?: InputMaybe<Scalars['String']>;
  extraParams?: InputMaybe<Scalars['JSON']>;
  pipelineUrl: Scalars['String'];
  revision: Scalars['String'];
  scriptName?: InputMaybe<Scalars['String']>;
};

export type NextflowWorkflowOrderByWithRelationInput = {
  analysisSchema?: InputMaybe<AnalysisSchemaOrderByRelationAggregateInput>;
  computeEnvId?: InputMaybe<SortOrder>;
  extraParams?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pipelineUrl?: InputMaybe<SortOrder>;
  revision?: InputMaybe<SortOrder>;
  scriptName?: InputMaybe<SortOrder>;
};

export type NextflowWorkflowUpdateOneRequiredWithoutAnalysisSchemaInput = {
  connect?: InputMaybe<NextflowWorkflowWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NextflowWorkflowCreateOrConnectWithoutAnalysisSchemaInput>;
  create?: InputMaybe<NextflowWorkflowCreateWithoutAnalysisSchemaInput>;
  update?: InputMaybe<NextflowWorkflowUpdateWithoutAnalysisSchemaInput>;
  upsert?: InputMaybe<NextflowWorkflowUpsertWithoutAnalysisSchemaInput>;
};

export type NextflowWorkflowUpdateWithoutAnalysisSchemaInput = {
  computeEnvId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  extraParams?: InputMaybe<Scalars['JSON']>;
  pipelineUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  revision?: InputMaybe<StringFieldUpdateOperationsInput>;
  scriptName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NextflowWorkflowUpsertWithoutAnalysisSchemaInput = {
  create: NextflowWorkflowCreateWithoutAnalysisSchemaInput;
  update: NextflowWorkflowUpdateWithoutAnalysisSchemaInput;
};

export type NextflowWorkflowWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type PresignedFormData = {
  __typename?: 'PresignedFormData';
  fields: Scalars['String'];
  url: Scalars['String'];
};

export type Primer = {
  __typename?: 'Primer';
  id: Scalars['Int'];
  name: Scalars['String'];
  text: Scalars['String'];
};

export type PrimerCreateInput = {
  name: Scalars['String'];
  text: Scalars['String'];
};

export enum PrimerDocType {
  Task = 'TASK',
  Tool = 'TOOL'
}

export type PrimerGoogleDoc = {
  __typename?: 'PrimerGoogleDoc';
  body: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  embedLink: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
  type: PrimerDocType;
  viewLink: Scalars['String'];
};

export type PrimerGoogleDocCreateInput = {
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateUpdated?: InputMaybe<Scalars['DateTime']>;
  embedLink: Scalars['String'];
  title: Scalars['String'];
  type?: InputMaybe<PrimerDocType>;
  viewLink: Scalars['String'];
};

export type PrimerGoogleDocUpdateInput = {
  dateCreated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dateUpdated?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  embedLink?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumPrimerDocTypeFieldUpdateOperationsInput>;
  viewLink?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PrimerGoogleDocWhereUniqueInput = {
  embedLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  viewLink?: InputMaybe<Scalars['String']>;
};

export type PrimerUpdateInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  text?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PrimerWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  action: Action;
  actionInvocation: ActionInvocation;
  actions: Array<Action>;
  allLabs: Array<Lab>;
  allTinkerBoxes: Array<TinkerBox>;
  analyses: Array<Analysis>;
  analysis: Analysis;
  analysisSchemas: Array<AnalysisSchema>;
  buckets: Array<S3Bucket>;
  chat?: Maybe<Chat>;
  dataSource: DataSource;
  dataSourceNotifications: Array<DataSourceNotification>;
  dataSources: Array<DataSource>;
  featureFlagEnabled: Scalars['Boolean'];
  fileSearch: FileSearchResponse;
  fileTransfers: Array<FileTransfer>;
  folderContents: FolderContents;
  formSchema: FormSchema;
  formSchemas: Array<FormSchema>;
  heatMapData?: Maybe<Array<HeatMapData>>;
  lab: Lab;
  labs: Array<Lab>;
  me?: Maybe<User>;
  presignedDownloadUrl: Scalars['String'];
  presignedFormData: PresignedFormData;
  primer: Primer;
  primerGoogleDoc: PrimerGoogleDoc;
  primerGoogleDocs: Array<PrimerGoogleDoc>;
  primers: Array<Primer>;
  tinkerBox: TinkerBox;
  tinkerBoxStats?: Maybe<Array<TinkerBoxStat>>;
  tinkerBoxStatsById?: Maybe<Array<TinkerBoxStatsById>>;
  tinkerBoxStatusChanges?: Maybe<Array<TinkerBoxStatusChanges>>;
  tinkerBoxes: Array<TinkerBox>;
  users: Array<User>;
  valueSchema: ValueSchema;
  valueSchemas: Array<ValueSchema>;
};


export type QueryActionArgs = {
  id: Scalars['Float'];
};


export type QueryActionInvocationArgs = {
  id: Scalars['Float'];
};


export type QueryAnalysisArgs = {
  id: Scalars['Float'];
};


export type QueryAnalysisSchemasArgs = {
  orderBy: AnalysisSchemaOrderByWithRelationInput;
};


export type QueryChatArgs = {
  id?: InputMaybe<Scalars['Float']>;
};


export type QueryDataSourceArgs = {
  id: Scalars['Float'];
};


export type QueryFeatureFlagEnabledArgs = {
  name: Scalars['String'];
};


export type QueryFileSearchArgs = {
  s3BucketId?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};


export type QueryFolderContentsArgs = {
  folder?: InputMaybe<Scalars['String']>;
  s3BucketId?: InputMaybe<Scalars['Float']>;
};


export type QueryFormSchemaArgs = {
  name: Scalars['String'];
};


export type QueryHeatMapDataArgs = {
  range?: InputMaybe<DateRange>;
};


export type QueryLabArgs = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryPresignedDownloadUrlArgs = {
  bucket: Scalars['String'];
  key: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
};


export type QueryPresignedFormDataArgs = {
  key: Scalars['String'];
  s3BucketId?: InputMaybe<Scalars['Float']>;
};


export type QueryPrimerArgs = {
  id: Scalars['Float'];
};


export type QueryPrimerGoogleDocArgs = {
  id: Scalars['Float'];
};


export type QueryTinkerBoxArgs = {
  id?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
};


export type QueryTinkerBoxStatsArgs = {
  increment?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<DateRange>;
};


export type QueryTinkerBoxStatsByIdArgs = {
  range?: InputMaybe<DateRange>;
};


export type QueryTinkerBoxStatusChangesArgs = {
  range?: InputMaybe<DateRange>;
};


export type QueryTinkerBoxesArgs = {
  labId?: InputMaybe<Scalars['Float']>;
};


export type QueryValueSchemaArgs = {
  where: ValueSchemaWhereUniqueInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export enum Role {
  Admin = 'ADMIN',
  Professor = 'PROFESSOR',
  User = 'USER'
}

export type S3Bucket = {
  __typename?: 'S3Bucket';
  _count: S3BucketCount;
  actions?: Maybe<Array<Action>>;
  bucket: Scalars['String'];
  dataSources?: Maybe<Array<DataSource>>;
  id: Scalars['Int'];
  lab?: Maybe<Array<Lab>>;
  prefix?: Maybe<Scalars['String']>;
  region: Scalars['String'];
};

export type S3BucketCount = {
  __typename?: 'S3BucketCount';
  actions: Scalars['Int'];
  dataSources: Scalars['Int'];
  lab: Scalars['Int'];
};

export type S3BucketCreateNestedOneWithoutActionsInput = {
  connect?: InputMaybe<S3BucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<S3BucketCreateOrConnectWithoutActionsInput>;
  create?: InputMaybe<S3BucketCreateWithoutActionsInput>;
};

export type S3BucketCreateNestedOneWithoutDataSourcesInput = {
  connect?: InputMaybe<S3BucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<S3BucketCreateOrConnectWithoutDataSourcesInput>;
  create?: InputMaybe<S3BucketCreateWithoutDataSourcesInput>;
};

export type S3BucketCreateNestedOneWithoutLabInput = {
  connect?: InputMaybe<S3BucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<S3BucketCreateOrConnectWithoutLabInput>;
  create?: InputMaybe<S3BucketCreateWithoutLabInput>;
};

export type S3BucketCreateOrConnectWithoutActionsInput = {
  create: S3BucketCreateWithoutActionsInput;
  where: S3BucketWhereUniqueInput;
};

export type S3BucketCreateOrConnectWithoutDataSourcesInput = {
  create: S3BucketCreateWithoutDataSourcesInput;
  where: S3BucketWhereUniqueInput;
};

export type S3BucketCreateOrConnectWithoutLabInput = {
  create: S3BucketCreateWithoutLabInput;
  where: S3BucketWhereUniqueInput;
};

export type S3BucketCreateWithoutActionsInput = {
  bucket: Scalars['String'];
  dataSources?: InputMaybe<DataSourceCreateNestedManyWithoutS3BucketInput>;
  lab?: InputMaybe<LabCreateNestedManyWithoutS3BucketInput>;
  prefix?: InputMaybe<Scalars['String']>;
  region: Scalars['String'];
};

export type S3BucketCreateWithoutDataSourcesInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutS3BucketInput>;
  bucket: Scalars['String'];
  lab?: InputMaybe<LabCreateNestedManyWithoutS3BucketInput>;
  prefix?: InputMaybe<Scalars['String']>;
  region: Scalars['String'];
};

export type S3BucketCreateWithoutLabInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutS3BucketInput>;
  bucket: Scalars['String'];
  dataSources?: InputMaybe<DataSourceCreateNestedManyWithoutS3BucketInput>;
  prefix?: InputMaybe<Scalars['String']>;
  region: Scalars['String'];
};

export type S3BucketUpdateOneRequiredWithoutActionsInput = {
  connect?: InputMaybe<S3BucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<S3BucketCreateOrConnectWithoutActionsInput>;
  create?: InputMaybe<S3BucketCreateWithoutActionsInput>;
  update?: InputMaybe<S3BucketUpdateWithoutActionsInput>;
  upsert?: InputMaybe<S3BucketUpsertWithoutActionsInput>;
};

export type S3BucketUpdateOneRequiredWithoutDataSourcesInput = {
  connect?: InputMaybe<S3BucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<S3BucketCreateOrConnectWithoutDataSourcesInput>;
  create?: InputMaybe<S3BucketCreateWithoutDataSourcesInput>;
  update?: InputMaybe<S3BucketUpdateWithoutDataSourcesInput>;
  upsert?: InputMaybe<S3BucketUpsertWithoutDataSourcesInput>;
};

export type S3BucketUpdateOneWithoutLabInput = {
  connect?: InputMaybe<S3BucketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<S3BucketCreateOrConnectWithoutLabInput>;
  create?: InputMaybe<S3BucketCreateWithoutLabInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<S3BucketUpdateWithoutLabInput>;
  upsert?: InputMaybe<S3BucketUpsertWithoutLabInput>;
};

export type S3BucketUpdateWithoutActionsInput = {
  bucket?: InputMaybe<StringFieldUpdateOperationsInput>;
  dataSources?: InputMaybe<DataSourceUpdateManyWithoutS3BucketInput>;
  lab?: InputMaybe<LabUpdateManyWithoutS3BucketInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  region?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type S3BucketUpdateWithoutDataSourcesInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutS3BucketInput>;
  bucket?: InputMaybe<StringFieldUpdateOperationsInput>;
  lab?: InputMaybe<LabUpdateManyWithoutS3BucketInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  region?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type S3BucketUpdateWithoutLabInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutS3BucketInput>;
  bucket?: InputMaybe<StringFieldUpdateOperationsInput>;
  dataSources?: InputMaybe<DataSourceUpdateManyWithoutS3BucketInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  region?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type S3BucketUpsertWithoutActionsInput = {
  create: S3BucketCreateWithoutActionsInput;
  update: S3BucketUpdateWithoutActionsInput;
};

export type S3BucketUpsertWithoutDataSourcesInput = {
  create: S3BucketCreateWithoutDataSourcesInput;
  update: S3BucketUpdateWithoutDataSourcesInput;
};

export type S3BucketUpsertWithoutLabInput = {
  create: S3BucketCreateWithoutLabInput;
  update: S3BucketUpdateWithoutLabInput;
};

export type S3BucketWhereUniqueInput = {
  bucket?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type S3Object = {
  __typename?: 'S3Object';
  bucket: Scalars['String'];
  fullPath: Scalars['String'];
  isFolder: Scalars['Boolean'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type S3ObjectInput = {
  bucket: Scalars['String'];
  fullPath: Scalars['String'];
  isFolder: Scalars['Boolean'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StartAllTinkerBoxesResponse = {
  __typename?: 'StartAllTinkerBoxesResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  analysesUpdated: Array<Analysis>;
  analysisUpdated: Analysis;
  fileTransfersUpdated: Array<FileTransfer>;
  labUpdated: Lab;
  labsUpdated: Lab;
  taskQueueLogs: TaskQueueLogsResponse;
  tinkerBoxUpdated: TinkerBox;
  tinkerBoxesUpdated: Array<TinkerBox>;
};


export type SubscriptionAnalysisUpdatedArgs = {
  id: Scalars['Float'];
};


export type SubscriptionTaskQueueLogsArgs = {
  jobId: Scalars['String'];
};


export type SubscriptionTinkerBoxUpdatedArgs = {
  id: Scalars['Float'];
};


export type SubscriptionTinkerBoxesUpdatedArgs = {
  labId?: InputMaybe<Scalars['Float']>;
};

export type SuccessOrErrors = {
  __typename?: 'SuccessOrErrors';
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type TaskQueueLogsResponse = {
  __typename?: 'TaskQueueLogsResponse';
  message: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type TestActionResponse = {
  __typename?: 'TestActionResponse';
  errors?: Maybe<Array<Scalars['String']>>;
  result?: Maybe<Scalars['String']>;
  testData: TestActionTestData;
};

export type TestActionTestData = {
  __typename?: 'TestActionTestData';
  files: Array<Scalars['String']>;
  folder: Scalars['String'];
};

export type TinkerBox = {
  __typename?: 'TinkerBox';
  _count: TinkerBoxCount;
  autoStop: Scalars['Boolean'];
  availabilityZone?: Maybe<Scalars['String']>;
  checkins?: Maybe<Array<TinkerBoxCheckin>>;
  id: Scalars['Int'];
  instanceId: Scalars['String'];
  ipAddress?: Maybe<Scalars['String']>;
  keyPair: KeyPair;
  keyPairId: Scalars['Int'];
  lab?: Maybe<Lab>;
  labId?: Maybe<Scalars['Int']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  launchedAt: Scalars['DateTime'];
  logins?: Maybe<Array<TinkerBoxSession>>;
  name: Scalars['String'];
  owner?: Maybe<User>;
  sessions: Array<TinkerBoxSession>;
  status: TinkerBoxStatus;
  statusChanges?: Maybe<Array<TinkerBoxStatusChange>>;
  theme?: Maybe<Scalars['JSON']>;
  userId?: Maybe<Scalars['Int']>;
};

export type TinkerBoxCheckin = {
  __typename?: 'TinkerBoxCheckin';
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  tinkerBox: TinkerBox;
  tinkerBoxId: Scalars['Int'];
};

export type TinkerBoxCheckinCreateManyTinkerBoxInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type TinkerBoxCheckinCreateManyTinkerBoxInputEnvelope = {
  data: Array<TinkerBoxCheckinCreateManyTinkerBoxInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TinkerBoxCheckinCreateNestedManyWithoutTinkerBoxInput = {
  connect?: InputMaybe<Array<TinkerBoxCheckinWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxCheckinCreateOrConnectWithoutTinkerBoxInput>>;
  create?: InputMaybe<Array<TinkerBoxCheckinCreateWithoutTinkerBoxInput>>;
  createMany?: InputMaybe<TinkerBoxCheckinCreateManyTinkerBoxInputEnvelope>;
};

export type TinkerBoxCheckinCreateOrConnectWithoutTinkerBoxInput = {
  create: TinkerBoxCheckinCreateWithoutTinkerBoxInput;
  where: TinkerBoxCheckinWhereUniqueInput;
};

export type TinkerBoxCheckinCreateWithoutTinkerBoxInput = {
  date?: InputMaybe<Scalars['DateTime']>;
};

export type TinkerBoxCheckinScalarWhereInput = {
  AND?: InputMaybe<Array<TinkerBoxCheckinScalarWhereInput>>;
  NOT?: InputMaybe<Array<TinkerBoxCheckinScalarWhereInput>>;
  OR?: InputMaybe<Array<TinkerBoxCheckinScalarWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  tinkerBoxId?: InputMaybe<IntFilter>;
};

export type TinkerBoxCheckinUpdateManyMutationInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TinkerBoxCheckinUpdateManyWithWhereWithoutTinkerBoxInput = {
  data: TinkerBoxCheckinUpdateManyMutationInput;
  where: TinkerBoxCheckinScalarWhereInput;
};

export type TinkerBoxCheckinUpdateManyWithoutTinkerBoxInput = {
  connect?: InputMaybe<Array<TinkerBoxCheckinWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxCheckinCreateOrConnectWithoutTinkerBoxInput>>;
  create?: InputMaybe<Array<TinkerBoxCheckinCreateWithoutTinkerBoxInput>>;
  createMany?: InputMaybe<TinkerBoxCheckinCreateManyTinkerBoxInputEnvelope>;
  delete?: InputMaybe<Array<TinkerBoxCheckinWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TinkerBoxCheckinScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TinkerBoxCheckinWhereUniqueInput>>;
  set?: InputMaybe<Array<TinkerBoxCheckinWhereUniqueInput>>;
  update?: InputMaybe<Array<TinkerBoxCheckinUpdateWithWhereUniqueWithoutTinkerBoxInput>>;
  updateMany?: InputMaybe<Array<TinkerBoxCheckinUpdateManyWithWhereWithoutTinkerBoxInput>>;
  upsert?: InputMaybe<Array<TinkerBoxCheckinUpsertWithWhereUniqueWithoutTinkerBoxInput>>;
};

export type TinkerBoxCheckinUpdateWithWhereUniqueWithoutTinkerBoxInput = {
  data: TinkerBoxCheckinUpdateWithoutTinkerBoxInput;
  where: TinkerBoxCheckinWhereUniqueInput;
};

export type TinkerBoxCheckinUpdateWithoutTinkerBoxInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TinkerBoxCheckinUpsertWithWhereUniqueWithoutTinkerBoxInput = {
  create: TinkerBoxCheckinCreateWithoutTinkerBoxInput;
  update: TinkerBoxCheckinUpdateWithoutTinkerBoxInput;
  where: TinkerBoxCheckinWhereUniqueInput;
};

export type TinkerBoxCheckinWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type TinkerBoxCount = {
  __typename?: 'TinkerBoxCount';
  checkins: Scalars['Int'];
  logins: Scalars['Int'];
  statusChanges: Scalars['Int'];
};

export type TinkerBoxCreateManyKeyPairInput = {
  autoStop?: InputMaybe<Scalars['Boolean']>;
  availabilityZone?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  instanceId: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  labId?: InputMaybe<Scalars['Int']>;
  launchedAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxCreateManyKeyPairInputEnvelope = {
  data: Array<TinkerBoxCreateManyKeyPairInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TinkerBoxCreateManyLabInput = {
  autoStop?: InputMaybe<Scalars['Boolean']>;
  availabilityZone?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  instanceId: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  keyPairId: Scalars['Int'];
  launchedAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxCreateManyLabInputEnvelope = {
  data: Array<TinkerBoxCreateManyLabInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TinkerBoxCreateManyOwnerInput = {
  autoStop?: InputMaybe<Scalars['Boolean']>;
  availabilityZone?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  instanceId: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  keyPairId: Scalars['Int'];
  labId?: InputMaybe<Scalars['Int']>;
  launchedAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxCreateManyOwnerInputEnvelope = {
  data: Array<TinkerBoxCreateManyOwnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TinkerBoxCreateNestedManyWithoutKeyPairInput = {
  connect?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxCreateOrConnectWithoutKeyPairInput>>;
  create?: InputMaybe<Array<TinkerBoxCreateWithoutKeyPairInput>>;
  createMany?: InputMaybe<TinkerBoxCreateManyKeyPairInputEnvelope>;
};

export type TinkerBoxCreateNestedManyWithoutLabInput = {
  connect?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxCreateOrConnectWithoutLabInput>>;
  create?: InputMaybe<Array<TinkerBoxCreateWithoutLabInput>>;
  createMany?: InputMaybe<TinkerBoxCreateManyLabInputEnvelope>;
};

export type TinkerBoxCreateNestedManyWithoutOwnerInput = {
  connect?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxCreateOrConnectWithoutOwnerInput>>;
  create?: InputMaybe<Array<TinkerBoxCreateWithoutOwnerInput>>;
  createMany?: InputMaybe<TinkerBoxCreateManyOwnerInputEnvelope>;
};

export type TinkerBoxCreateOrConnectWithoutKeyPairInput = {
  create: TinkerBoxCreateWithoutKeyPairInput;
  where: TinkerBoxWhereUniqueInput;
};

export type TinkerBoxCreateOrConnectWithoutLabInput = {
  create: TinkerBoxCreateWithoutLabInput;
  where: TinkerBoxWhereUniqueInput;
};

export type TinkerBoxCreateOrConnectWithoutOwnerInput = {
  create: TinkerBoxCreateWithoutOwnerInput;
  where: TinkerBoxWhereUniqueInput;
};

export type TinkerBoxCreateWithoutKeyPairInput = {
  autoStop?: InputMaybe<Scalars['Boolean']>;
  availabilityZone?: InputMaybe<Scalars['String']>;
  checkins?: InputMaybe<TinkerBoxCheckinCreateNestedManyWithoutTinkerBoxInput>;
  instanceId: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  lab?: InputMaybe<LabCreateNestedOneWithoutTinkerBoxesInput>;
  launchedAt?: InputMaybe<Scalars['DateTime']>;
  logins?: InputMaybe<TinkerBoxSessionCreateNestedManyWithoutTinkerBoxInput>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<UserCreateNestedOneWithoutTinkerBoxesInput>;
  statusChanges?: InputMaybe<TinkerBoxStatusChangeCreateNestedManyWithoutTinkerBoxInput>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxCreateWithoutLabInput = {
  autoStop?: InputMaybe<Scalars['Boolean']>;
  availabilityZone?: InputMaybe<Scalars['String']>;
  checkins?: InputMaybe<TinkerBoxCheckinCreateNestedManyWithoutTinkerBoxInput>;
  instanceId: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  keyPair: KeyPairCreateNestedOneWithoutTinkerBoxesInput;
  launchedAt?: InputMaybe<Scalars['DateTime']>;
  logins?: InputMaybe<TinkerBoxSessionCreateNestedManyWithoutTinkerBoxInput>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<UserCreateNestedOneWithoutTinkerBoxesInput>;
  statusChanges?: InputMaybe<TinkerBoxStatusChangeCreateNestedManyWithoutTinkerBoxInput>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxCreateWithoutOwnerInput = {
  autoStop?: InputMaybe<Scalars['Boolean']>;
  availabilityZone?: InputMaybe<Scalars['String']>;
  checkins?: InputMaybe<TinkerBoxCheckinCreateNestedManyWithoutTinkerBoxInput>;
  instanceId: Scalars['String'];
  ipAddress?: InputMaybe<Scalars['String']>;
  keyPair: KeyPairCreateNestedOneWithoutTinkerBoxesInput;
  lab?: InputMaybe<LabCreateNestedOneWithoutTinkerBoxesInput>;
  launchedAt?: InputMaybe<Scalars['DateTime']>;
  logins?: InputMaybe<TinkerBoxSessionCreateNestedManyWithoutTinkerBoxInput>;
  name?: InputMaybe<Scalars['String']>;
  statusChanges?: InputMaybe<TinkerBoxStatusChangeCreateNestedManyWithoutTinkerBoxInput>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxScalarWhereInput = {
  AND?: InputMaybe<Array<TinkerBoxScalarWhereInput>>;
  NOT?: InputMaybe<Array<TinkerBoxScalarWhereInput>>;
  OR?: InputMaybe<Array<TinkerBoxScalarWhereInput>>;
  autoStop?: InputMaybe<BoolFilter>;
  availabilityZone?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  instanceId?: InputMaybe<StringFilter>;
  ipAddress?: InputMaybe<StringNullableFilter>;
  keyPairId?: InputMaybe<IntFilter>;
  labId?: InputMaybe<IntNullableFilter>;
  launchedAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringFilter>;
  theme?: InputMaybe<JsonNullableFilter>;
};

export type TinkerBoxSession = {
  __typename?: 'TinkerBoxSession';
  id: Scalars['Int'];
  loginDate: Scalars['DateTime'];
  logoutDate?: Maybe<Scalars['DateTime']>;
  tinkerBox?: Maybe<TinkerBox>;
  tinkerBoxId: Scalars['Int'];
};

export type TinkerBoxSessionCreateManyTinkerBoxInput = {
  id?: InputMaybe<Scalars['Int']>;
  loginDate: Scalars['DateTime'];
  logoutDate?: InputMaybe<Scalars['DateTime']>;
};

export type TinkerBoxSessionCreateManyTinkerBoxInputEnvelope = {
  data: Array<TinkerBoxSessionCreateManyTinkerBoxInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TinkerBoxSessionCreateNestedManyWithoutTinkerBoxInput = {
  connect?: InputMaybe<Array<TinkerBoxSessionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxSessionCreateOrConnectWithoutTinkerBoxInput>>;
  create?: InputMaybe<Array<TinkerBoxSessionCreateWithoutTinkerBoxInput>>;
  createMany?: InputMaybe<TinkerBoxSessionCreateManyTinkerBoxInputEnvelope>;
};

export type TinkerBoxSessionCreateOrConnectWithoutTinkerBoxInput = {
  create: TinkerBoxSessionCreateWithoutTinkerBoxInput;
  where: TinkerBoxSessionWhereUniqueInput;
};

export type TinkerBoxSessionCreateWithoutTinkerBoxInput = {
  loginDate: Scalars['DateTime'];
  logoutDate?: InputMaybe<Scalars['DateTime']>;
};

export type TinkerBoxSessionScalarWhereInput = {
  AND?: InputMaybe<Array<TinkerBoxSessionScalarWhereInput>>;
  NOT?: InputMaybe<Array<TinkerBoxSessionScalarWhereInput>>;
  OR?: InputMaybe<Array<TinkerBoxSessionScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  loginDate?: InputMaybe<DateTimeFilter>;
  logoutDate?: InputMaybe<DateTimeNullableFilter>;
  tinkerBoxId?: InputMaybe<IntFilter>;
};

export type TinkerBoxSessionTinkerBoxIdLoginDateUniqueCompoundUniqueInput = {
  loginDate: Scalars['DateTime'];
  tinkerBoxId: Scalars['Int'];
};

export type TinkerBoxSessionUpdateManyMutationInput = {
  loginDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoutDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TinkerBoxSessionUpdateManyWithWhereWithoutTinkerBoxInput = {
  data: TinkerBoxSessionUpdateManyMutationInput;
  where: TinkerBoxSessionScalarWhereInput;
};

export type TinkerBoxSessionUpdateManyWithoutTinkerBoxInput = {
  connect?: InputMaybe<Array<TinkerBoxSessionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxSessionCreateOrConnectWithoutTinkerBoxInput>>;
  create?: InputMaybe<Array<TinkerBoxSessionCreateWithoutTinkerBoxInput>>;
  createMany?: InputMaybe<TinkerBoxSessionCreateManyTinkerBoxInputEnvelope>;
  delete?: InputMaybe<Array<TinkerBoxSessionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TinkerBoxSessionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TinkerBoxSessionWhereUniqueInput>>;
  set?: InputMaybe<Array<TinkerBoxSessionWhereUniqueInput>>;
  update?: InputMaybe<Array<TinkerBoxSessionUpdateWithWhereUniqueWithoutTinkerBoxInput>>;
  updateMany?: InputMaybe<Array<TinkerBoxSessionUpdateManyWithWhereWithoutTinkerBoxInput>>;
  upsert?: InputMaybe<Array<TinkerBoxSessionUpsertWithWhereUniqueWithoutTinkerBoxInput>>;
};

export type TinkerBoxSessionUpdateWithWhereUniqueWithoutTinkerBoxInput = {
  data: TinkerBoxSessionUpdateWithoutTinkerBoxInput;
  where: TinkerBoxSessionWhereUniqueInput;
};

export type TinkerBoxSessionUpdateWithoutTinkerBoxInput = {
  loginDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoutDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TinkerBoxSessionUpsertWithWhereUniqueWithoutTinkerBoxInput = {
  create: TinkerBoxSessionCreateWithoutTinkerBoxInput;
  update: TinkerBoxSessionUpdateWithoutTinkerBoxInput;
  where: TinkerBoxSessionWhereUniqueInput;
};

export type TinkerBoxSessionWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  tinkerBoxIdLoginDateUnique?: InputMaybe<TinkerBoxSessionTinkerBoxIdLoginDateUniqueCompoundUniqueInput>;
};

export type TinkerBoxStat = {
  __typename?: 'TinkerBoxStat';
  date: Scalars['DateTime'];
  sessions: Array<TinkerBoxSession>;
};

export type TinkerBoxStatsById = {
  __typename?: 'TinkerBoxStatsById';
  sessions: Array<TinkerBoxSession>;
  tinkerBoxId: Scalars['Float'];
};

export enum TinkerBoxStatus {
  Pending = 'pending',
  Running = 'running',
  ShuttingDown = 'shutting_down',
  Stopped = 'stopped',
  Stopping = 'stopping',
  Terminated = 'terminated'
}

export type TinkerBoxStatusChange = {
  __typename?: 'TinkerBoxStatusChange';
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  status: TinkerBoxStatus;
  tinkerBox: TinkerBox;
  tinkerBoxId: Scalars['Int'];
};

export type TinkerBoxStatusChangeCreateManyTinkerBoxInput = {
  date: Scalars['DateTime'];
  id?: InputMaybe<Scalars['Int']>;
  status: TinkerBoxStatus;
};

export type TinkerBoxStatusChangeCreateManyTinkerBoxInputEnvelope = {
  data: Array<TinkerBoxStatusChangeCreateManyTinkerBoxInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TinkerBoxStatusChangeCreateNestedManyWithoutTinkerBoxInput = {
  connect?: InputMaybe<Array<TinkerBoxStatusChangeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxStatusChangeCreateOrConnectWithoutTinkerBoxInput>>;
  create?: InputMaybe<Array<TinkerBoxStatusChangeCreateWithoutTinkerBoxInput>>;
  createMany?: InputMaybe<TinkerBoxStatusChangeCreateManyTinkerBoxInputEnvelope>;
};

export type TinkerBoxStatusChangeCreateOrConnectWithoutTinkerBoxInput = {
  create: TinkerBoxStatusChangeCreateWithoutTinkerBoxInput;
  where: TinkerBoxStatusChangeWhereUniqueInput;
};

export type TinkerBoxStatusChangeCreateWithoutTinkerBoxInput = {
  date: Scalars['DateTime'];
  status: TinkerBoxStatus;
};

export type TinkerBoxStatusChangeScalarWhereInput = {
  AND?: InputMaybe<Array<TinkerBoxStatusChangeScalarWhereInput>>;
  NOT?: InputMaybe<Array<TinkerBoxStatusChangeScalarWhereInput>>;
  OR?: InputMaybe<Array<TinkerBoxStatusChangeScalarWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  status?: InputMaybe<EnumTinkerBoxStatusFilter>;
  tinkerBoxId?: InputMaybe<IntFilter>;
};

export type TinkerBoxStatusChangeTinkerBoxIdDateUniqueCompoundUniqueInput = {
  date: Scalars['DateTime'];
  tinkerBoxId: Scalars['Int'];
};

export type TinkerBoxStatusChangeUpdateManyMutationInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumTinkerBoxStatusFieldUpdateOperationsInput>;
};

export type TinkerBoxStatusChangeUpdateManyWithWhereWithoutTinkerBoxInput = {
  data: TinkerBoxStatusChangeUpdateManyMutationInput;
  where: TinkerBoxStatusChangeScalarWhereInput;
};

export type TinkerBoxStatusChangeUpdateManyWithoutTinkerBoxInput = {
  connect?: InputMaybe<Array<TinkerBoxStatusChangeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxStatusChangeCreateOrConnectWithoutTinkerBoxInput>>;
  create?: InputMaybe<Array<TinkerBoxStatusChangeCreateWithoutTinkerBoxInput>>;
  createMany?: InputMaybe<TinkerBoxStatusChangeCreateManyTinkerBoxInputEnvelope>;
  delete?: InputMaybe<Array<TinkerBoxStatusChangeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TinkerBoxStatusChangeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TinkerBoxStatusChangeWhereUniqueInput>>;
  set?: InputMaybe<Array<TinkerBoxStatusChangeWhereUniqueInput>>;
  update?: InputMaybe<Array<TinkerBoxStatusChangeUpdateWithWhereUniqueWithoutTinkerBoxInput>>;
  updateMany?: InputMaybe<Array<TinkerBoxStatusChangeUpdateManyWithWhereWithoutTinkerBoxInput>>;
  upsert?: InputMaybe<Array<TinkerBoxStatusChangeUpsertWithWhereUniqueWithoutTinkerBoxInput>>;
};

export type TinkerBoxStatusChangeUpdateWithWhereUniqueWithoutTinkerBoxInput = {
  data: TinkerBoxStatusChangeUpdateWithoutTinkerBoxInput;
  where: TinkerBoxStatusChangeWhereUniqueInput;
};

export type TinkerBoxStatusChangeUpdateWithoutTinkerBoxInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumTinkerBoxStatusFieldUpdateOperationsInput>;
};

export type TinkerBoxStatusChangeUpsertWithWhereUniqueWithoutTinkerBoxInput = {
  create: TinkerBoxStatusChangeCreateWithoutTinkerBoxInput;
  update: TinkerBoxStatusChangeUpdateWithoutTinkerBoxInput;
  where: TinkerBoxStatusChangeWhereUniqueInput;
};

export type TinkerBoxStatusChangeWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  tinkerBoxIdDateUnique?: InputMaybe<TinkerBoxStatusChangeTinkerBoxIdDateUniqueCompoundUniqueInput>;
};

export type TinkerBoxStatusChanges = {
  __typename?: 'TinkerBoxStatusChanges';
  statusChanges: Array<TinkerBoxStatusChange>;
  tinkerBoxId: Scalars['Float'];
};

export type TinkerBoxTinkerBoxNameLabIdUniqueCompoundUniqueInput = {
  labId: Scalars['Int'];
  name: Scalars['String'];
};

export type TinkerBoxTinkerBoxNameUserIdUniqueCompoundUniqueInput = {
  name: Scalars['String'];
};

export type TinkerBoxUpdateManyMutationInput = {
  autoStop?: InputMaybe<BoolFieldUpdateOperationsInput>;
  availabilityZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  instanceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  launchedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxUpdateManyWithWhereWithoutKeyPairInput = {
  data: TinkerBoxUpdateManyMutationInput;
  where: TinkerBoxScalarWhereInput;
};

export type TinkerBoxUpdateManyWithWhereWithoutLabInput = {
  data: TinkerBoxUpdateManyMutationInput;
  where: TinkerBoxScalarWhereInput;
};

export type TinkerBoxUpdateManyWithWhereWithoutOwnerInput = {
  data: TinkerBoxUpdateManyMutationInput;
  where: TinkerBoxScalarWhereInput;
};

export type TinkerBoxUpdateManyWithoutKeyPairInput = {
  connect?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxCreateOrConnectWithoutKeyPairInput>>;
  create?: InputMaybe<Array<TinkerBoxCreateWithoutKeyPairInput>>;
  createMany?: InputMaybe<TinkerBoxCreateManyKeyPairInputEnvelope>;
  delete?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TinkerBoxScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  set?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  update?: InputMaybe<Array<TinkerBoxUpdateWithWhereUniqueWithoutKeyPairInput>>;
  updateMany?: InputMaybe<Array<TinkerBoxUpdateManyWithWhereWithoutKeyPairInput>>;
  upsert?: InputMaybe<Array<TinkerBoxUpsertWithWhereUniqueWithoutKeyPairInput>>;
};

export type TinkerBoxUpdateManyWithoutLabInput = {
  connect?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxCreateOrConnectWithoutLabInput>>;
  create?: InputMaybe<Array<TinkerBoxCreateWithoutLabInput>>;
  createMany?: InputMaybe<TinkerBoxCreateManyLabInputEnvelope>;
  delete?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TinkerBoxScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  set?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  update?: InputMaybe<Array<TinkerBoxUpdateWithWhereUniqueWithoutLabInput>>;
  updateMany?: InputMaybe<Array<TinkerBoxUpdateManyWithWhereWithoutLabInput>>;
  upsert?: InputMaybe<Array<TinkerBoxUpsertWithWhereUniqueWithoutLabInput>>;
};

export type TinkerBoxUpdateManyWithoutOwnerInput = {
  connect?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TinkerBoxCreateOrConnectWithoutOwnerInput>>;
  create?: InputMaybe<Array<TinkerBoxCreateWithoutOwnerInput>>;
  createMany?: InputMaybe<TinkerBoxCreateManyOwnerInputEnvelope>;
  delete?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TinkerBoxScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  set?: InputMaybe<Array<TinkerBoxWhereUniqueInput>>;
  update?: InputMaybe<Array<TinkerBoxUpdateWithWhereUniqueWithoutOwnerInput>>;
  updateMany?: InputMaybe<Array<TinkerBoxUpdateManyWithWhereWithoutOwnerInput>>;
  upsert?: InputMaybe<Array<TinkerBoxUpsertWithWhereUniqueWithoutOwnerInput>>;
};

export type TinkerBoxUpdateWithWhereUniqueWithoutKeyPairInput = {
  data: TinkerBoxUpdateWithoutKeyPairInput;
  where: TinkerBoxWhereUniqueInput;
};

export type TinkerBoxUpdateWithWhereUniqueWithoutLabInput = {
  data: TinkerBoxUpdateWithoutLabInput;
  where: TinkerBoxWhereUniqueInput;
};

export type TinkerBoxUpdateWithWhereUniqueWithoutOwnerInput = {
  data: TinkerBoxUpdateWithoutOwnerInput;
  where: TinkerBoxWhereUniqueInput;
};

export type TinkerBoxUpdateWithoutKeyPairInput = {
  autoStop?: InputMaybe<BoolFieldUpdateOperationsInput>;
  availabilityZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  checkins?: InputMaybe<TinkerBoxCheckinUpdateManyWithoutTinkerBoxInput>;
  instanceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lab?: InputMaybe<LabUpdateOneWithoutTinkerBoxesInput>;
  launchedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logins?: InputMaybe<TinkerBoxSessionUpdateManyWithoutTinkerBoxInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<UserUpdateOneWithoutTinkerBoxesInput>;
  statusChanges?: InputMaybe<TinkerBoxStatusChangeUpdateManyWithoutTinkerBoxInput>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxUpdateWithoutLabInput = {
  autoStop?: InputMaybe<BoolFieldUpdateOperationsInput>;
  availabilityZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  checkins?: InputMaybe<TinkerBoxCheckinUpdateManyWithoutTinkerBoxInput>;
  instanceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutTinkerBoxesInput>;
  launchedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logins?: InputMaybe<TinkerBoxSessionUpdateManyWithoutTinkerBoxInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  owner?: InputMaybe<UserUpdateOneWithoutTinkerBoxesInput>;
  statusChanges?: InputMaybe<TinkerBoxStatusChangeUpdateManyWithoutTinkerBoxInput>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxUpdateWithoutOwnerInput = {
  autoStop?: InputMaybe<BoolFieldUpdateOperationsInput>;
  availabilityZone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  checkins?: InputMaybe<TinkerBoxCheckinUpdateManyWithoutTinkerBoxInput>;
  instanceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  ipAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutTinkerBoxesInput>;
  lab?: InputMaybe<LabUpdateOneWithoutTinkerBoxesInput>;
  launchedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logins?: InputMaybe<TinkerBoxSessionUpdateManyWithoutTinkerBoxInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  statusChanges?: InputMaybe<TinkerBoxStatusChangeUpdateManyWithoutTinkerBoxInput>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TinkerBoxUpsertWithWhereUniqueWithoutKeyPairInput = {
  create: TinkerBoxCreateWithoutKeyPairInput;
  update: TinkerBoxUpdateWithoutKeyPairInput;
  where: TinkerBoxWhereUniqueInput;
};

export type TinkerBoxUpsertWithWhereUniqueWithoutLabInput = {
  create: TinkerBoxCreateWithoutLabInput;
  update: TinkerBoxUpdateWithoutLabInput;
  where: TinkerBoxWhereUniqueInput;
};

export type TinkerBoxUpsertWithWhereUniqueWithoutOwnerInput = {
  create: TinkerBoxCreateWithoutOwnerInput;
  update: TinkerBoxUpdateWithoutOwnerInput;
  where: TinkerBoxWhereUniqueInput;
};

export type TinkerBoxWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  instanceId?: InputMaybe<Scalars['String']>;
  tinkerBoxNameLabIdUnique?: InputMaybe<TinkerBoxTinkerBoxNameLabIdUniqueCompoundUniqueInput>;
  tinkerBoxNameUserIdUnique?: InputMaybe<TinkerBoxTinkerBoxNameUserIdUniqueCompoundUniqueInput>;
};

export type UpdateActionResponse = {
  __typename?: 'UpdateActionResponse';
  errors?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateTinkerBoxData = {
  theme: Scalars['JSON'];
};

export type User = {
  __typename?: 'User';
  _count: UserCount;
  actions?: Maybe<Array<Action>>;
  analyses?: Maybe<Array<Analysis>>;
  awsUsername: Scalars['String'];
  chats?: Maybe<Array<Chat>>;
  cloudFormationStack?: Maybe<CloudFormationStack>;
  cloudFormationStackId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  dataSourceSubscriptions?: Maybe<Array<DataSourceSubscription>>;
  email: Scalars['String'];
  featureFlags?: Maybe<Array<UserFeatureFlag>>;
  fileTransfers?: Maybe<Array<FileTransfer>>;
  firstname: Scalars['String'];
  id: Scalars['Int'];
  keyPair: KeyPair;
  keyPairId: Scalars['Int'];
  labMembers?: Maybe<Array<LabMember>>;
  lastname: Scalars['String'];
  roles?: Maybe<Array<UserRole>>;
  tinkerBoxes?: Maybe<Array<TinkerBox>>;
};

export type UserCount = {
  __typename?: 'UserCount';
  actions: Scalars['Int'];
  analyses: Scalars['Int'];
  chats: Scalars['Int'];
  dataSourceSubscriptions: Scalars['Int'];
  featureFlags: Scalars['Int'];
  fileTransfers: Scalars['Int'];
  labMembers: Scalars['Int'];
  roles: Scalars['Int'];
  tinkerBoxes: Scalars['Int'];
};

export type UserCreateManyCloudFormationStackInput = {
  awsUsername: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  keyPairId: Scalars['Int'];
  lastname: Scalars['String'];
  password: Scalars['String'];
};

export type UserCreateManyCloudFormationStackInputEnvelope = {
  data: Array<UserCreateManyCloudFormationStackInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserCreateNestedManyWithoutCloudFormationStackInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutCloudFormationStackInput>>;
  create?: InputMaybe<Array<UserCreateWithoutCloudFormationStackInput>>;
  createMany?: InputMaybe<UserCreateManyCloudFormationStackInputEnvelope>;
};

export type UserCreateNestedOneWithoutActionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutActionsInput>;
  create?: InputMaybe<UserCreateWithoutActionsInput>;
};

export type UserCreateNestedOneWithoutAnalysesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAnalysesInput>;
  create?: InputMaybe<UserCreateWithoutAnalysesInput>;
};

export type UserCreateNestedOneWithoutChatsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutChatsInput>;
  create?: InputMaybe<UserCreateWithoutChatsInput>;
};

export type UserCreateNestedOneWithoutDataSourceSubscriptionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDataSourceSubscriptionsInput>;
  create?: InputMaybe<UserCreateWithoutDataSourceSubscriptionsInput>;
};

export type UserCreateNestedOneWithoutKeyPairInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutKeyPairInput>;
  create?: InputMaybe<UserCreateWithoutKeyPairInput>;
};

export type UserCreateNestedOneWithoutLabMembersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLabMembersInput>;
  create?: InputMaybe<UserCreateWithoutLabMembersInput>;
};

export type UserCreateNestedOneWithoutTinkerBoxesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTinkerBoxesInput>;
  create?: InputMaybe<UserCreateWithoutTinkerBoxesInput>;
};

export type UserCreateOrConnectWithoutActionsInput = {
  create: UserCreateWithoutActionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutAnalysesInput = {
  create: UserCreateWithoutAnalysesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutChatsInput = {
  create: UserCreateWithoutChatsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCloudFormationStackInput = {
  create: UserCreateWithoutCloudFormationStackInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutDataSourceSubscriptionsInput = {
  create: UserCreateWithoutDataSourceSubscriptionsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutKeyPairInput = {
  create: UserCreateWithoutKeyPairInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutLabMembersInput = {
  create: UserCreateWithoutLabMembersInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutTinkerBoxesInput = {
  create: UserCreateWithoutTinkerBoxesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutActionsInput = {
  analyses?: InputMaybe<AnalysisCreateNestedManyWithoutCreatorInput>;
  awsUsername: Scalars['String'];
  chats?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  featureFlags?: InputMaybe<UserFeatureFlagCreateNestedManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferCreateNestedManyWithoutUserInput>;
  firstname: Scalars['String'];
  keyPair: KeyPairCreateNestedOneWithoutUserInput;
  labMembers?: InputMaybe<LabMemberCreateNestedManyWithoutUserInput>;
  lastname: Scalars['String'];
  password: Scalars['String'];
  roles?: InputMaybe<UserRoleCreateNestedManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutOwnerInput>;
};

export type UserCreateWithoutAnalysesInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutCreatorInput>;
  awsUsername: Scalars['String'];
  chats?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  featureFlags?: InputMaybe<UserFeatureFlagCreateNestedManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferCreateNestedManyWithoutUserInput>;
  firstname: Scalars['String'];
  keyPair: KeyPairCreateNestedOneWithoutUserInput;
  labMembers?: InputMaybe<LabMemberCreateNestedManyWithoutUserInput>;
  lastname: Scalars['String'];
  password: Scalars['String'];
  roles?: InputMaybe<UserRoleCreateNestedManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutOwnerInput>;
};

export type UserCreateWithoutChatsInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisCreateNestedManyWithoutCreatorInput>;
  awsUsername: Scalars['String'];
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  featureFlags?: InputMaybe<UserFeatureFlagCreateNestedManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferCreateNestedManyWithoutUserInput>;
  firstname: Scalars['String'];
  keyPair: KeyPairCreateNestedOneWithoutUserInput;
  labMembers?: InputMaybe<LabMemberCreateNestedManyWithoutUserInput>;
  lastname: Scalars['String'];
  password: Scalars['String'];
  roles?: InputMaybe<UserRoleCreateNestedManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutOwnerInput>;
};

export type UserCreateWithoutCloudFormationStackInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisCreateNestedManyWithoutCreatorInput>;
  awsUsername: Scalars['String'];
  chats?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  featureFlags?: InputMaybe<UserFeatureFlagCreateNestedManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferCreateNestedManyWithoutUserInput>;
  firstname: Scalars['String'];
  keyPair: KeyPairCreateNestedOneWithoutUserInput;
  labMembers?: InputMaybe<LabMemberCreateNestedManyWithoutUserInput>;
  lastname: Scalars['String'];
  password: Scalars['String'];
  roles?: InputMaybe<UserRoleCreateNestedManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutOwnerInput>;
};

export type UserCreateWithoutDataSourceSubscriptionsInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisCreateNestedManyWithoutCreatorInput>;
  awsUsername: Scalars['String'];
  chats?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  featureFlags?: InputMaybe<UserFeatureFlagCreateNestedManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferCreateNestedManyWithoutUserInput>;
  firstname: Scalars['String'];
  keyPair: KeyPairCreateNestedOneWithoutUserInput;
  labMembers?: InputMaybe<LabMemberCreateNestedManyWithoutUserInput>;
  lastname: Scalars['String'];
  password: Scalars['String'];
  roles?: InputMaybe<UserRoleCreateNestedManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutOwnerInput>;
};

export type UserCreateWithoutKeyPairInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisCreateNestedManyWithoutCreatorInput>;
  awsUsername: Scalars['String'];
  chats?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  featureFlags?: InputMaybe<UserFeatureFlagCreateNestedManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferCreateNestedManyWithoutUserInput>;
  firstname: Scalars['String'];
  labMembers?: InputMaybe<LabMemberCreateNestedManyWithoutUserInput>;
  lastname: Scalars['String'];
  password: Scalars['String'];
  roles?: InputMaybe<UserRoleCreateNestedManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutOwnerInput>;
};

export type UserCreateWithoutLabMembersInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisCreateNestedManyWithoutCreatorInput>;
  awsUsername: Scalars['String'];
  chats?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  featureFlags?: InputMaybe<UserFeatureFlagCreateNestedManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferCreateNestedManyWithoutUserInput>;
  firstname: Scalars['String'];
  keyPair: KeyPairCreateNestedOneWithoutUserInput;
  lastname: Scalars['String'];
  password: Scalars['String'];
  roles?: InputMaybe<UserRoleCreateNestedManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxCreateNestedManyWithoutOwnerInput>;
};

export type UserCreateWithoutTinkerBoxesInput = {
  actions?: InputMaybe<ActionCreateNestedManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisCreateNestedManyWithoutCreatorInput>;
  awsUsername: Scalars['String'];
  chats?: InputMaybe<ChatCreateNestedManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackCreateNestedOneWithoutUsersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  featureFlags?: InputMaybe<UserFeatureFlagCreateNestedManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferCreateNestedManyWithoutUserInput>;
  firstname: Scalars['String'];
  keyPair: KeyPairCreateNestedOneWithoutUserInput;
  labMembers?: InputMaybe<LabMemberCreateNestedManyWithoutUserInput>;
  lastname: Scalars['String'];
  password: Scalars['String'];
  roles?: InputMaybe<UserRoleCreateNestedManyWithoutUserInput>;
};

export type UserFeatureFlag = {
  __typename?: 'UserFeatureFlag';
  featureFlag: FeatureFlag;
  featureFlagId: Scalars['Int'];
  id: Scalars['Int'];
  user: User;
  userId: Scalars['Int'];
};

export type UserFeatureFlagCreateManyUserInput = {
  featureFlagId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
};

export type UserFeatureFlagCreateManyUserInputEnvelope = {
  data: Array<UserFeatureFlagCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserFeatureFlagCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserFeatureFlagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserFeatureFlagCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserFeatureFlagCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserFeatureFlagCreateManyUserInputEnvelope>;
};

export type UserFeatureFlagCreateOrConnectWithoutUserInput = {
  create: UserFeatureFlagCreateWithoutUserInput;
  where: UserFeatureFlagWhereUniqueInput;
};

export type UserFeatureFlagCreateWithoutUserInput = {
  featureFlag: FeatureFlagCreateNestedOneWithoutUsersInput;
};

export type UserFeatureFlagScalarWhereInput = {
  AND?: InputMaybe<Array<UserFeatureFlagScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserFeatureFlagScalarWhereInput>>;
  OR?: InputMaybe<Array<UserFeatureFlagScalarWhereInput>>;
  featureFlagId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserFeatureFlagUncheckedUpdateManyWithoutFeatureFlagsInput = {
  featureFlagId?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type UserFeatureFlagUpdateManyWithWhereWithoutUserInput = {
  data: UserFeatureFlagUncheckedUpdateManyWithoutFeatureFlagsInput;
  where: UserFeatureFlagScalarWhereInput;
};

export type UserFeatureFlagUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserFeatureFlagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserFeatureFlagCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserFeatureFlagCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserFeatureFlagCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserFeatureFlagWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserFeatureFlagScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserFeatureFlagWhereUniqueInput>>;
  set?: InputMaybe<Array<UserFeatureFlagWhereUniqueInput>>;
  update?: InputMaybe<Array<UserFeatureFlagUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserFeatureFlagUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserFeatureFlagUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserFeatureFlagUpdateWithWhereUniqueWithoutUserInput = {
  data: UserFeatureFlagUpdateWithoutUserInput;
  where: UserFeatureFlagWhereUniqueInput;
};

export type UserFeatureFlagUpdateWithoutUserInput = {
  featureFlag?: InputMaybe<FeatureFlagUpdateOneRequiredWithoutUsersInput>;
};

export type UserFeatureFlagUpsertWithWhereUniqueWithoutUserInput = {
  create: UserFeatureFlagCreateWithoutUserInput;
  update: UserFeatureFlagUpdateWithoutUserInput;
  where: UserFeatureFlagWhereUniqueInput;
};

export type UserFeatureFlagWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  id: Scalars['Int'];
  role: Role;
  user: User;
  userId: Scalars['Int'];
};

export type UserRoleCreateManyUserInput = {
  id?: InputMaybe<Scalars['Int']>;
  role: Role;
};

export type UserRoleCreateManyUserInputEnvelope = {
  data: Array<UserRoleCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserRoleCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserRoleCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserRoleCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserRoleCreateManyUserInputEnvelope>;
};

export type UserRoleCreateOrConnectWithoutUserInput = {
  create: UserRoleCreateWithoutUserInput;
  where: UserRoleWhereUniqueInput;
};

export type UserRoleCreateWithoutUserInput = {
  role: Role;
};

export type UserRoleScalarWhereInput = {
  AND?: InputMaybe<Array<UserRoleScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserRoleScalarWhereInput>>;
  OR?: InputMaybe<Array<UserRoleScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  userId?: InputMaybe<IntFilter>;
};

export type UserRoleUpdateManyMutationInput = {
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
};

export type UserRoleUpdateManyWithWhereWithoutUserInput = {
  data: UserRoleUpdateManyMutationInput;
  where: UserRoleScalarWhereInput;
};

export type UserRoleUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserRoleCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserRoleCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserRoleCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserRoleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserRoleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserRoleWhereUniqueInput>>;
  set?: InputMaybe<Array<UserRoleWhereUniqueInput>>;
  update?: InputMaybe<Array<UserRoleUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserRoleUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserRoleUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserRoleUpdateWithWhereUniqueWithoutUserInput = {
  data: UserRoleUpdateWithoutUserInput;
  where: UserRoleWhereUniqueInput;
};

export type UserRoleUpdateWithoutUserInput = {
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
};

export type UserRoleUpsertWithWhereUniqueWithoutUserInput = {
  create: UserRoleCreateWithoutUserInput;
  update: UserRoleUpdateWithoutUserInput;
  where: UserRoleWhereUniqueInput;
};

export type UserRoleWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  awsUsername?: InputMaybe<StringFilter>;
  cloudFormationStackId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  keyPairId?: InputMaybe<IntFilter>;
  lastname?: InputMaybe<StringFilter>;
  password?: InputMaybe<StringFilter>;
};

export type UserUpdateManyMutationInput = {
  awsUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithWhereWithoutCloudFormationStackInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutCloudFormationStackInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutCloudFormationStackInput>>;
  create?: InputMaybe<Array<UserCreateWithoutCloudFormationStackInput>>;
  createMany?: InputMaybe<UserCreateManyCloudFormationStackInputEnvelope>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutCloudFormationStackInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutCloudFormationStackInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutCloudFormationStackInput>>;
};

export type UserUpdateOneRequiredWithoutActionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutActionsInput>;
  create?: InputMaybe<UserCreateWithoutActionsInput>;
  update?: InputMaybe<UserUpdateWithoutActionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutActionsInput>;
};

export type UserUpdateOneRequiredWithoutAnalysesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAnalysesInput>;
  create?: InputMaybe<UserCreateWithoutAnalysesInput>;
  update?: InputMaybe<UserUpdateWithoutAnalysesInput>;
  upsert?: InputMaybe<UserUpsertWithoutAnalysesInput>;
};

export type UserUpdateOneRequiredWithoutChatsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutChatsInput>;
  create?: InputMaybe<UserCreateWithoutChatsInput>;
  update?: InputMaybe<UserUpdateWithoutChatsInput>;
  upsert?: InputMaybe<UserUpsertWithoutChatsInput>;
};

export type UserUpdateOneRequiredWithoutDataSourceSubscriptionsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDataSourceSubscriptionsInput>;
  create?: InputMaybe<UserCreateWithoutDataSourceSubscriptionsInput>;
  update?: InputMaybe<UserUpdateWithoutDataSourceSubscriptionsInput>;
  upsert?: InputMaybe<UserUpsertWithoutDataSourceSubscriptionsInput>;
};

export type UserUpdateOneRequiredWithoutLabMembersInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLabMembersInput>;
  create?: InputMaybe<UserCreateWithoutLabMembersInput>;
  update?: InputMaybe<UserUpdateWithoutLabMembersInput>;
  upsert?: InputMaybe<UserUpsertWithoutLabMembersInput>;
};

export type UserUpdateOneWithoutKeyPairInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutKeyPairInput>;
  create?: InputMaybe<UserCreateWithoutKeyPairInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateWithoutKeyPairInput>;
  upsert?: InputMaybe<UserUpsertWithoutKeyPairInput>;
};

export type UserUpdateOneWithoutTinkerBoxesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutTinkerBoxesInput>;
  create?: InputMaybe<UserCreateWithoutTinkerBoxesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateWithoutTinkerBoxesInput>;
  upsert?: InputMaybe<UserUpsertWithoutTinkerBoxesInput>;
};

export type UserUpdateWithWhereUniqueWithoutCloudFormationStackInput = {
  data: UserUpdateWithoutCloudFormationStackInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutActionsInput = {
  analyses?: InputMaybe<AnalysisUpdateManyWithoutCreatorInput>;
  awsUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  chats?: InputMaybe<ChatUpdateManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutUsersInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionUpdateManyWithoutUserInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  featureFlags?: InputMaybe<UserFeatureFlagUpdateManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferUpdateManyWithoutUserInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutUserInput>;
  labMembers?: InputMaybe<LabMemberUpdateManyWithoutUserInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  roles?: InputMaybe<UserRoleUpdateManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutOwnerInput>;
};

export type UserUpdateWithoutAnalysesInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutCreatorInput>;
  awsUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  chats?: InputMaybe<ChatUpdateManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutUsersInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionUpdateManyWithoutUserInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  featureFlags?: InputMaybe<UserFeatureFlagUpdateManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferUpdateManyWithoutUserInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutUserInput>;
  labMembers?: InputMaybe<LabMemberUpdateManyWithoutUserInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  roles?: InputMaybe<UserRoleUpdateManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutOwnerInput>;
};

export type UserUpdateWithoutChatsInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisUpdateManyWithoutCreatorInput>;
  awsUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutUsersInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionUpdateManyWithoutUserInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  featureFlags?: InputMaybe<UserFeatureFlagUpdateManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferUpdateManyWithoutUserInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutUserInput>;
  labMembers?: InputMaybe<LabMemberUpdateManyWithoutUserInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  roles?: InputMaybe<UserRoleUpdateManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutOwnerInput>;
};

export type UserUpdateWithoutCloudFormationStackInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisUpdateManyWithoutCreatorInput>;
  awsUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  chats?: InputMaybe<ChatUpdateManyWithoutUserInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionUpdateManyWithoutUserInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  featureFlags?: InputMaybe<UserFeatureFlagUpdateManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferUpdateManyWithoutUserInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutUserInput>;
  labMembers?: InputMaybe<LabMemberUpdateManyWithoutUserInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  roles?: InputMaybe<UserRoleUpdateManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutOwnerInput>;
};

export type UserUpdateWithoutDataSourceSubscriptionsInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisUpdateManyWithoutCreatorInput>;
  awsUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  chats?: InputMaybe<ChatUpdateManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutUsersInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  featureFlags?: InputMaybe<UserFeatureFlagUpdateManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferUpdateManyWithoutUserInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutUserInput>;
  labMembers?: InputMaybe<LabMemberUpdateManyWithoutUserInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  roles?: InputMaybe<UserRoleUpdateManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutOwnerInput>;
};

export type UserUpdateWithoutKeyPairInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisUpdateManyWithoutCreatorInput>;
  awsUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  chats?: InputMaybe<ChatUpdateManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutUsersInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionUpdateManyWithoutUserInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  featureFlags?: InputMaybe<UserFeatureFlagUpdateManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferUpdateManyWithoutUserInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  labMembers?: InputMaybe<LabMemberUpdateManyWithoutUserInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  roles?: InputMaybe<UserRoleUpdateManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutOwnerInput>;
};

export type UserUpdateWithoutLabMembersInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisUpdateManyWithoutCreatorInput>;
  awsUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  chats?: InputMaybe<ChatUpdateManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutUsersInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionUpdateManyWithoutUserInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  featureFlags?: InputMaybe<UserFeatureFlagUpdateManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferUpdateManyWithoutUserInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutUserInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  roles?: InputMaybe<UserRoleUpdateManyWithoutUserInput>;
  tinkerBoxes?: InputMaybe<TinkerBoxUpdateManyWithoutOwnerInput>;
};

export type UserUpdateWithoutTinkerBoxesInput = {
  actions?: InputMaybe<ActionUpdateManyWithoutCreatorInput>;
  analyses?: InputMaybe<AnalysisUpdateManyWithoutCreatorInput>;
  awsUsername?: InputMaybe<StringFieldUpdateOperationsInput>;
  chats?: InputMaybe<ChatUpdateManyWithoutUserInput>;
  cloudFormationStack?: InputMaybe<CloudFormationStackUpdateOneWithoutUsersInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dataSourceSubscriptions?: InputMaybe<DataSourceSubscriptionUpdateManyWithoutUserInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  featureFlags?: InputMaybe<UserFeatureFlagUpdateManyWithoutUserInput>;
  fileTransfers?: InputMaybe<FileTransferUpdateManyWithoutUserInput>;
  firstname?: InputMaybe<StringFieldUpdateOperationsInput>;
  keyPair?: InputMaybe<KeyPairUpdateOneRequiredWithoutUserInput>;
  labMembers?: InputMaybe<LabMemberUpdateManyWithoutUserInput>;
  lastname?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  roles?: InputMaybe<UserRoleUpdateManyWithoutUserInput>;
};

export type UserUpsertWithWhereUniqueWithoutCloudFormationStackInput = {
  create: UserCreateWithoutCloudFormationStackInput;
  update: UserUpdateWithoutCloudFormationStackInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutActionsInput = {
  create: UserCreateWithoutActionsInput;
  update: UserUpdateWithoutActionsInput;
};

export type UserUpsertWithoutAnalysesInput = {
  create: UserCreateWithoutAnalysesInput;
  update: UserUpdateWithoutAnalysesInput;
};

export type UserUpsertWithoutChatsInput = {
  create: UserCreateWithoutChatsInput;
  update: UserUpdateWithoutChatsInput;
};

export type UserUpsertWithoutDataSourceSubscriptionsInput = {
  create: UserCreateWithoutDataSourceSubscriptionsInput;
  update: UserUpdateWithoutDataSourceSubscriptionsInput;
};

export type UserUpsertWithoutKeyPairInput = {
  create: UserCreateWithoutKeyPairInput;
  update: UserUpdateWithoutKeyPairInput;
};

export type UserUpsertWithoutLabMembersInput = {
  create: UserCreateWithoutLabMembersInput;
  update: UserUpdateWithoutLabMembersInput;
};

export type UserUpsertWithoutTinkerBoxesInput = {
  create: UserCreateWithoutTinkerBoxesInput;
  update: UserUpdateWithoutTinkerBoxesInput;
};

export type UserWhereUniqueInput = {
  awsUsername?: InputMaybe<Scalars['String']>;
  cloudFormationStackId?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  keyPairId?: InputMaybe<Scalars['Int']>;
};

export type ValueSchema = {
  __typename?: 'ValueSchema';
  _count: ValueSchemaCount;
  analysisSchemaOutput?: Maybe<Array<AnalysisSchemaOutput>>;
  analysisValueInput?: Maybe<Array<AnalysisSchemaInput>>;
  id: Scalars['Int'];
  name: Scalars['String'];
  schema: Scalars['JSON'];
};

export type ValueSchemaCount = {
  __typename?: 'ValueSchemaCount';
  analysisSchemaOutput: Scalars['Int'];
  analysisValueInput: Scalars['Int'];
};

export type ValueSchemaCreateInput = {
  analysisSchemaOutput?: InputMaybe<AnalysisSchemaOutputCreateNestedManyWithoutValueSchemaInput>;
  analysisValueInput?: InputMaybe<AnalysisSchemaInputCreateNestedManyWithoutValueSchemaInput>;
  name: Scalars['String'];
  schema: Scalars['JSON'];
};

export type ValueSchemaCreateNestedOneWithoutAnalysisSchemaOutputInput = {
  connect?: InputMaybe<ValueSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ValueSchemaCreateOrConnectWithoutAnalysisSchemaOutputInput>;
  create?: InputMaybe<ValueSchemaCreateWithoutAnalysisSchemaOutputInput>;
};

export type ValueSchemaCreateNestedOneWithoutAnalysisValueInputInput = {
  connect?: InputMaybe<ValueSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ValueSchemaCreateOrConnectWithoutAnalysisValueInputInput>;
  create?: InputMaybe<ValueSchemaCreateWithoutAnalysisValueInputInput>;
};

export type ValueSchemaCreateOrConnectWithoutAnalysisSchemaOutputInput = {
  create: ValueSchemaCreateWithoutAnalysisSchemaOutputInput;
  where: ValueSchemaWhereUniqueInput;
};

export type ValueSchemaCreateOrConnectWithoutAnalysisValueInputInput = {
  create: ValueSchemaCreateWithoutAnalysisValueInputInput;
  where: ValueSchemaWhereUniqueInput;
};

export type ValueSchemaCreateWithoutAnalysisSchemaOutputInput = {
  analysisValueInput?: InputMaybe<AnalysisSchemaInputCreateNestedManyWithoutValueSchemaInput>;
  name: Scalars['String'];
  schema: Scalars['JSON'];
};

export type ValueSchemaCreateWithoutAnalysisValueInputInput = {
  analysisSchemaOutput?: InputMaybe<AnalysisSchemaOutputCreateNestedManyWithoutValueSchemaInput>;
  name: Scalars['String'];
  schema: Scalars['JSON'];
};

export type ValueSchemaUpdateInput = {
  analysisSchemaOutput?: InputMaybe<AnalysisSchemaOutputUpdateManyWithoutValueSchemaInput>;
  analysisValueInput?: InputMaybe<AnalysisSchemaInputUpdateManyWithoutValueSchemaInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  schema?: InputMaybe<Scalars['JSON']>;
};

export type ValueSchemaUpdateOneRequiredWithoutAnalysisSchemaOutputInput = {
  connect?: InputMaybe<ValueSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ValueSchemaCreateOrConnectWithoutAnalysisSchemaOutputInput>;
  create?: InputMaybe<ValueSchemaCreateWithoutAnalysisSchemaOutputInput>;
  update?: InputMaybe<ValueSchemaUpdateWithoutAnalysisSchemaOutputInput>;
  upsert?: InputMaybe<ValueSchemaUpsertWithoutAnalysisSchemaOutputInput>;
};

export type ValueSchemaUpdateOneRequiredWithoutAnalysisValueInputInput = {
  connect?: InputMaybe<ValueSchemaWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ValueSchemaCreateOrConnectWithoutAnalysisValueInputInput>;
  create?: InputMaybe<ValueSchemaCreateWithoutAnalysisValueInputInput>;
  update?: InputMaybe<ValueSchemaUpdateWithoutAnalysisValueInputInput>;
  upsert?: InputMaybe<ValueSchemaUpsertWithoutAnalysisValueInputInput>;
};

export type ValueSchemaUpdateWithoutAnalysisSchemaOutputInput = {
  analysisValueInput?: InputMaybe<AnalysisSchemaInputUpdateManyWithoutValueSchemaInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  schema?: InputMaybe<Scalars['JSON']>;
};

export type ValueSchemaUpdateWithoutAnalysisValueInputInput = {
  analysisSchemaOutput?: InputMaybe<AnalysisSchemaOutputUpdateManyWithoutValueSchemaInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  schema?: InputMaybe<Scalars['JSON']>;
};

export type ValueSchemaUpsertWithoutAnalysisSchemaOutputInput = {
  create: ValueSchemaCreateWithoutAnalysisSchemaOutputInput;
  update: ValueSchemaUpdateWithoutAnalysisSchemaOutputInput;
};

export type ValueSchemaUpsertWithoutAnalysisValueInputInput = {
  create: ValueSchemaCreateWithoutAnalysisValueInputInput;
  update: ValueSchemaUpdateWithoutAnalysisValueInputInput;
};

export type ValueSchemaWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateCliTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCliTokenMutation = { __typename?: 'Mutation', createCliToken: { __typename?: 'CreateCliTokenResponse', token: string } };

export type LoginOneTimePasswordMutationVariables = Exact<{
  otp: Scalars['String'];
}>;


export type LoginOneTimePasswordMutation = { __typename?: 'Mutation', loginOneTimePassword: { __typename?: 'LoginResponse', success?: boolean | null, errors?: Array<string> | null } };

export type LoginUsernamePasswordMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginUsernamePasswordMutation = { __typename?: 'Mutation', loginUsernamePassword: { __typename?: 'LoginResponse', errors?: Array<string> | null, success?: boolean | null } };

export type SendOneTimePasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendOneTimePasswordMutation = { __typename?: 'Mutation', sendOneTimePassword: boolean };


export const CreateCliTokenDocument = gql`
    mutation CreateCliToken {
  createCliToken {
    token
  }
}
    `;
export type CreateCliTokenMutationFn = Apollo.MutationFunction<CreateCliTokenMutation, CreateCliTokenMutationVariables>;

/**
 * __useCreateCliTokenMutation__
 *
 * To run a mutation, you first call `useCreateCliTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCliTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCliTokenMutation, { data, loading, error }] = useCreateCliTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateCliTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateCliTokenMutation, CreateCliTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCliTokenMutation, CreateCliTokenMutationVariables>(CreateCliTokenDocument, options);
      }
export type CreateCliTokenMutationHookResult = ReturnType<typeof useCreateCliTokenMutation>;
export type CreateCliTokenMutationResult = Apollo.MutationResult<CreateCliTokenMutation>;
export type CreateCliTokenMutationOptions = Apollo.BaseMutationOptions<CreateCliTokenMutation, CreateCliTokenMutationVariables>;
export const LoginOneTimePasswordDocument = gql`
    mutation LoginOneTimePassword($otp: String!) {
  loginOneTimePassword(otp: $otp) {
    success
    errors
  }
}
    `;
export type LoginOneTimePasswordMutationFn = Apollo.MutationFunction<LoginOneTimePasswordMutation, LoginOneTimePasswordMutationVariables>;

/**
 * __useLoginOneTimePasswordMutation__
 *
 * To run a mutation, you first call `useLoginOneTimePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginOneTimePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginOneTimePasswordMutation, { data, loading, error }] = useLoginOneTimePasswordMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useLoginOneTimePasswordMutation(baseOptions?: Apollo.MutationHookOptions<LoginOneTimePasswordMutation, LoginOneTimePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginOneTimePasswordMutation, LoginOneTimePasswordMutationVariables>(LoginOneTimePasswordDocument, options);
      }
export type LoginOneTimePasswordMutationHookResult = ReturnType<typeof useLoginOneTimePasswordMutation>;
export type LoginOneTimePasswordMutationResult = Apollo.MutationResult<LoginOneTimePasswordMutation>;
export type LoginOneTimePasswordMutationOptions = Apollo.BaseMutationOptions<LoginOneTimePasswordMutation, LoginOneTimePasswordMutationVariables>;
export const LoginUsernamePasswordDocument = gql`
    mutation LoginUsernamePassword($email: String!, $password: String!) {
  loginUsernamePassword(email: $email, password: $password) {
    errors
    success
  }
}
    `;
export type LoginUsernamePasswordMutationFn = Apollo.MutationFunction<LoginUsernamePasswordMutation, LoginUsernamePasswordMutationVariables>;

/**
 * __useLoginUsernamePasswordMutation__
 *
 * To run a mutation, you first call `useLoginUsernamePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUsernamePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUsernamePasswordMutation, { data, loading, error }] = useLoginUsernamePasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUsernamePasswordMutation(baseOptions?: Apollo.MutationHookOptions<LoginUsernamePasswordMutation, LoginUsernamePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUsernamePasswordMutation, LoginUsernamePasswordMutationVariables>(LoginUsernamePasswordDocument, options);
      }
export type LoginUsernamePasswordMutationHookResult = ReturnType<typeof useLoginUsernamePasswordMutation>;
export type LoginUsernamePasswordMutationResult = Apollo.MutationResult<LoginUsernamePasswordMutation>;
export type LoginUsernamePasswordMutationOptions = Apollo.BaseMutationOptions<LoginUsernamePasswordMutation, LoginUsernamePasswordMutationVariables>;
export const SendOneTimePasswordDocument = gql`
    mutation SendOneTimePassword($email: String!) {
  sendOneTimePassword(email: $email)
}
    `;
export type SendOneTimePasswordMutationFn = Apollo.MutationFunction<SendOneTimePasswordMutation, SendOneTimePasswordMutationVariables>;

/**
 * __useSendOneTimePasswordMutation__
 *
 * To run a mutation, you first call `useSendOneTimePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOneTimePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOneTimePasswordMutation, { data, loading, error }] = useSendOneTimePasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendOneTimePasswordMutation(baseOptions?: Apollo.MutationHookOptions<SendOneTimePasswordMutation, SendOneTimePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOneTimePasswordMutation, SendOneTimePasswordMutationVariables>(SendOneTimePasswordDocument, options);
      }
export type SendOneTimePasswordMutationHookResult = ReturnType<typeof useSendOneTimePasswordMutation>;
export type SendOneTimePasswordMutationResult = Apollo.MutationResult<SendOneTimePasswordMutation>;
export type SendOneTimePasswordMutationOptions = Apollo.BaseMutationOptions<SendOneTimePasswordMutation, SendOneTimePasswordMutationVariables>;